"use strict";

// Start namespace
var pyzel = {};

// Shop Scripts
$(function(){
	$(document).on('click', '.cplqs_minus, .cplqs_plus', function(e){
		e.preventDefault();
		var t = $(this);
		var isQtdReadOnly = t.closest('.cpl_quantityselect').hasClass('qtdreadonly_true');
		
		
		if(!isQtdReadOnly){
			var product = t.closest('.cartproduct');
			var action = t.attr('data-action');
			var input = t.closest('.cpl_quantityselect').find('.cplqs_value input');
			var value = Number(input.val());
	
			var id_product = Number(product.attr('data-id_product'));
			var id_producttype = Number(product.attr('data-id_producttype'));
			var id_variant = product.attr('data-id_variant');
			var qty = 1;
	console.log( action );
			if(action=='less'){
				if(value>0){
					value--;
					service_DeleteFromCart(id_product, id_producttype, id_variant, qty, t);
				}
			} else {
				value++;
				service_AddToCart(id_product, id_producttype, id_variant, qty, t);
			}
			input.val(value);
		}
		
	});
	



	




	$(document).on('change', '.shipbillingaddresscheck input', function(){

        /*
		var t = $(this);
		var state = t.prop('checked');
		if(state==false){
			var baHeight = $('.billing_address_inner').height();
			$('.billing_address').stop().animate({
				height: baHeight
			});
		} else {
			$('.billing_address').stop().animate({
				height: 0
			});
		}*/

        $('.billing_address_inner').toggle('display'); //PBS: 12 lines to 1

	});

});





//PBS: do this only after validation
/*
$(function(){
	$(document).on('click', '#checkout-open-modal', function(){
		var products = $('.coos_original').clone();
		products.removeClass('coos_original');
		products.find('.checkout_ordersummary').removeAttr('style');
		$('.coconfirm_productlist').empty();
		$('.coconfirm_productlist').append(products);
	});

	$(document).on('click', '.swe_errormessage_goback', function(e){
		e.preventDefault();
		$('.submitwindow_error').fadeOut();
		$('.submitwindow').fadeOut();
	});
});
*/

$(function(){
	$(document).on('click', '.btn_getquote', function(e){
		e.preventDefault();
		$('.quotelist_wrapper').empty();
		var t = $(this);
		var wrapper = t.closest('.calculateshipping_wrapper');
		var ship_country = wrapper.find('.country_wrapper select').val();
		var ship_state =  wrapper.find('.state_wraper select').val();
		var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
		
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token')+'?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			method: 'GET',
xhrFields: {
                withCredentials: true
            },
                crossDomain: true,
			context: document.body
		}).done(function(data) {			
			for(var key in data){
				var item = data[key];
				
				var id_shipping_method = item.id_shipping_method;
				var name = item.name;
				var price = item.price;
				var selected = item.selected;
				
				if(selected!=undefined&&selected=='true'){
					selected = 'checked';
				} else {
					selected = '';
				}
				
				
				$('.quotelist_wrapper').append('																	\
					<div class="col-xs-12">																			\
						<label>																						\
							<input type="radio" '+selected+' name="quoteoption" value="'+id_shipping_method+'">		\
							'+name+'																				\
						</label>																					\
					</div>																							\
				');
			}
		});
	});
	
	
	
	$(document).on('click', '.btn-applyshipping', function(e){
		e.preventDefault();
		
		var wrapper = $('.calculateshipping_wrapper');
		var ship_country = wrapper.find('.country_wrapper select').val();
		var ship_state =  wrapper.find('.state_wraper select').val();
		var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
		var id_shipping_method = $('#getquote_modal .quotelist_wrapper input:checked').val();	
		
		var json = {
			id_shipping_method: ''+id_shipping_method+'',
			ship_country: ''+ship_country+'',
			ship_state: ''+ship_state+'',
			ship_zipcode: ''+ship_zipcode+''
		}
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token'),
			method: 'POST',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {

			//console.log('was getting cart data');
			service_GetCart( 'step-01' );

		});		
	});

});




/*
 *	Add Promo Code
 */
$(document).on('click', '.btn_apply', function(e){
	e.preventDefault();
	var t = $(this);
	var code = t.closest('.cci_promo').find('.ccip_code').val();
	if(code!=''){
		var json = [ 
			{
				promocode: ''+code+'',
				type: 'promocode'
			}
		];
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts',
			method: 'POST',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {
			service_GetCart();
		}).error(function(data) {
			$('.cci_insertedpromocodes').append('<div class="div_promocode alert">'+data.responseJSON.message+'</div>');
			setTimeout(function(){ $(".cci_insertedpromocodes .div_promocode.alert").stop().fadeOut("slow");  }, 3000);
			setTimeout(function(){ $(".cci_insertedpromocodes .div_promocode.alert").remove(); }, 5000);
		});
	}
});
/*
* end Add Promo Code
*/

/*
 *	Remove Promo Code
 */
$(document).on('click', '.cpl_deletepromocode', function(e){
	e.preventDefault();
	var t = $(this);
	var div = t.closest(".div_promocode");
	var promocode_name = div.find('.promocode_name').text();
	var promocode_description = div.find('.promocode_description').text();
	if(promocode_name!=''){
		var json = [ 
			{
				name: promocode_name,
				description: promocode_description,
				type: 'promocode',
				token: Cookies.get('token').replace('/','')
			}
		];
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
			method: 'DELETE',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {
			service_GetCart();
		});
	}
});
/*
 *	end Remove Promo Code
 */














function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

/* ----- INSTA WIDGET ----- */
/* -- CONFIGS -- */
var bigImgsSize = 30; // <-- Percentagem
/* end CONFIGS - */
function setInstaImgsPosition(widget, widgetPropertys){
	var widgetWidth = widget.width();
	var widgetHeight = widget.height();
	var items = widget.find('div');
	var nrOfItems = items.size();
	var itemPostWidth = widgetWidth / nrOfItems;

	if(nrOfItems > 3){
		var smallImgIndex = 0;
		var bigImg = ':odd';
		items.eq(1).removeClass('small_img_front');
	} else {
		var smallImgIndex = 1;
		var bigImg = ':even';
		items.eq(1).addClass('small_img_front');
	}
	var firstImgHeight = items.eq(smallImgIndex).find('img').height();

	items.each(function(){
		var t = $(this);
		var tIndex = t.index();
		var tWidth = t.width();
		var position = (tIndex * widgetWidth) / nrOfItems;
		t.css({
			width: itemPostWidth,
			left: position
		});
	});
	
	items.filter(bigImg).each(function(){
		var t = $(this);
		var tLeft = parseFloat(t.css('left'));
		var tFinalWidth = t.width() * bigImgsSize/100;
		var tLeftNudge = tFinalWidth / 2;

		var tTop = parseFloat(t.css('top'));
		var tFinalHeight = widgetHeight * bigImgsSize/100;
		var tTopNudge = tFinalHeight / 2;

		t.css({
			width: t.width() + tFinalWidth,
			left: (tLeft - tLeftNudge)
		});

		var tImgHeight = t.find('img').height();
		var bigImgTop = -((tImgHeight - firstImgHeight) / 2);
		if(bigImgsSize === 0){
			bigImgTop = 0;
		}
		t.css({
			top: bigImgTop
		});

		widget.css({
			height: firstImgHeight,
			'margin-top': (Math.abs(bigImgTop) + widgetPropertys.widgetMarginTop),
			'margin-bottom': (Math.abs(bigImgTop) + widgetPropertys.widgetMarginBottom)
		});
	});
}

function startInstaWidget(widgetElement){
	var widget = widgetElement;
	var widgetPropertys = {
		widgetMarginTop: parseFloat(widget.css('margin-top')),
		widgetMarginBottom: parseFloat(widget.css('margin-bottom'))
	}
	setInstaImgsPosition(widget, widgetPropertys);

	$(window).resize(function(){
		setInstaImgsPosition(widget, widgetPropertys);
		setTimeout(function(){
			setInstaImgsPosition(widget, widgetPropertys);
		}, 10);
	});


	var instaImgs = $('.instaimgs_wrapper img');
	var nrOfImgs = 	instaImgs.size();
	var loadedImgs = 0;
	instaImgs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfImgs){
			setInstaImgsPosition(widget, widgetPropertys);
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});
}
/* --- end INSTA WIDGET --- */


/* ----- cart contents ----- */
function openCloseCart(cartContents, cartContentsState){
	if(cartContentsState=='false'){
		cartContents.stop().fadeIn(300, function(){
			cartContents.attr('data-open', 'true');
		});
	} else {
		cartContents.stop().fadeOut(300, function(){
			cartContents.attr('data-open', 'false');
		});
	}
}

$(function(){
	var myCartBtns = '.btn_mycart a, .btn_mycart_small, #cart-row .btn_mycart, .cart';
	var cartContents = $('.mycart_contents');

	$(document).on('click', myCartBtns, function(e){
		e.preventDefault();
		var cartContentsState = cartContents.attr('data-open');
		openCloseCart(cartContents, cartContentsState);
	});


	$(document).on('click', function(e){
		var target = $(e.toElement);
		if (!target.parents('.mycart_contents').length) {
	        if(!target.parent().hasClass('btn_mycart')) {
	        	var isCartOpen = $('.mycart_contents').attr('data-open');
				if(isCartOpen == 'true'){
					openCloseCart(cartContents, false);
				}
	        }
	    }
	});


	/*$(window).on('scroll', function(){
		var t = $(this);
		var top = t.scrollTop();
		if(top>40){
			$('.mycart_contents_float').css('top', (top+80));
		} else {
			$('.mycart_contents_float').css('top', 105);
		}
	});*/
});


//---------------------------------------------------------
	//-------------------------------------------------------

	//-------------------------------------------------------
	//show the menu on mouse enter
	$(document).on('mouseenter', '.hasmegamenu', function(){

        //return;

		var t = $(this);
		//t.css('border','1px solid #fc0');
		var tMegamenuName = t.attr('data-custommegamenu');
		var tMegamenu = $('#'+tMegamenuName);
		var tMegamenuContent = tMegamenu.find('.megamenu_inner');
		var tMegamenuContentHeight = tMegamenuContent.outerHeight();
		
		//add class to know that mega menu is open
		var isMegaMenuOpen = tMegamenu.hasClass('megamenu_open');

		//animate and add class again?
		tMegamenu.stop().animate({
			height: tMegamenuContentHeight
		}, 200, function(){
			tMegamenu.addClass('megamenu_open');
			is_open = true;
		});

        // force link on dropdown menu
        $(this).on('click', function(){

            window.location= "/surfboards";

        })

	});

	//-------------------------------------------------------

	//-------------------------------------------------------
	//on leave .hasmegamenu
	$(document).on('mouseleave', '.hasmegamenu', function(e){
	//$(document).on('mouseleave', '.megamenu_inner', function(e){				

		//console.log('you left the class .hasmegamenu');
		//console.log('you left the class .megamenu_inner');
		
		var t = $(this);
		var tMegamenuName = t.attr('data-custommegamenu');
		var tMegamenu = $('#'+tMegamenuName);
		//var target = $(e.toElement);
		//var target = $(e.currentTarget);
		//var target = $(e.target);
		//e.relatedTarget 
		//firefox does not recognize toElement..
		var target = $(e.relatedTarget);

		//console.log(target);
		//console.log('tMegamenuName = '+tMegamenuName);
		
		//bug starts here..
		//seems that firefox does not handle well target.parents('div#'+tMegamenuName)
		//on leave the button, if the current target is NOT the current mega menu..
		if (!target.parents('div#'+tMegamenuName).length) {
		//if( $('#'+tMegamenuName).length > 0 ){
		//if( is_open === true ){
			
					//console.log( 'parents of target: '+target.parents('div#'+tMegamenuName).length );
			
	        if(!target.hasClass('megamenu')) {
	        	tMegamenu.stop().animate({
							height: 0
						}, 200, function(){
						//what happens here..?	
						tMegamenu.removeClass('megamenu_open');
					}
				);
	    }
	  }

			//on leave .megamenu..? inside on leave .hasmegamenu..?		  
	    $(document).on('mouseleave', '.megamenu', function(){
				
				//console.log('you left the class .megamenu');
				
	    	var t = $(this);
				var tMegamenuName = t.attr('id');

				$('.hasmegamenu').each(function(){
					var tItem = $(this);
					if(tItem.attr('data-custommegamenu') == tMegamenuName) {
						tItem.removeClass('curr_megamenu');
					}
				});

				tMegamenu.stop().animate({
					height: 0
				}, 200, function(){
					tMegamenu.removeClass('megamenu_open');
				});			
		
			});
		
		//what happerns here..?
		$(document).on('mouseenter', '.megamenu', function(){
			var t = $(this);
			var tMegamenuName = t.attr('id');

			$('.hasmegamenu').each(function(){
				var tItem = $(this);
				if(tItem.attr('data-custommegamenu') == tMegamenuName) {
					tItem.addClass('curr_megamenu');
				}
			});
		});
		
	});//end on leave..?

//---------------------------------------------------------

//show surfboard on mega menu
$(function(){
	
	var boardPreviewWrapper = $('.mmboardpreview'); 
	var boardPreviewTarget = boardPreviewWrapper.find('img');

	function showBoard(boardImg, min_price, model, currency_iso, currency_symbol){		
		
		boardPreviewTarget.attr('src', boardImg);
		boardPreviewWrapper.css(
			{
				'height'	:	'auto',
				'width'		: '400px',
				'left'		:	'100px'
			}
		)
		//boardPreviewWrapper.css('width', '400px');
		//boardPreviewWrapper.css('left', '100px');

		boardPreviewWrapper.find('.mmbp_title').html(model);
		boardPreviewWrapper.find('.mmbp_price_price').html(min_price);
		boardPreviewWrapper.find('.mmbp_price_symbol').html(currency_symbol);
		boardPreviewWrapper.find('.mmbp_price_iso').html(currency_iso);
		
		//boardPreviewWrapper.stop().fadeIn(1000);
		boardPreviewWrapper.stop().animate(
			{
				'opacity':1,
				'left': '0px'
			}, 
			500
		)
	}
	
	function hideBoard(){
		
		//boardPreviewWrapper.stop().fadeOut(500, function(){
		boardPreviewWrapper.stop().animate(
			{
				'opacity':0,
				'left': '50px'
			}, 
			1000,
			function(){
			//boardPreviewWrapper.css('height', 0);
				boardPreviewTarget.attr('src', '');
		})
		
	}
	
	$(document).on('mouseenter', '.megamenu ul li a', function(){
		var t = $(this);
		var boardImg = t.attr('data-boardimg');
		var min_price = t.attr('data-min_price');
		
		var currency_iso = t.attr('data-currencyiso');
		var currency_symbol = t.attr('data-currencysymbol');
		
		var model = t.attr('data-model');
		if(boardImg != undefined && boardImg != ''){
			showBoard(boardImg, min_price, model, currency_iso, currency_symbol);
		}
	});
	
	$(document).on('mouseleave', '.megamenu ul li a', function(){
		hideBoard();
	});
	
});
/* --- end MEGAMENU --- */


/* ----- FEATURED BOARDS WIDGET ----- */
	var itemsPerPage = 3;
	function init_FeaturedBoards(widget){

        //console.log( widget );

		var smallCrossoverPoint = 750;
		var animSpeed = 400;
		var winWPrev = $(window).width();
		var intoSmall = false;
		var smallCurrPageMemory = -1;

		$(window).resize(function(){
			var winW = $(window).width();
			if(winWPrev < winW){
				if(winW > smallCrossoverPoint){
					if(intoSmall==true){
						// ----- small OUT
						itemsPerPage = 3;
						var currPageTemp = Number(widget.find('.featuredboards_viewport').attr('data-currpage'));
						var currPageToSmall = Math.floor(currPageTemp / 3);
						widget.find('.featuredboards_viewport').attr('data-currpage', currPageToSmall);
						intoSmall = false;
						smallCurrPageMemory = currPageTemp;
						setBottomNavPages(widget);
						checkCurrBottomNav(widget, currPageToSmall);
					}
				}
			} else {
				if(winW < smallCrossoverPoint){
					if(intoSmall==false){
						// ----- small IN
						itemsPerPage = 1;
						var currPageTemp = widget.find('.featuredboards_viewport').attr('data-currpage');
						var currPageToSmall = currPageTemp * 3;
						if(smallCurrPageMemory > -1){
							widget.find('.featuredboards_viewport').attr('data-currpage', smallCurrPageMemory);
						} else {
							widget.find('.featuredboards_viewport').attr('data-currpage', currPageToSmall);
						}
						intoSmall = true;
						setBottomNavPages(widget);
						checkCurrBottomNav(widget, currPageToSmall);
					}
				}
			}
			winWPrev = winW;

			var currPage = Number(widget.find('.featuredboards_viewport').attr('data-currpage'));
			var mainContainer = widget.find('.fboards_maincontainer');
			var containerWidth = mainContainer.width();
			var track = widget.find('.featuredboards_track');
			var trackGoTo = -(currPage * containerWidth);
			var containerWidth = mainContainer.width();

			track.css({
				'left': trackGoTo
			});

			var windowWidth = $(window).width();
			if(windowWidth < (smallCrossoverPoint+1)){
				// ----- RUN on RESIZE IN
				$('.featb_item').width(containerWidth);
			} else {
				// ----- RUN on RESIZE OUT
				$('.featb_item').attr('style', '');
			}
		});

        $(document).on('click', '.featbnav_next', function(e){

            e.preventDefault();

            $(document).trigger('board_widget_next',['next-nav']);

        })

		//$(document).on('click', '.featbnav_next', function(e){
        // trying to distinguish two events, next and size nav
        $(document).on('board_widget_next', function(e, target){

            //console.log('clicked or triggered next!');

            /*
            console.log('board_widget_next was triggered');
            console.log('e.target: '+e.target);
            console.log('e.currentTarget: '+e.currentTarget);
            console.log('target: '+target);
            */

			e.preventDefault();

            var t = $(this);

            //console.log( t );

			//var mainContainer = t.closest('.fboards_maincontainer');

            var mainContainer = $('.fboards_maincontainer');

			var track = mainContainer.find('.featuredboards_track');

            // getting the currPage from .featuredboards_viewport, but is defined where?
			var currPage = Number(mainContainer.find('.featuredboards_viewport').attr('data-currpage'));
            //var currPage = mainContainer.find('.featuredboards_viewport').attr('data-currpage');

            currPage++;

            //console.log( 'currPage: '+currPage );

			var containerWidth = mainContainer.width();
			//var trackPosition = parseFloat(track.css('left'));

            // the ammount to travel is defined here
			/*
            var trackGoTo = -(currPage * containerWidth);
            console.log( 'currPage: '+currPage );
            console.log( 'containerWidth: '+containerWidth );
            console.log( 'trackGoTo: '+trackGoTo );
            */

            // PBS a possible solution:
            // get the position of the next separator and travel that..?
            // but it will not work for normal "next".. or maybe it will because it� based on the currPage
            // it doesn�t work..
            // try to catch the event trigger and handle it

            //console.log( $('.featbsep_'+currPage).position() );

            //console.log( 'searching for $(".featbsep_'+currPage * 2+'" )' );

            if( target == 'wave-size-nav'){

                // get the selected wave size
                $next_separator = $('.fbbn_curr').data('separator');

                //console.log( '$next_separator: '+$next_separator );

                var position_of_next_separator = $('.featbsep_'+$next_separator ).position();

                //console.log( position_of_next_separator.left );

                var trackGoTo = -position_of_next_separator.left;

            }else{

                //console.log('the target was next arrow..');
                var trackGoTo = -(currPage * containerWidth);

            }


			var nrOfItems = track.find('.featb_item').size();
			var totalPages = Math.ceil(nrOfItems / itemsPerPage);
			var lastPage = totalPages - 1;
			var windowW = $(window).width();

            // back 2 the start
			if(currPage > lastPage){
				//console.log('ol�!');
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', lastPage);
				trackGoTo = -(lastPage * containerWidth);
			} else {

                //console.log('here doing stuff..?');

                //alert( currPage );
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', currPage);
                //mainContainer.find('.featuredboards_viewport').attr('data-currpage', 3);

				track.stop().animate({
					left: trackGoTo
				}, animSpeed);

				widget.find('.featb_regua').stop().animate({
					'background-position': -(windowW)
				}, animSpeed, function(){
					widget.find('.featb_regua').css('background-position', 'center');
				});
			}

            smallCurrPageMemory = -1;

            checkCurrBottomNav(widget, currPage );
            // skips the separator as Gon�alo suggested
            //checkCurrBottomNav(widget, currPage - 1 );

		});

        // PBS: maybe try to reuse the code of next..?
		$(document).on('click', '.featbnav_prev', function(e){

            e.preventDefault();

            //return;

			var t = $(this);
			var mainContainer = t.closest('.fboards_maincontainer');
			var track = mainContainer.find('.featuredboards_track');
			var currPage = Number(mainContainer.find('.featuredboards_viewport').attr('data-currpage'));
			currPage--;
			var containerWidth = mainContainer.width();
			var trackPosition = parseFloat(track.css('left'));
			var trackGoTo = -(currPage * containerWidth);
			var windowW = $(window).width();
			
			if(currPage < 0){
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', 0);
				trackGoTo = 0;
			} else {
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', currPage);
				track.stop().animate({
					left: trackGoTo
				}, animSpeed);

				widget.find('.featb_regua').stop().animate({
					'background-position': (windowW)
				}, animSpeed, function(){
					widget.find('.featb_regua').css('background-position', 'center');
				});
			}
			smallCurrPageMemory = -1;

            checkCurrBottomNav(widget, currPage );
            // skips the separator as Gon�alo suggested
            //checkCurrBottomNav(widget, currPage - 1);

		});

		
		//$(document).on('click', '.featb_bottomnav ul li a', function(e){
        $(document).on('click', '.featb_bottomnav ul li', function(e){

            //console.log('here be scrolling..');

			e.preventDefault();

            //return;

			//var t = $(this);
            var tParent = $(this);

            //console.log( t );

			//var tParent = t.closest('li');

            // Get the index of the clicked <li> element, relative to its siblings
			var tIndex = tParent.index();

            //console.log( 'tIndex is: '+tIndex );
            //console.log( tParent );

            //console.log('items per page: '+itemsPerPage);

            // counting from zero
			//var targetIndex = tIndex-1;
            // or maybe NOT!
            var targetIndex = tIndex;

            // get the corresponding separator to get the index
			var targetElement = widget.find('.featuredboards_track .featb_sep').eq(targetIndex);

            //targetElement.css('border','1px dotted orange')

            //console.log( targetElement );

			var elementIndex = targetElement.index();

            //console.log( 'elementIndex (separator) is: '+elementIndex );

            var elementPage = (Math.floor(elementIndex / itemsPerPage))-1;
            //var elementPage = (Math.floor(elementIndex / itemsPerPage));

            // if not currently selected
			if(!tParent.hasClass('fbbn_curr')){

                // remove the currently selected one
				widget.find('.fbbn_curr').removeClass('fbbn_curr');

				tParent.addClass('fbbn_curr');

                //console.log( 'elementPage: '+elementPage );

				//if( tIndex != 0 ){
					//widget.find('.featuredboards_viewport').attr('data-currpage', elementPage - 1 );
                    widget.find('.featuredboards_viewport').attr('data-currpage', elementPage );
				//} else {
					//widget.find('.featuredboards_viewport').attr('data-currpage', -1);
				//}

                // triggers the click on the navigation bar
                //widget.find('.featbnav_next').trigger('click');
                $(document).trigger('board_widget_next',['wave-size-nav']);

			}else{

                console.log("it is already the choosen one.");

            }

		})

		function setBottomNavPages(widget){

			var sepIndex = 0;

            //console.log('setting the corrspage on the size nav');

			widget.find('.featb_bottomnav li').eq(0).attr('data-corrspage', '0');

            // get the separators
            widget.find('.featuredboards_track .featb_sep').each(function(){

                //console.log('looping thru the separatorz');

                // the separator itself
				var t = $(this);

                //console.log( t );

				var tIndex = t.index();
				var tPage = (Math.floor(tIndex / itemsPerPage));

                //console.log( 'tPage = '+tPage );

				widget.find('.featb_bottomnav li').eq(sepIndex).attr('data-corrspage', tPage);

				sepIndex++;

			});

		}

		setBottomNavPages(widget);

		function checkCurrBottomNav(widget, currPage){

            //return;

            //console.log( 'checking nav for currPage:'+currPage );

			var pageFirst = widget.find('.featb_bottomnav ul li').eq(0).attr('data-corrspage');
			var pageSecond = widget.find('.featb_bottomnav ul li').eq(1).attr('data-corrspage');
			var pageThird = widget.find('.featb_bottomnav ul li').eq(2).attr('data-corrspage');
			if(currPage >= pageThird){
				widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
				widget.find('.featb_bottomnav ul li').eq(2).addClass('fbbn_curr');
			} else if(currPage < pageThird){
				if(currPage < pageSecond){
					widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
					widget.find('.featb_bottomnav ul li').eq(0).addClass('fbbn_curr');
				} else {
					widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
					widget.find('.featb_bottomnav ul li').eq(1).addClass('fbbn_curr');
				}
			}
		}

		$(window).resize();
	}

	//what is this?
	$(function(){
		//var widget = $('.featuredboards_home');
		//init_FeaturedBoards(widget);
	});

/* --- end FEATURED BOARDS WIDGET --- */


/* ----- SHOP ONLINE HOME INIT ----- */
$(function(){
	function checkContainerHeight(widget){
		var rowI = 0;
		widget.find('.shponl_tabs .row').each(function(){
			var t = $(this);
			if((rowI%2) === 1){
				t.addClass('row_odd');
			}
			rowI++;
		});
		widget.find('.shponl_nav a:eq(0)').tab('show');
	}

	var widget = $('.shoponline_home');
	checkContainerHeight(widget);
});
/* --- end SHOP ONLINE HOME INIT --- */


/* ------- BOARDS LIST NAV ------- */
$(function(){
	function checkChecked(t){
		var state = t.prop('checked');
		var parent = t.closest('label');
		if(state === true){
			parent.addClass('sblf_checked');
		} else {
			parent.removeClass('sblf_checked');
		}
	}
	$(document).on('change', '.sblf_tabs label input.sblf_filtercheck', function(){
		var t = $(this);
		checkChecked(t)
	});
	$('.sblf_tabs label input.sblf_filtercheck').each(function(){
		var t = $(this);
		checkChecked(t);
	});
});
/* ----- end BOARDS LIST NAV ----- */


/* ------- OTHER BOARDS WIDGET ------- */
	function otherBoardsInit(widget){
		var itemsPerPageSmall = 3;
		var itemsPerPageLarge = 6;

		var win = $(window);
		var bulletsWrapper = widget.find('.carousel-indicators');
		var boardsWrapper = widget.find('.carousel-inner');
		var initialWinW = win.width();
		var winWPrev = initialWinW;
		var smallCrossoverPoint = 750;
		var isSmall;
		if(initialWinW <= smallCrossoverPoint){
			isSmall = false;
			winWPrev++;
		} else {
			isSmall = true;
		}

		function setBoardsColumns(currItemsPerPage){
			var allBoards = widget.find('.os_imgwrapper');
			var nrOfBoards = allBoards.size();
			var nrOfPages = Math.ceil(nrOfBoards / currItemsPerPage);
			var colsValue = 12 / currItemsPerPage;

			bulletsWrapper.empty();
			boardsWrapper.empty();

			for(i=0;i<nrOfPages;i++){
				boardsWrapper.append('<div class="item boardspage"><div class="row"></div></div>');
				bulletsWrapper.append('<li data-target="#othersurfboards_widget" data-slide-to="'+i+'"></li>');
			}
			widget.find('.carousel-indicators li:first').addClass('active');
			widget.find('.boardspage:first').addClass('active');

			widget.find('.boardspage').each(function(){
				var t = $(this);
				for(i=0;i<currItemsPerPage;i++){
					t.find('.row').append('<div class="col-xs-'+colsValue+' boardspage_items"></div>');
				}
			});

			var bpIndex = 0;
			$('.boardspage_items').each(function(){
				var t = $(this);
				t.append(allBoards.eq(bpIndex));
				bpIndex++;
			});
		}

		$(window).resize(function(){
			var winW = win.width();
			if(winW < winWPrev){
				if(winW <= smallCrossoverPoint){
					if(isSmall==false){
						isSmall = true;
						setBoardsColumns(itemsPerPageSmall);
						widget.removeClass('os_large');
						widget.addClass('os_small');
					}
				}
			} else {
				if(winW > smallCrossoverPoint){
					if(isSmall==true){
						isSmall = false;
						setBoardsColumns(itemsPerPageLarge);
						widget.removeClass('os_small');
						widget.addClass('os_large');
					}
				}
			}
			winWPrev = winW;
		});
		$(window).resize();
	}
/* ----- end OTHER BOARDS WIDGET ----- */

//aligns the chilli logo and stuff on the shop home
// i think this was replaced by CSS..
$(function(){
	var linksDstk = $('.links_destaque');
	//var logo = linksDstk.find('.centerlogo_gfx');
	var logo = $('.centerlogo_gfx');
	var logoImg = logo.find('img');

	function setlinksDstkVCenter(){
		var linksDstkH = linksDstk.height();

		//console.log( linksDstkH );

		var logoH = logo.height();
		var logoPos = ((linksDstkH/2) - (logoH/2));
		//logo.css('top', logoPos);
		logo.css('margin-top', logoPos);
	}

	$(window).resize(function(){
		setlinksDstkVCenter();
	});

	logoImg.one("load", function() {
		setlinksDstkVCenter();

		setTimeout(function(){
			setlinksDstkVCenter();
		}, 100);
		setTimeout(function(){
			setlinksDstkVCenter();
		}, 800);
	}).each(function() {
		if(this.complete) $(this).load();
	});
});

/* ------------------ VIDEOS ---------------------- */
function setVideoProperties(){
	$('.vc_item').each(function(){
		var t = $(this);
		var videoSource = t.attr('data-videosource');
		var id = t.attr('data-id');

        console.log('received id: '+id);

		if(videoSource == 'vimeo'){
			$.ajax({
				url: 'https://vimeo.com/api/v2/video/'+id+'.xml',
				method: 'GET',
				context: document.body
			}).done(function(data) {
				var data = $(data);

                // PBS 07.2016: all titles now come from shaperbuddy now
				//var title = data.find('title').text();
                //t.find('.vci_title').text(title);

                var thumb = data.find('thumbnail_large').text();

				t.find('.vci_img > img').attr('src', thumb);
			});
		} else {
			var thumb = 'https://img.youtube.com/vi/'+id+'/0.jpg';
			t.find('.vci_img > img').attr('src', thumb);
		}
	});


	var firstUrl = $('.vc_item:first').attr('href');
	var firstSource = $('.vc_item:first').attr('data-videosource');
	setVideo(firstUrl, firstSource, true);
}


function setVideo(url, videoSource, isFirstVideo){
	
	//console.log(url);
	//assign url to social share
	$('.social-share-video-link').each(function(){
		console.log($(this).data('url'));
        this.href = '';
		//initial_href = this.href;
        initial_href = $(this).data('url')
		final_href = initial_href += url;
		this.href = final_href;
	});
	
	if(videoSource == 'vimeo'){
		if(!isFirstVideo){
			var autoPlayHtml = '?autoplay=true';
		} else {
			var autoPlayHtml = '';
		}
		$('#videomain_wrapper').html('<iframe src="'+url+''+autoPlayHtml+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
	} else {
		if(!isFirstVideo){
			var autoPlayHtml = '?autoplay=1';
		} else {
			var autoPlayHtml = '';
		}
		var youtuId = youtube_parser(url);
		$('#videomain_wrapper').html('<iframe src="https://www.youtube.com/embed/'+youtuId+''+autoPlayHtml+'" frameborder="0" allowfullscreen></iframe>');
	}
}


function setVideoPagination(widget){
	var itemsPerPage = widget.attr('data-itemsperpage');
	var listWrapper = widget.find('.carousel-inner');
	var indicatorsWrapper = widget.find('.carousel-indicators');
	var allItems = widget.find('.vc_item_wrapper');
	var nrOfItems = allItems.size();
	var nrOfPages = Math.ceil(nrOfItems/itemsPerPage);
	listWrapper.empty();
	indicatorsWrapper.empty();

	for(i=0;i<nrOfPages;i++){
		listWrapper.append('<div class="item"><div class="container"><div class="row"></div></div></div>');
	}
	listWrapper.find('.item:first').addClass('active');

	var aiI = 1;
	allItems.each(function(){
		var t = $(this);
		var currPage = Math.ceil(aiI/itemsPerPage);
		listWrapper.find('.item').eq(currPage-1).find('.container > .row').append(t);
		aiI++;
	});

	for(i=0;i<nrOfPages;i++){
		indicatorsWrapper.append('<li data-target="#videos_carousel" data-slide-to="'+i+'">'+(i+1)+'</li>');
	}
	indicatorsWrapper.find('li:first').addClass('active');

	if(nrOfPages<2){
		indicatorsWrapper.hide();
		widget.find('.vc_arrows').hide();
	}



	$(document).on('click', '.vc_item', function(e){
		e.preventDefault();
		var t = $(this);
		var url = t.attr('href');
		var videoWrapper = $('#videomain_wrapper');
		var vwPos = videoWrapper.offset().top;
		var videoSource = t.attr('data-videosource');

		if(url!='#'){
			$("html, body").stop().animate({scrollTop:vwPos}, '500', 'swing', function() {
			});

			setVideo(url, videoSource);
		}

		t.closest(widget).find('.vc_item.active').removeClass('active');
		t.addClass('active');
	});
}

$(function(){
	//var widget = $('.videos_carousel');
	//setVideoPagination(widget);
});
/* ---------------- end VIDEOS -------------------- */


function checkOutDescWidth(){

    //PBS: maybe just use media queries??

    /*$(window).on('resize', function(){
		$('.cpl_item').each(function(){
			var t = $(this);
			var colWidth = t.find('.cplh_col2').width();
			var imgWidth = t.find('.cplh_col2 .cpl_img').width();
			var colWidthMinusImg = colWidth-imgWidth;
			t.find('.cpl_productdesc').width(colWidthMinusImg-10);
		});
	});*/
}

$(function(){
	checkOutDescWidth();
});

function youtube_parser(url){
	var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	var match = url.match(regExp);
	if (match && match[2].length == 11) {
	  return match[2];
	} else {
	  //error
	}
}

function getQueryString(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var allItems;
function setListItemHeight(allItems){
	var imgs = allItems.find('img');
	var nrOfItems = imgs.size();
	var container = allItems.closest('.container');
	var containerWidth;
	var containerWidthPrev;

	function setHeights(){
		allItems.css('height', 'auto');
		var heights = new Array();
		allItems.each(function(){
			var t = $(this);
			var tHeight = t.height();
			heights.push(tHeight);
		});
		var max = Math.max.apply(null, heights);
		allItems.height(max);
	}

	var loadedImgs = 0;
	imgs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfItems){
			setHeights();
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});

	$(window).resize(function(){
		containerWidth = container.width();
		if(containerWidth != containerWidthPrev){
			setHeights();
		}
		containerWidthPrev = containerWidth;
	});
	
	setHeights();
}

//what is this for?
//it messed up the height of technolgy items
/*
$(function(){
	allItems = new Array('.shopitem', '.sblbl_board', '.tl_item', '.vc_item_wrapper', '.sbbl_item', '.dl_item', '.cdsclmer_item');
	for(var i=0;i<allItems.length;i++){
		var tTarget = $(allItems[i]) 
		var exist = (tTarget.size()>0);
		if(exist){
			setListItemHeight(tTarget);
		}
	}
});
*/

//where?
/* ----- PARALAX SCROLLING BG ----- 
$(document).ready(function(){
   $window = $(window);
   $('section[data-type="background"]').each(function(){
     var $scroll = $(this);              
      $(window).scroll(function() {                           
        var yPos = -($window.scrollTop() / $scroll.data('speed'));
        var coords = '50% '+ yPos + 'px';
        $scroll.css({ backgroundPosition: coords });   
      });
   });
});
document.createElement("section");
/* --- end PARALAX SCROLLING BG --- */

/* ----- SCROLL TO ANCHOR ----- */
$(function() {	
	
  //$('a[href*=#]:not([href=#])').click(function() {
	//apply only to the right element
	$('#slide-to-top').click(function() {				
		
  	var t = $(this);
  	var parentHasNoScroll = t.closest('.noscrollscript').size();
  	if(parentHasNoScroll === 0){
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		}
  	}

  });
	
});
/* --- end SCROLL TO ANCHOR --- */

/*
$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});
*/



$(function(){	
	$(document).on('click', '.shopitem .variant_color', function(){
		var t = $(this);
		var dataColor = t.attr('data-colorname');
		var tLinkElement = t.closest('.shopitem').find('a');
		var initUrl = tLinkElement.attr('data-url');
		var finalUrl = initUrl+'&variantcolor='+dataColor;
		tLinkElement.attr('href', finalUrl);
	});
	
	
	$(document).on('click', '.shponlc_prodpic .variant_color', function(){
		var t = $(this);
		var dataColor = t.attr('data-colorname');
		var tLinkElement = t.closest('.shponlc_prodpic').find('a');
		var initUrl = tLinkElement.attr('data-url');
		var finalUrl = initUrl+'&variantcolor='+dataColor;
		tLinkElement.attr('href', finalUrl);
	});
});




/*add border to product variants on click*/

$('body').on('click','.variant_color',function(){
	$('.variant_color_selected').removeClass('variant_color_selected');
	$(this).addClass('variant_color_selected');
})








/*! Lazy Load 1.9.7 - MIT license - Copyright 2010-2015 Mika Tuupola */
!function(a,b,c,d){var e=a(b);a.fn.lazyload=function(f){function g(){var b=0;i.each(function(){var c=a(this);if(!j.skip_invisible||c.is(":visible"))if(a.abovethetop(this,j)||a.leftofbegin(this,j));else if(a.belowthefold(this,j)||a.rightoffold(this,j)){if(++b>j.failure_limit)return!1}else c.trigger("appear"),b=0})}var h,i=this,j={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!1,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};return f&&(d!==f.failurelimit&&(f.failure_limit=f.failurelimit,delete f.failurelimit),d!==f.effectspeed&&(f.effect_speed=f.effectspeed,delete f.effectspeed),a.extend(j,f)),h=j.container===d||j.container===b?e:a(j.container),0===j.event.indexOf("scroll")&&h.bind(j.event,function(){return g()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,(c.attr("src")===d||c.attr("src")===!1)&&c.is("img")&&c.attr("src",j.placeholder),c.one("appear",function(){if(!this.loaded){if(j.appear){var d=i.length;j.appear.call(b,d,j)}a("<img />").bind("load",function(){var d=c.attr("data-"+j.data_attribute);c.hide(),c.is("img")?c.attr("src",d):c.css("background-image","url('"+d+"')"),c[j.effect](j.effect_speed),b.loaded=!0;var e=a.grep(i,function(a){return!a.loaded});if(i=a(e),j.load){var f=i.length;j.load.call(b,f,j)}}).attr("src",c.attr("data-"+j.data_attribute))}}),0!==j.event.indexOf("scroll")&&c.bind(j.event,function(){b.loaded||c.trigger("appear")})}),e.bind("resize",function(){g()}),/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent&&b.originalEvent.persisted&&i.each(function(){a(this).trigger("appear")})}),a(c).ready(function(){g()}),this},a.belowthefold=function(c,f){var g;return g=f.container===d||f.container===b?(b.innerHeight?b.innerHeight:e.height())+e.scrollTop():a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return g=f.container===d||f.container===b?e.width()+e.scrollLeft():a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollTop():a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollLeft():a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!(a.rightoffold(b,c)||a.leftofbegin(b,c)||a.belowthefold(b,c)||a.abovethetop(b,c))},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})}(jQuery,window,document);
"use strict";var pyzel={};!function(i){"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){var e=window.Slick||{};e=function(){function e(e,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(e),appendDots:i(e),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" data-role="none" role="button" tabindex="0" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(e),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(e).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,"undefined"!=typeof document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=t++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}var t=0;return e}(),e.prototype.activateADA=function(){var i=this;i.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):o===!0?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),s.options.rtl===!0&&s.options.vertical===!1&&(e=-e),s.transformsEnabled===!1?s.options.vertical===!1?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):s.cssTransitions===!1?(s.options.rtl===!0&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),s.options.vertical===!1?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),s.options.vertical===!1?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this,o=t.getNavTarget();null!==o&&"object"==typeof o&&o.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};e.options.fade===!1?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(i.options.infinite===!1&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1===0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;e.options.arrows===!0&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),e.options.infinite!==!0&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(o.options.dots===!0&&o.slideCount>o.options.slidesToShow){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),e.options.centerMode!==!0&&e.options.swipeToSlide!==!0||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.options.draggable===!0&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var a=document.createElement("div");for(e=0;e<l.options.rows;e++){var d=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&d.appendChild(n.get(c))}a.appendChild(d)}o.appendChild(a)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,a=r.$slider.width(),d=window.innerWidth||i(window).width();if("window"===r.respondTo?n=d:"slider"===r.respondTo?n=a:"min"===r.respondTo&&(n=Math.min(d,a)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(r.originalSettings.mobileFirst===!1?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||l===!1||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!==0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var a=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(a),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t,o=this;if(e=o.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var s in e){if(i<e[s]){i=t;break}t=e[s]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),e.$slider.off("focus.slick blur.slick"),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide)),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),e.options.accessibility===!0&&e.$list.off("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition),i(document).off("ready.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&(i=e.$slides.children().children(),i.removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){var e=this;e.shouldClick===!1&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;t.cssTransitions===!1?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;e.cssTransitions===!1?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){var i=this;return i.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(i.options.infinite===!0)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(i.options.centerMode===!0)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s=this,n=0;return s.slideOffset=0,t=s.$slides.first().outerHeight(!0),s.options.infinite===!0?(s.slideCount>s.options.slidesToShow&&(s.slideOffset=s.slideWidth*s.options.slidesToShow*-1,n=t*s.options.slidesToShow*-1),s.slideCount%s.options.slidesToScroll!==0&&i+s.options.slidesToScroll>s.slideCount&&s.slideCount>s.options.slidesToShow&&(i>s.slideCount?(s.slideOffset=(s.options.slidesToShow-(i-s.slideCount))*s.slideWidth*-1,n=(s.options.slidesToShow-(i-s.slideCount))*t*-1):(s.slideOffset=s.slideCount%s.options.slidesToScroll*s.slideWidth*-1,n=s.slideCount%s.options.slidesToScroll*t*-1))):i+s.options.slidesToShow>s.slideCount&&(s.slideOffset=(i+s.options.slidesToShow-s.slideCount)*s.slideWidth,n=(i+s.options.slidesToShow-s.slideCount)*t),s.slideCount<=s.options.slidesToShow&&(s.slideOffset=0,n=0),s.options.centerMode===!0&&s.options.infinite===!0?s.slideOffset+=s.slideWidth*Math.floor(s.options.slidesToShow/2)-s.slideWidth:s.options.centerMode===!0&&(s.slideOffset=0,s.slideOffset+=s.slideWidth*Math.floor(s.options.slidesToShow/2)),e=s.options.vertical===!1?i*s.slideWidth*-1+s.slideOffset:i*t*-1+n,s.options.variableWidth===!0&&(o=s.slideCount<=s.options.slidesToShow||s.options.infinite===!1?s.$slideTrack.children(".slick-slide").eq(i):s.$slideTrack.children(".slick-slide").eq(i+s.options.slidesToShow),e=s.options.rtl===!0?o[0]?(s.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,s.options.centerMode===!0&&(o=s.slideCount<=s.options.slidesToShow||s.options.infinite===!1?s.$slideTrack.children(".slick-slide").eq(i):s.$slideTrack.children(".slick-slide").eq(i+s.options.slidesToShow+1),e=s.options.rtl===!0?o[0]?(s.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,e+=(s.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){var e=this;return e.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(e.options.infinite===!1?i=e.slideCount:(t=e.options.slidesToScroll*-1,o=e.options.slidesToScroll*-1,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o,s=this;return o=s.options.centerMode===!0?s.slideWidth*Math.floor(s.options.slidesToShow/2):0,s.options.swipeToSlide===!0?(s.$slideTrack.find(".slick-slide").each(function(e,n){if(n.offsetLeft-o+i(n).outerWidth()/2>s.swipeLeft*-1)return t=n,!1}),e=Math.abs(i(t).attr("data-slick-index")-s.currentSlide)||1):s.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){var t=this;t.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),t.options.accessibility===!0&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this;e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),e.$slideTrack.attr("role","listbox"),e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){i(this).attr({role:"option","aria-describedby":"slick-slide"+e.instanceUid+t})}),null!==e.$dots&&e.$dots.attr("role","tablist").find("li").each(function(t){i(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+e.instanceUid+t,id:"slick-slide"+e.instanceUid+t})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide))},e.prototype.initDotEvents=function(){var e=this;e.options.dots===!0&&e.slideCount>e.options.slidesToShow&&i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),e.options.dots===!0&&e.options.pauseOnDotsHover===!0&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),e.options.accessibility===!0&&e.$list.on("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(document).on("ready.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.initUI=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&e.options.accessibility===!0?e.changeSlide({data:{message:e.options.rtl===!0?"next":"previous"}}):39===i.keyCode&&e.options.accessibility===!0&&e.changeSlide({data:{message:e.options.rtl===!0?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=document.createElement("img");o.onload=function(){e.animate({opacity:0},100,function(){e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy").removeClass("slick-loading")}),r.$slider.trigger("lazyLoaded",[r,e,t])})},o.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,e,t])},o.src=t})}var t,o,s,n,r=this;r.options.centerMode===!0?r.options.infinite===!0?(s=r.currentSlide+(r.options.slidesToShow/2+1),n=s+r.options.slidesToShow+2):(s=Math.max(0,r.currentSlide-(r.options.slidesToShow/2+1)),n=2+(r.options.slidesToShow/2+1)+r.currentSlide):(s=r.options.infinite?r.options.slidesToShow+r.currentSlide:r.currentSlide,n=Math.ceil(s+r.options.slidesToShow),r.options.fade===!0&&(s>0&&s--,n<=r.slideCount&&n++)),t=r.$slider.find(".slick-slide").slice(s,n),e(t),r.slideCount<=r.options.slidesToShow?(o=r.$slider.find(".slick-slide"),e(o)):r.currentSlide>=r.slideCount-r.options.slidesToShow?(o=r.$slider.find(".slick-cloned").slice(0,r.options.slidesToShow),e(o)):0===r.currentSlide&&(o=r.$slider.find(".slick-cloned").slice(r.options.slidesToShow*-1),e(o))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){var i=this;i.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(i){var e=this;e.unslicked||(e.$slider.trigger("afterChange",[e,i]),e.animating=!1,e.setPosition(),e.swipeLeft=null,e.options.autoplay&&e.autoPlay(),e.options.accessibility===!0&&e.initADA())},e.prototype.prev=e.prototype.slickPrev=function(){var i=this;i.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n=this,r=i("img[data-lazy]",n.$slider);r.length?(t=r.first(),o=t.attr("data-lazy"),s=document.createElement("img"),s.onload=function(){t.attr("src",o).removeAttr("data-lazy").removeClass("slick-loading"),n.options.adaptiveHeight===!0&&n.setPosition(),n.$slider.trigger("lazyLoaded",[n,t,o]),n.progressiveLazyLoad()},s.onerror=function(){e<3?setTimeout(function(){n.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,t,o]),n.progressiveLazyLoad())},s.src=o):n.$slider.trigger("allImagesLoaded",[n])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,t=n[e].breakpoint,n.hasOwnProperty(e)){for(;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;return"boolean"==typeof i?(e=i,i=e===!0?0:o.slideCount-1):i=e===!0?--i:i,!(o.slideCount<1||i<0||i>o.slideCount-1)&&(o.unload(),t===!0?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,void o.reinit())},e.prototype.setCSS=function(i){var e,t,o=this,s={};o.options.rtl===!0&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,o.transformsEnabled===!1?o.$slideTrack.css(s):(s={},o.cssTransitions===!1?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;i.options.vertical===!1?i.options.centerMode===!0&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),i.options.centerMode===!0&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),i.options.vertical===!1&&i.options.variableWidth===!1?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):i.options.variableWidth===!0?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();i.options.variableWidth===!1&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,t.options.rtl===!0?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":"undefined"!=typeof arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),i.options.fade===!1?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=i.options.vertical===!0?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||i.options.useCSS===!0&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&i.animType!==!1&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&i.animType!==!1},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),n.options.centerMode===!0?(e=Math.floor(n.options.slidesToShow/2),n.options.infinite===!0&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,
t.slice(o-e+1,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")):i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=n.options.infinite===!0?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===n.options.lazyLoad&&n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(s.options.fade===!0&&(s.options.centerMode=!1),s.options.infinite===!0&&s.options.fade===!1&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=s.options.centerMode===!0?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));return s||(s=0),t.slideCount<=t.options.slidesToShow?(t.setSlideClasses(s),void t.asNavFor(s)):void t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,a=null,d=this;if(e=e||!1,(d.animating!==!0||d.options.waitForAnimate!==!0)&&!(d.options.fade===!0&&d.currentSlide===i||d.slideCount<=d.options.slidesToShow))return e===!1&&d.asNavFor(i),o=i,a=d.getLeft(o),r=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?r:d.swipeLeft,d.options.infinite===!1&&d.options.centerMode===!1&&(i<0||i>d.getDotCount()*d.options.slidesToScroll)?void(d.options.fade===!1&&(o=d.currentSlide,t!==!0?d.animateSlide(r,function(){d.postSlide(o)}):d.postSlide(o))):d.options.infinite===!1&&d.options.centerMode===!0&&(i<0||i>d.slideCount-d.options.slidesToScroll)?void(d.options.fade===!1&&(o=d.currentSlide,t!==!0?d.animateSlide(r,function(){d.postSlide(o)}):d.postSlide(o))):(d.options.autoplay&&clearInterval(d.autoPlayTimer),s=o<0?d.slideCount%d.options.slidesToScroll!==0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+o:o>=d.slideCount?d.slideCount%d.options.slidesToScroll!==0?0:o-d.slideCount:o,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,s]),n=d.currentSlide,d.currentSlide=s,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(l=d.getNavTarget(),l=l.slick("getSlick"),l.slideCount<=l.options.slidesToShow&&l.setSlideClasses(d.currentSlide)),d.updateDots(),d.updateArrows(),d.options.fade===!0?(t!==!0?(d.fadeSlideOut(n),d.fadeSlide(s,function(){d.postSlide(s)})):d.postSlide(s),void d.animateHeight()):void(t!==!0?d.animateSlide(a,function(){d.postSlide(s)}):d.postSlide(s)))},e.prototype.startLoad=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),o=Math.round(180*t/Math.PI),o<0&&(o=360-Math.abs(o)),o<=45&&o>=0?s.options.rtl===!1?"left":"right":o<=360&&o>=315?s.options.rtl===!1?"left":"right":o>=135&&o<=225?s.options.rtl===!1?"right":"left":s.options.verticalSwiping===!0?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(o.touchObject.edgeHit===!0&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(e.options.swipe===!1||"ontouchend"in document&&e.options.swipe===!1||e.options.draggable===!1&&i.type.indexOf("mouse")!==-1))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,e.options.verticalSwiping===!0&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!r.dragging||n&&1!==n.length)&&(e=r.getLeft(r.currentSlide),r.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,r.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,r.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(r.touchObject.curX-r.touchObject.startX,2))),r.options.verticalSwiping===!0&&(r.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(r.touchObject.curY-r.touchObject.startY,2)))),t=r.swipeDirection(),"vertical"!==t?(void 0!==i.originalEvent&&r.touchObject.swipeLength>4&&i.preventDefault(),s=(r.options.rtl===!1?1:-1)*(r.touchObject.curX>r.touchObject.startX?1:-1),r.options.verticalSwiping===!0&&(s=r.touchObject.curY>r.touchObject.startY?1:-1),o=r.touchObject.swipeLength,r.touchObject.edgeHit=!1,r.options.infinite===!1&&(0===r.currentSlide&&"right"===t||r.currentSlide>=r.getDotCount()&&"left"===t)&&(o=r.touchObject.swipeLength*r.options.edgeFriction,r.touchObject.edgeHit=!0),r.options.vertical===!1?r.swipeLeft=e+o*s:r.swipeLeft=e+o*(r.$list.height()/r.listWidth)*s,r.options.verticalSwiping===!0&&(r.swipeLeft=e+o*s),r.options.fade!==!0&&r.options.touchMove!==!1&&(r.animating===!0?(r.swipeLeft=null,!1):void r.setCSS(r.swipeLeft))):void 0)},e.prototype.swipeStart=function(i){var e,t=this;return t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow?(t.touchObject={},!1):(void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,void(t.dragging=!0))},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i,e=this;i=Math.floor(e.options.slidesToShow/2),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-e.options.slidesToShow&&e.options.centerMode===!1?(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-1&&e.options.centerMode===!0&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||"undefined"==typeof s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),"undefined"!=typeof t)return t;return o}}),pyzel.convertToSVG=function(){$('img[src$=".svg"]').each(function(){var i=$(this),e=i.attr("src"),t=i.prop("attributes");$.get(e,function(e){var o=jQuery(e).find("svg");o=o.removeAttr("xmlns:a"),$.each(t,function(){o.attr(this.name,this.value)}),i.replaceWith(o)},"xml")})},pyzel.sliders={},pyzel.sliders.init=function(){var i=$(".js-homepage-top-slider");i.length&&(i.on("init",function(e){i.find(".slick-current").removeClass("slick-active"),setTimeout(function(){i.find(".slick-current").addClass("slick-active")},5)}),i.slick({arrows:!1,autoplay:!0,autoplaySpeed:4e3,pauseOnHover:!1}))},pyzel.submenus={},pyzel.submenus.init=function(){$(".js-show-submenu").on("mouseenter",function(){pyzel.submenus.show($(this))}),$(".js-hide-submenu").on("mouseenter",function(){pyzel.submenus.hide()}),$(".js-navbar").on("mouseleave",function(){pyzel.submenus.hide()})},pyzel.submenus.show=function(i){var e=i.data("submenu");$(".js-submenu ul").hide(),$(".js-show-submenu").removeClass("arrow"),$(".js-submenu-"+e).show(),i.addClass("arrow"),$(".js-submenu").stop().slideDown()},pyzel.submenus.hide=function(){$(".js-submenu").stop().slideUp(function(){$(".js-submenu ul").hide(),$(".js-show-submenu").removeClass("arrow")})},$(function(){pyzel.convertToSVG(),pyzel.submenus.init(),pyzel.sliders.init()});
//# sourceMappingURL=sourcemaps/scripts.js.map

var sUrl = 'https://pyzeleurope.shaperbuddy.com';
var sUrlShop = 'https://pyzeleurope.shaperbuddy.com';

/*
 *
 *	Language Selector
 *
 */
 //var sLang = getQueryString('lang');
 var sLang = "en";

 if( sLang=="" ) sLang="en";

/*
 *	Função para atualizar o URL quando se altera o idioma
 */
 function addOrUpdateUrlParam(uri, paramKey, paramVal) {
 	var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");
 	if (re.test(uri)) {
 		uri = uri.replace(re, '$1' + paramKey + "=" + paramVal);
 	} else {
 		var separator = /\?/.test(uri) ? "&" : "?";
 		uri = uri + separator + paramKey + "=" + paramVal;
 	}
 	return uri;
 }

 function getQueryString(name) {
 	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
 	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
 	results = regex.exec(location.search);
 	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
 }

//	Altera o idioma para PT quando se clica em pt
$(document).on("click", "#lang_pt", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="pt" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "pt");
	}
})

//	Altera o idioma para EN quando se clica em en
$(document).on("click", "#lang_en", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="en" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "en");
	}
})

//	Altera o idioma para EN quando se clica em en
$(document).on("click", "#lang_fr", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="fr" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "fr");
	}
})


/* function actualLanguage(element){
 	var lang = element.text().replace('-','').replace(' ','');
 	$.ajax({
		url: sUrl+'/api/v1/language',
		method: 'POST',
		data: '{ "lang":"'+lang+'" }',
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
	        withCredentials: true
	    },
		crossDomain: true,
		context: document.body
	}).done(function(data) { 
		window.location.reload();
	}) 	
 }

 $(function(){
 	$.ajax({
		url: sUrl+'/api/v1/language',
		method: 'GET',
		context: document.body
	}).done(function(data) { 
		$('#language-selector ul li a').removeClass('active');
		$('#language-selector ul li a[text='+data.lang+']').addClass('active');
		sLang = data.lang;
	}) 	
 })

 $(document).on('click', '#language-selector ul li a', function(e){
 	e.preventDefault();
 	actualLanguage( $(this) );
 	//setTimeout(function(){ window.location.reload(); }, 1000);
 })*/
/*
 *	end Language Selector
 */

/*
  *	Equalize - Deixar os objetos com o mesmo tamanho (altura)
  */
  $.fn.equalize = function(){
    var maxHeight = 0;
    this.each(function(){
        var _this = $(this);
        if(_this.height() > maxHeight){
        	maxHeight = _this.height();
        }
    });
    return this.each(function(){
        $(this).height(maxHeight);
    });
};
/*
 *	end Equalize
 */

 /*used to populate the mega menu*/
 function service_SurfboardModels(){
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {

		//console.log(data);

		$('.mm_0 ul').empty();
		$('.mm_4 ul').empty();
		$('.mm_6 ul').empty();
		for(var key in data) {
			var min_price = data[key].min_price;
			var currency_iso = data[key].currency.iso;
			var currency_symbol = data[key].currency.symbol;
			var waveSize = data[key].wavesize.min;
			var model = data[key].surfboardmodel;
			var boardImg = data[key].img_420;
			var id = data[key].id_surfboardmodel;
			$('.mm_'+waveSize+' ul').append('<li><a href="/boards/detail.php?id='+id+'" data-boardimg="'+boardImg+'" data-min_price="'+min_price+'" data-currencyiso="'+currency_iso+'" data-currencysymbol="'+currency_symbol+'" data-model="'+model+'">'+model+'</a></li>');

			//$('#surfboards-menu-mobile').append('<li><a href="#">'+model+'</a></li>');

			//$('#waves-size-'+waveSize+' li').after().append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
			//$('#waves-size').append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
			$('#waves-size-'+waveSize).after('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');

			//waves-size-0

			$('.ftws_'+waveSize).append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
		}
	});
 }



 function service_SurfboardModels_widget(){
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		for(var key in data) {
 			var id_surfboardmodel = data[key].id_surfboardmodel;
 			var waveSize = data[key].wavesize.min;
 			var model = data[key].surfboardmodel;
 			var boardImg = data[key].img_303;
 			var symbol = data[key].currency.symbol;
 			var iso = data[key].currency.iso;
 			var minPrice = data[key].min_price;
 			var latestModel = data[key].latestmodel;
 			var hasPrice = '';
 			var isNew = '';
 			if(minPrice==''){
 				hasPrice = 'no_price';
 			}
 			if(latestModel==''){
 				isNew = 'not_new';
 			}

            /*
			if(waveSize == '0'){
				$('.featuredboards_track').prepend('															\
					<div class="featb_item">																	\
						<div class="btnnew_wrapper">															\
							<div class="btn btn-warning '+isNew+'">New</div>									\
						</div>																					\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">							\
							<div class="board_img">																\
								<img src="'+boardImg+'">														\
							</div>																				\
							<div class="board_shadow">															\
								<img src="/images/boardswidget_shadow.png">										\
							</div>																				\
							<div class="board_info">															\
								<span class="board_name">'+model+'</span>										\
								<span class="board_price '+hasPrice+'"><span class="currency_symbol">'+symbol+'</	span>'+minPrice+' '+iso+'</span>	\
							</div>																				\
						</a>																					\
					</div>																						\
				');
				*/
			//} else {
				$('.featbsep_'+waveSize).after('																\
					<div class="featb_item">																	\
					<div class="btnnew_wrapper">															\
					<div class="btn btn-warning '+isNew+'">New</div>									\
					</div>																					\
					<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">							\
					<div class="board_img">																\
					<img src="'+boardImg+'">														\
					</div>																				\
					<div class="board_shadow">															\
					<img src="/images/boardswidget_shadow.png">										\
					</div>																				\
					<div class="board_info">															\
					<span class="board_name">'+model+'</span>										\
					<span class="board_price '+hasPrice+'"><span class="currency_symbol">'+symbol+'</span>'+minPrice+' '+iso+'</span>	\
					</div>																				\
					</a>																					\
					</div>																						\
					');
			//}
		}
		var widget = $('.featuredboards_home');
		init_FeaturedBoards(widget);

        // trick to hide the first separator
        $('.featuredboards_track').css('left','-350px');

      });
 }


//populate carousel
function service_homeSliderImg(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/42/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var imgContainer = $('.main_destaque .carousel-inner');
		var bulletContainer = $('.main_destaque .carousel-indicators')
		//imgContainer.empty();
		bulletContainer.empty();
		var keyI = 0;
		for(var key in data) {

			//check if link exists
			if( data[key].hpurl != null ) link = data[key].hpurl;
			else link = '#';

			//--------------------------------------------------------
			//build html here

			//manipulate for testing purposes - it works
			//data[key].hpurl = 'http://www.surftotal.com';

			var item = '<div class="item">';

			//open link if it exists
			if( data[key].hpurl != null ){
				item += '<a href="'+data[key].hpurl+'">';
			}

			item += '<img src="'+data[key].bannerimg+'" alt="'+data[key].hpresume+'"> \
			<div class="carousel-caption"></div>				\
			<div class="carousel-caption">					\
			<p class="hpslidertext_1">'+data[key].hptitle+'</p>					\
			<p class="hpslidertext_2">'+data[key].hpresume+'</p>';

			//close link, if it exists..
			if( data[key].hpurl != null ){
				item += '</a>';
			}

			item += '</div>\
			</div>';

			//console.log(item);

			//finish building html
			//--------------------------------------------------------

			//append html
			imgContainer.append(item);

			bulletContainer.append('<li data-target="#chilli_carousel" data-slide-to="'+keyI+'"></li>');

			keyI++;

		}

		imgContainer.find('.item:first').addClass('active');
		bulletContainer.find('li:first').addClass('active');

		setTimeout(function(){
			$('.main_destaque').removeClass('md_loadingimgs');
		}, 200);

	});
}



function service_homeLinksDestaque(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/43/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		$('.links_destaque .ld_1 a img').attr('src', data[0].hpthumb);
		$('.links_destaque .ld_1 .ld_item_title').text(data[0].hpresume);
		$('.links_destaque .ld_1 a').attr('href', data[0].hpurl);
		$('.links_destaque .ld_1 a .lditem_toplayer p').html(data[0].hptitle);
		$('.links_destaque .ld_2 a img').attr('src', data[1].hpthumb);
		$('.links_destaque .ld_2 .ld_item_title').text(data[1].hpresume);
		$('.links_destaque .ld_2 a').attr('href', data[1].hpurl);
		$('.links_destaque .ld_2 a .lditem_toplayer p').html(data[1].hptitle);
	});
}


//home video
function service_homeVideo(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/44/objects?top=1&lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log(data);

        //throw new Error('exiting');

        $('#video-title').text(data[0].hptitle);
        $('#video-date').append(data[0].dt_publication.en);

        var isYoutube = data[0].hpurlvideo.indexOf('youtu') > -1;
        if(isYoutube){
        	videoId = youtube_parser(data[0].hpurlvideo);
        	videoSource = 'youtube';
        } else {
        	var vimeoId = data[0].hpurlvideo.split('/');
        	videoId = vimeoId[vimeoId.length - 1];
        	videoSource = 'vimeo';
        	videoUrl = 'https://player.vimeo.com/video/'+videoId;
        }

        if(videoSource=='vimeo'){
        	videoHtml = '<iframe src="https://player.vimeo.com/video/'+videoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        } else if(videoSource=='youtube'){
        	videoHtml = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
        }
        $('.video_home_video').append(videoHtml);
      });
}



function service_homeNews(id_team){
	var url = sUrl+'/api/v1/cms/zones/45/objects?lang='+sLang;
	if(id_team!=undefined){
		url += '&id_team='+id_team;
	}

	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var length = data.length;
		var container = $('.lfc_articles_container');
		container.empty();
		for(i=0;i<3;i++){
			var multimediaType = data[i].multimedia[0].id_cmsconteudomultimediatype;
			var fileUrl = data[i].multimedia[0].filename;
			var title = data[i].hptitle;
			var pubDate = data[i].dt_publication.en;
			var resume = data[i].hpresume;
			var id_cmsconteudo = data[i].id_cmsconteudo;


			container.append('																	\
				<div class="col-sm-4 lfc_article_wrapper lfca_'+i+'">							\
				<div class="lfc_article">													\
				<a href="/blog/detail.php?id='+id_cmsconteudo+'">			\
				<div class="lfc_image">												\
				<img src="'+fileUrl+'" class="img-responsive">					\
				<div class="lfc_title">											\
				<p class="lfc_titletitle">'+title+'</p>						\
				</div>															\
				</div>																\
				</a>																	\
				</div>																		\
				</div>																			\
				');


			if(multimediaType === '178'){
				var videoUrl = data[i].multimedia[0].url;
				var isYoutube = videoUrl.indexOf('youtu') > -1;
				if(isYoutube){
					var videoId = youtube_parser(videoUrl);
					fileUrl = 'https://img.youtube.com/vi/'+videoId+'/0.jpg';
					$('.lfca_'+i+' .lfc_article .lfc_image img').attr('src', fileUrl);
				} else {
					var vimeoId = videoUrl.split('/');
					vimeoId = vimeoId[vimeoId.length - 1];
					$('.lfca_'+i).addClass('vimeo_'+vimeoId);
					$.ajax({
						url: 'https://vimeo.com/api/v2/video/'+vimeoId+'.xml',
						method: 'GET',
						context: document.body
					}).done(function(data) {
						var data = $(data);
						var id = data.find('id').text();
						var vimeoFileUrl = data.find('thumbnail_large').text();
						$('.vimeo_'+id).find('.lfc_image img').attr('src', vimeoFileUrl);
					});
				}
			}


		}
	});
}

/*
<div class="col-sm-4 lfc_article_wrapper lfca_'+i+'">							\
	<div class="lfc_article">													\
		<a href="#">															\
			<div class="lfc_image">												\
				<img src="'+fileUrl+'" class="img-responsive">					\
			</div>																\
			<div class="lfc_title">												\
				<p class="lfc_titletitle">'+title+'</p>							\
				<p class="lfc_titleinfo">Posted on: '+pubDate+'</p>				\
			</div>																\
			<div class="lfc_text"><p>'+resume+'</p></div>						\
			<span class="btn btn-primary">View post</span>						\
		</a>																	\
	</div>																		\
</div>
*/




function initInstagram(){
	$('.instaimgs_wrapper').empty();
	$.ajax({
		type: "GET",
		dataType: "jsonp",
		cache: false,
        //url: "https://api.instagram.com/v1/users/12945741/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //url: "https://api.instagram.com/v1/tags/pyzelsurfboards/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //this is the token of pictures feed app of user @pedrosilvashaperbuddy
        url: "https://api.instagram.com/v1/users/12945741/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d",
        success: function(data) {
        	var data = data.data;
        	var iwIndex = 1;
        	$('.instaimgs_wrapper').each(function(){
        		var t = $(this);
        		var nrOfImgs = t.attr('data-nrofimgs');

        		for(var i = 0; i < nrOfImgs; i++){
        			var imgThumb = data[i].images.standard_resolution.url;
        			var imgUrl = data[i].link;
        			t.append('														\
        				<div class="it_item">										\
        				<a href="'+imgUrl+'" target="_blank">					\
        				<img src="'+imgThumb+'" class="img-responsive">		\
        				</a>													\
        				</div>														\
        				');
        		}
        		iwIndex++;
        	});

        	$('.insta_widget').each(function(){
        		var t = $(this);
        		startInstaWidget(t);
        	});
        }
      });
}





function service_Sprayslist(){

    //$('.sbl_boardslist .row').empty();

    var sprays_html = '<div class="row" style="margin-top:50px">';

    $.ajax({
    	url: sUrl+'/api/v1/art/paint?lang='+sLang,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

        //count the loops to add new rows
        var loops = 0;

        //lazy" data-original="'+img+'"

        for(var key in data) {

        	sprays_html += '<div class="col-sm-4 col-xs-12 text-center spray-paint-col">\
        	<a href="#">\
        	<img class="img-responsive center-block spray-paint-img lazy" data-original="'+data[key].image+'">\
        	<img src="/images/boardswidget_shadow_double.jpg" class="img-responsive center-block">\
        	<div class="board_info">\
        	<span class="board_name">'+data[key].name+'</span>\
        	</div>\
        	</a>\
        	</div>';

        	loops++;

            //close this row and add new row
            if( loops == 3 ){

            	sprays_html += '</div><div class="row" style="margin-top:50px">';

            	loops = 0;

            }

		}//end for

        //close row

        sprays_html += '</div>';

        $('#sprays-container').append( sprays_html );

        //lazy load images only when doc is ready
        $('document').ready(function(){

        	//console.log('doc is ready');

        	$("img.lazy").lazyload({
        		effect : "fadeIn"
        	});
        })

      });

    //open the model and show the spray..
    $(document).on('click', '#sprays-container a', function(e){
    	e.preventDefault();
    	var t = $(this);
    	var imgSrc = t.find('.spray-paint-img').attr('src');
    	var title = t.find('.board_info span').text();
    	$('.spraypimg_wrapper img').attr('src', imgSrc);
    	$('.spraypimg_wrapper_title').text(title);

    	$('#spraypreview').modal('show');

    });

    //fade
    $(document).on('mouseover', '.spray-paint-col', function(){

        //var el = $(this);

        $('.spray-paint-col').not(this).stop().animate({'opacity':.5});

        $(this).on('mouseout', function(){
        	$('.spray-paint-col').not(this).stop().animate({'opacity':1});
        })
      })

  }






  var boardModelList;
  function filterBoards(){
  	$('.sbl_boardslist .sblblboard_item').removeClass('sblblbi_visible');
  	var filterItems = $('.sblf_tabs .tab-pane');
  	var filter = '';
  	var query;
  	var checkedItemsObj = {};

  	var fiIndex = 0;
  	filterItems.each(function(){
  		var t = $(this);
  		var checkedItems = new Array();
  		var tChecked = t.find('.sblf_filtercheck:checked');
  		tChecked.each(function(){
  			var t = $(this);
  			var filterValue = '.'+t.attr('data-filtervalue');
  			checkedItems.push(filterValue);
  		});
  		if(checkedItems.length>0){
  			checkedItemsObj[fiIndex] = checkedItems;
  		} else {
  			checkedItemsObj[fiIndex] = ['none'];
  		}
  		fiIndex++;
  	});

  	function allCombinations(sets,f,context){
  		if (!context) context=this;
  		var p=[],max=sets.length-1,lens=[];
  		for (var i=sets.length;i--;) lens[i]=sets[i].length;
  			function dive(d){
  				var a=sets[d], len=lens[d];
  				if (d==max) for (var i=0;i<len;++i) p[d]=a[i], f.apply(context,p);
  				else        for (var i=0;i<len;++i) p[d]=a[i], dive(d+1);
  				p.pop();
  			}
  			dive(0);
  		}

  		allCombinations([checkedItemsObj[0],checkedItemsObj[1],checkedItemsObj[2]], function(filter1,filter2,filter3){
  			var option = filter1+''+filter2+''+filter3;
  			option = option.replace(/none/g, "");
  			filter += option+', ';
  		});

  		filter = filter.slice(0,-2);
  		query = $(filter);
  		var nrOfFilterChecked = $('.sblf_tabs .sblf_filtercheck:checked').length;
  		if(nrOfFilterChecked==0){
  			query = $('.sbl_boardslist .sblblboard_item');
  		}
  		query.each(function(){
  			var t = $(this);
  			var img = t.find('.sblbl_boardimg img');
  			var src = img.attr('data-imgsrc');
  			img.attr('src', src);
  		});
  		query.addClass('sblblbi_visible');
  	}
  	$(function(){
  		$(document).on('change', '.sblf_tabs .sblf_filtercheck', function(){
  			filterBoards();
  		});
  	});


  	var bmp_loaded = 0;
  	function boardModelPage_isLoaded(loaded){
  		bmp_loaded++;;
  		if(bmp_loaded==4){
  			$('.sblf_filtercheck:first').trigger('change');
  		}
  	}


  	function toFeet(n) {
  		return Math.floor(n / 12) + "'" + (n % 12) + '"';
  	}

  	function toInches(n){

  		return Math.ceil( n * .039 );

  	}

/*

/surfboards
gets the boards? yes - where: /surfboards

*/
function service_SurfboardModelsPage(){

    //throw new Error('died before loading boards');

	//alert('service_SurfboardModelsPage');

	$.ajax({
		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log(data);

		var loops = 0;

		var boards_html = '<!--board content goes here-->';

		boardModelList = data;
		for(var key in data) {

			// FALTA VERIFICAR SE É NEW
			var id_surfboardmodel = data[key].id_surfboardmodel;
			var model = data[key].surfboardmodel;
			var price = data[key].min_price;
			var symbol = data[key].currency.symbol;
			var iso = data[key].currency.iso;
			var img = data[key].img_303;
			var waveSize = 'ws_'+data[key].wavesize.min;
			var boardType = 'bt_'+data[key].id_surfboardmodeltype;
			var skillLevelObj = data[key].skilllevel;
			var skillLevel = '';
			for(var key in skillLevelObj) {
				skillLevel += 'sl_'+key+' ';
			}

            //if start, include row
            //if( loops == 0 ) $('.sbl_boardslist').append('row<div class="row">');

            if( loops == 0 ) boards_html += '<div class="row">';

            //browsers do not accept unclosed elements, so we must build all the html,
            //and on the end, append it..
            /*
			$('.sbl_boardslist').append('																	\
				<div class="col-sm-4 col-xs-12 sblblboard_item '+waveSize+' '+boardType+' '+skillLevel+'">		\
					<div class="sblbl_board">																	\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">																			\
							<div class="sblbl_board_top">														\
								<div href="#" class="btn btn-warning">New</div>									\
							</div>																				\
							<div class="sblbl_boardimg">														\
								<img src="" class="img-responsive" data-imgsrc="'+img+'">						\
							</div>																				\
							<div class="board_shadow">															\
								<img src="/images/boardswidget_shadow.png">										\
							</div>																				\
							<div class="board_info">															\
								<span class="board_name">'+model+'</span>										\
								<span class="board_price">'+symbol+''+price+' '+iso+'</span>						\
							</div>																				\
						</a>																					\
					</div>																						\
				</div>																							\
			');
			*/

            //show a default image if board does not exist - the designer must make one, the one bellow is no good
            //if( img == '' ) img = 'http://images.shaperbuddy.com.s3-website-us-east-1.amazonaws.com/-1/img/boardlist_avatar.png';

            // extra classes are for the filters
            boards_html += '<div class="col-sm-4 col-xs-12 sblblboard_item '+waveSize+' '+boardType+' '+skillLevel+'">		\
            <div class="sblbl_board">																	\
            <a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">																			\
            <div class="sblbl_board_top">														\
            <div href="#" class="btn btn-warning">New</div>									\
            </div>																				\
            <div class="sblbl_boardimg">														\
            <img src="" class="img-responsive" data-imgsrc="'+img+'">						\
            </div>																				\
            <div class="board_shadow">															\
            <img src="/images/boardswidget_shadow.png">										\
            </div>																				\
            <div class="board_info">															\
            <span class="board_name">'+model+'</span>										\
            <span class="board_price">'+symbol+''+price+' '+iso+'</span>						\
            </div>																				\
            </a>																					\
            </div>\
            </div>';

            //PBS: count loops to insert a new row..
            loops++;

            if( loops == 3 ){

                //if( loop == 0 )
                //$('.sbl_boardslist').append('end row</div>start row<div class="row">');

                boards_html += '</div><div class="row">';

                //reset loop counter
                loops = 0;

              }

              //console.log(loops);

        }//end for board data

        //close row
        boards_html += '</div>';

        $('.sbl_boardslist').append(boards_html);
        //$('#surfboards-placeholder').append(boards_html);

        // what happens here..?
        boardModelPage_isLoaded('board_list');
      });
}


/* /surfboards */
function service_SurfboardModelsPage_filter(){
	$('.sblf_tabs .tab-pane').empty();
	$.ajax({
		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			var waveSize = data[key].wavesize.min;
			var waveSizeMinMax = data[key].wavesize;
			if($('.sblffc_wavesize_'+waveSize).length < 1){
				$('#sblf_wavesize').append('																														\
					<label>																																			\
					<input class="sblf_filtercheck sblffc_wavesize_'+waveSize+'" type="checkbox" name="" value="" data-filtervalue="ws_'+waveSizeMinMax.min+'">	\
					'+waveSizeMinMax.min+' - '+waveSizeMinMax.max+' Ft 																							\
					</label>																																		\
					');
			}
		}
		boardModelPage_isLoaded('filter_wavesize');
	});


	$.ajax({
		url: sUrl+'/api/v1/surboardmodeltypes?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			$('#sblf_boardtype').append('																			\
				<label>																								\
				<input class="sblf_filtercheck" type="checkbox" name="" value="" data-filtervalue="bt_'+key+'">	\
				'+data[key]+' 																					\
				</label>																							\
				');
		}
		boardModelPage_isLoaded('filter_boardtype');
	});


	$.ajax({
		url: sUrl+'/api/v1/skilllevels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			$('#sblf_skilllevel').append('																			\
				<label>																								\
				<input class="sblf_filtercheck" type="checkbox" name="" value="" data-filtervalue="sl_'+key+'">	\
				'+data[key]+' 																					\
				</label>																							\
				');
		}
		boardModelPage_isLoaded('filter_skilllevel');
	});
}









var locations = new Array();

function service_Dealers(){
	var container = $('.dealers_list_inner');
	container.empty();
	$.ajax({
		url: sUrl+'/api/v1/dealers?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var loadedCountrys = new Array();
		var loadedStates = new Array();

		for(var key in data) {
			var t = data[key];
			var country = t.country;
			var countryId = t.id_country
			var state = t.state;
			var stateId = t.id_state;
			var name = t.name;
			var address = t.address;
			var phone = t.phone;
			var email = t.email;
			var lat = t.gpslat;
			var lng = t.gpslong;

			if( lat != '' ){

				var location = [];

				location['name']       = name;
				location['lat']        = lat;
				location['lng']        = lng;
				location['address']    = address;
				location['phone']      = phone;
				location['email']      = email;
				location['url']        = t.url;

				locations.push( location );

			}

			var isCountryLoaded = (loadedCountrys.indexOf(country)>-1);
			var isStateLoaded = (loadedStates.indexOf(state)>-1);
			// BUILD COUNTRY
			if(!isCountryLoaded){
				loadedCountrys.push(country);
				container.append('									\
					<div id="ct_'+countryId+'" class="dl_country country_'+countryId+'">	\
					<p class="dl_countrytitle">					\
					<span>'+country+'</span>				\
					</p>										\
					<div class="container"></div>				\
					</div>											\
					');
				$('.dealers_filter .df_country').append('<option value="'+countryId+'">'+country+'</option>');
			}
			// BUILD STATE
			if(state!= ''){
				if(!isStateLoaded){
					loadedStates.push(state);
					container.find('.country_'+countryId+' .container').append('	\
						<div class="row dl_areatitle">								\
						<div class="col-xs-12">'+state+'</div>					\
						</div>														\
						<div class="row state_'+stateId+'"></div>					\
						');
				}
			}
			//BUILD SHOPS
			var shopTarget;
			if(state!= ''){
				shopTarget = container.find('.country_'+countryId+' .container .state_'+stateId+'');
			} else {
				shopTarget = container.find('.country_'+countryId+' .container');
			}
			shopTarget.append('																							\
				<div class="col-sm-4 dl_item">																			\
				<h5>'+name+'</h5>																					\
				<p class="dli_address">'+address+'</p>																\
				<p class="dli_phone">																				\
				<label>Phone:&nbsp;</label>'+phone+'															\
				</p>																								\
				<p class="dli_email">																				\
				<label>Email:&nbsp;</label>'+email+'															\
				</p>																								\
				<a href="#" data-lat="'+lat+'" data-lng="'+lng+'" class="dli_viewonmaps" data-toggle="modal" data-target="#modal_viewonmaps">View on Google Maps</a>	\
				</div>																									\
				');
			if(phone==''){
				$('.dl_item:last .dli_phone').remove();
			}
			if(email==''){
				$('.dl_item:last .dli_email').remove();
			}
			if(lat==''){
				$('.dl_item:last .dli_viewonmaps').remove();
			}
		}

		setListItemHeight($('.dl_item'));
		setMarker(locations);

		$(window).trigger('scroll');
	});
}










function service_TeamList(){
	var container = $('.team_list .row');
	container.empty();
	$.ajax({
		url: sUrl+'/api/v1/team?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			var image = data[key].photothumb;
			var country = data[key].country;
			var name = data[key].name;
			var id = data[key].id_team;
			container.append('															\
				<div class="col-sm-4">													\
				<div class="tl_item">												\
				<a href="/team/detail.php?id='+id+'&/'+name.replace(' ','-').toLowerCase()+'">							\
				<div class="tli_img">										\
				<img src="'+image+'" class="img-responsive">			\
				</div>														\
				<div class="tli_name">'+name+'</div>						\
				<div class="tli_location">'+country+'</div>					\
				</a>															\
				</div>																\
				</div>																	\
				');
		}
		setListItemHeight($('.tl_item').parent());
	});
}





function service_TeamDetail_images(){
	var teamMemberId = getQueryString('id');
	var teamMemberSliderImgs = $('.teammember_slider .carousel-inner');
	var teamMemberSliderIndicators = $('.teammember_slider .carousel-indicators');
	teamMemberSliderImgs.empty();
	teamMemberSliderIndicators.empty();
	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'/images?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var loopI = 0;
		for(var key in data) {
			var img = data[key].url;
			teamMemberSliderImgs.append('<div class="item"><img src="'+img+'" alt="..."></div>');
			teamMemberSliderIndicators.append('<li data-target="#chilli_carousel" data-slide-to="'+loopI+'"></li>');
			loopI++;
		}
		teamMemberSliderImgs.find('.item:first').addClass('active');
		teamMemberSliderIndicators.find('.li:first').addClass('active');
	});
}


function service_TeamDetail_video(){
	var teamMemberId = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'/videos?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log( data );

		for(var key in data) {

			var description = data[key].description;
			var url = data[key].url;
			var videoId;
			var videoSource;
			var videoUrl = url;
			var isYoutube = videoUrl.indexOf('youtu') > -1;

			if(isYoutube){
				videoId = youtube_parser(videoUrl);
				videoSource = 'youtube';
			} else {
				var vimeoId = videoUrl.split('/');
				videoId = vimeoId[vimeoId.length - 1];
				videoSource = 'vimeo';
				videoUrl = 'https://player.vimeo.com/video/'+videoId;
			}

			$('.videos_carousel .carousel-inner .active .row').append('							\
				<div class="col-sm-4 vc_item_wrapper">											\
				<a href="'+videoUrl+'" class="vc_item" data-videosource="'+videoSource+'" data-id="'+videoId+'">	\
				<div class="vci_img">													\
				<img src="images/dummies/vc_videothumb.jpg" class="img-responsive">	\
				<div class="playbutton">											\
				<img src="/images/vc_playicon.png">								\
				</div>																\
				</div>																	\
				<div class="vci_title">'+description+'</div>								\
				</a>																		\
				</div>																			\
				');

		}

		setVideoPagination($('.videos_carousel'));
		setVideoProperties();
	});
}

//team details
function service_TeamDetail(){

	var teamMemberId = getQueryString('id');

	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var id_team = data.id_team;
		var name = data.name;
		var firstName = name.split(' ')[0];
		var country = data.country;
		var description = data.bio;
		var height = data.height;
		var weight = data.weight;
		var stance = data.stance_txt;
		var quiver = data.surfboardmodels;
		var quiverNrOfBoards = quiver.length;
		var socialNetworks = data.socialnetworks;
		var symbol = data.currency.symbol;
		var iso = data.currency.iso;

		$('.tli_name_main, .breadcrumb .active').html(name);
		$('.tli_location').html(country);
		$('.tli_text').html(description);
		$('.tli_firstname, .insta_widget_wrapper h1 span').html(firstName);
		$('.rider-name').html(firstName+"´s");
		$('.tli_height span').html(height);
		$('.tli_weight span').html(weight);
		$('.tli_stance span').html(stance);


		for(var key in socialNetworks){

			var id_socialnetwork = socialNetworks[key].id_socialnetwork;
			var url = socialNetworks[key].url;

			// facebook
			if(id_socialnetwork=='1'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_fb.png"></a></li>');
			}
			//twitter
			if(id_socialnetwork=='2'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_twitter.png"></a></li>');
			}
			//
			if(id_socialnetwork=='3'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_youtube.png"></a></li>');
			}
			// instagram
			if(id_socialnetwork=='4'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_insta.png"></a></li>');

				//prepare the username, like the designer wants it..
				if( url != null ){

					var url_parts = url.split('/');

					//console.log(url_parts[3]);

					$('.getsocial_subtitle').html( '<a href="'+url+'" target="_blank">@'+url_parts[3]+'</a>' );

				}

				initInstagram_team(socialNetworks[key].memberid);
			}
			// vimeo
			if(id_socialnetwork=='5'){
			}

		}


		var nrOfCols = 12/quiverNrOfBoards;
		if(quiverNrOfBoards>=4){
			nrOfCols = 4;
		}
		var quiverI=0;
		for(var key in quiver) {
			if(quiverI<4){
				var img = quiver[key].images[0].image_74;
				var model = quiver[key].surfboardmodel;
				var price = quiver[key].minprice;

				var height = quiver[key].height;
				var wide = quiver[key].wide;
				var thick = quiver[key].thick;

				var modelDesc = '<p><strong>'+model+'</strong> - '+height+' x '+wide+' x '+thick+' L</p>';

				var surfboard_model = quiver[key].id_surfboardmodel;

				$('.tli_ride').append(modelDesc);

				$('.teammember_quiver .container .row').append('												\
					<div class="col-sm-'+nrOfCols+'">															\
					<div class="sblbl_board">																\
					<a href="/boards/detail.php?id='+surfboard_model+'">																		\
					<div class="sblbl_boardimg">													\
					<img src="'+img+'" class="img-responsive">									\
					</div>																			\
					<div class="board_shadow">														\
					<img src="/images/boardswidget_shadow.png">									\
					</div>																			\
					<div class="board_info">														\
					<span class="board_name">'+model+'</span>									\
					<span class="board_price">'+symbol+''+price+' '+iso+'</span>				\
					</div>																			\
					</a>																				\
					</div>																					\
					</div>																						\
					');
			}
			quiverI++;
		}

		service_homeNews(id_team);

	});
}







function initInstagram_team(id){
	$('.instaimgs_wrapper').empty();
	$.ajax({
		type: "GET",
		dataType: "jsonp",
		cache: false,
		url: 'https://api.instagram.com/v1/users/'+id+'/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075',
        //url: "https://api.instagram.com/v1/tags/pyzelsurfboards/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        success: function(data) {

					//console.log( data );

					var data = data.data;
					var iwIndex = 1;
					$('.instaimgs_wrapper').each(function(){
						var t = $(this);
						var nrOfImgs = t.attr('data-nrofimgs');

						for(var i = 0; i < nrOfImgs; i++){
							var imgThumb = data[i].images.standard_resolution.url;
							var imgUrl = data[i].link;
							t.append('														\
								<div class="it_item">										\
								<a href="'+imgUrl+'" target="_blank">											\
								<img src="'+imgThumb+'" class="img-responsive" alt="'+data[i].caption.text+'">		\
								</a>													\
								</div>														\
								');
						}
						iwIndex++;
					});

					$('.insta_widget').each(function(){
						var t = $(this);
						startInstaWidget(t);
					});
				}
			});
}









function service_Videos(){

    //console.log( 'yo yo service video in the house!' );

    var teamMemberId = getQueryString('id');

    var videoContainer = $('.videos_carousel .carousel-inner .active .row');

    $.ajax({
    	url: sUrl+'/api/v1/cms/zones/44/objects?lang='+sLang,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

    	//console.log( data );

    	for(var key in data) {
    		var url = data[key].hpurlvideo;
    		var posted = data[key].dt_publication.en;
    		var videoId;
    		var videoSource;
    		var videoUrl = url;
    		var isYoutube = videoUrl.indexOf('youtu') > -1;

    		if(isYoutube){
    			videoId = youtube_parser(videoUrl);
    			videoSource = 'youtube';
    		} else {
    			var vimeoId = videoUrl.split('/');
    			videoId = vimeoId[vimeoId.length - 1];
    			videoSource = 'vimeo';
    			videoUrl = 'https://player.vimeo.com/video/'+videoId;
    		}

    		videoContainer.append('																						\
    			<div class="col-sm-4 vc_item_wrapper">																	\
    			<a href="'+videoUrl+'" class="vc_item" data-videosource="'+videoSource+'" data-id="'+videoId+'">	\
    			<div class="vci_img">																			\
    			<img src="" class="img-responsive">															\
    			<div class="playbutton">																	\
    			<img src="/images/vc_playicon.png">														\
    			</div>																						\
    			</div>																							\
    			<div class="vci_title">'+data[key].hptitle+'</div>																	\
    			<div class="vci_addinfo">Posted on: '+posted+'</div>											\
    			</a>																								\
    			</div>																									\
    			');
    	}

    	setVideoPagination($('.videos_carousel'));
    	setVideoProperties();
    });
  }




// ---------------------------- PRODUCTS LIST --------------------------//

// shop/boards/
//TO-DO: we need to get boards per model.. DONE
// TO-DO: get boards by length, like on JR

function service_productBoardsList(qString){
	var queryLang = "";
	if( sLang!=undefined ){
		queryLang = "&lang="+sLang;
	} 
	var url;
	
	if(qString==undefined){
		url = sUrl+'/api/v1/shop/surfboards'+queryLang;
	} else {
		url = sUrl+'/api/v1/shop/surfboards?'+qString+queryLang;
	}

	//alert(url);

	var boardListContainer = $('.shopitems_list');
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		boardListContainer.empty();

		var total_surfboards = 0;

		//for loop
		for(var key in data) {

			total_surfboards++;

			var currency = data[key].currency;
			var id = data[key].id_surfboard;
			var img = data[key].img.deck;
			var model = data[key].surfboardmodel;
			var length_inches = data[key].length_inches;
			var width_inches = data[key].width_inches;
			var thickness = data[key].thickness;
			var thickness_inches = data[key].thickness_inches;
			var volume = data[key].volume;
			if(volume!=''){
				volume = ' = '+volume+' L ';
			}
	           /* ===================================================== *
                 * 	Define se a prancha é usada, nova, team e etc...
                 * ===================================================== */
                 var boardstate = data[key].stocktype;

                 var finsystem = data[key].finsystem;
                 var fin_no = data[key].fin_no;
                 var price = data[key].price;

                 if(img == ''){
                 	//img = 'http://images.shaperbuddy.com.s3-website-us-east-1.amazonaws.com/-1/img/boardlist_avatar.png';
                 	img = "/images/boardlist_avatar.png";
                 }

                 boardListContainer.append('																																					\
                 	<div class="col-sm-4 col-xs-12">																																		\
                 	<div class="surfboards-list shopitem">																																				\
                 	<a href="/?page=shopsurfboarddetail&id='+id+'">																													\
                 	<div class="si_img">																																		\
                 	<img class="img-responsive lazy" src="/images/boardlist_avatar.png" data-original="'+img+'">																												\
                 	</div>																																						\
                 	<div class="shponlc_prodinfo">																																\
                 	<div class="shponlc_prodinfo_inner">																													\
                 	<p class="shponlcpi_prodname">'+model+'</p>																											\
                 	<p class="shponlcpi_prodprice"><span class="currency-symbol"></span>'+price+' <span class="currency-iso">'+currency.iso+'</span></p>																		\
                 	<p class="shponlcpi_proddetails">'+length_inches+' x '+width_inches+' x '+thickness_inches+' '+volume+'<br>'+finsystem+' Fin System x '+fin_no+'</p>		\
                 	<p class="shponlcpi_proddetails proddetail_state">'+boardstate+'</p>\
                 	</div>																																					\
                 	</div>																																						\
                 	</a>																																							\
                 	</div>																																								\
                 	</div>																																									\
                 	');

		}//end for?

		//console.log( total_surfboards );

		$('.slfh_results').text( total_surfboards );

		/*
		var nrOfItemsInList = $('.shopitems_list > div').length;
		if(nrOfItemsInList>5){
			$('.shopitems_list > div:eq(4)').after('													\
				<div class="col-sm-4 col-xs-12 shopitem_alternative">									\
					<div class="shopitem">																\
						<a href="/custom-order">																	\
							<div class="si_img">														\
								<img src="/images/custom-order.jpg" class="img-responsive">	\
							</div>																		\
							<div class="si_overtext">													\
								<div class="siot_text">Custom Board Order</div>							\
								<div class="btn_viewall">Start Now</div>								\
							</div>																		\
						</a>																			\
					</div>																				\
				</div>																					\
			');
		} else {
			$('.shopitems_list').append('																\
				<div class="col-sm-4 col-xs-12 shopitem_alternative">									\
					<div class="shopitem">																\
						<a href="#">																	\
							<div class="si_img">														\
								<img src="images/shoplistimg_alternetive1.jpg" class="img-responsive">	\
							</div>																		\
							<div class="si_overtext">													\
								<div class="siot_text">Custom Board Order</div>							\
								<div class="btn_viewall">Start Now</div>								\
							</div>																		\
						</a>																			\
					</div>																				\
				</div>																					\
			');
		}
		*/

		//lazy load images only when doc is ready
		$('document').ready(function(){
			$("img.lazy").lazyload({
				effect : "fadeIn"
			});
		})

		//setListItemHeight($('.shopitem').parent());

		//show no results
		if(data.length==0){
			$('.shopitems_list_noresult').show();
			$('.shopitem_alternative').hide();
		} else {
			$('.shopitems_list_noresult').hide();
			$('.shopitem_alternative').show();
		}

	});

}





//function service_productAccessoriesList(qString){
// refactoring this
function products_list(section, qString){

    	//console.log('yo yo service_productAccessoriesList');
    	var shopdetail = "accessoriesdetail";
	if( section=="accessories" ){
		//accessories
		shopdetail = "accessoriesdetail";
	}else if( section=="apparel" ){
		//clothing
		shopdetail = "appareldetail";
	}else if( section=="softgoods" ){
		//soft goods
		shopdetail = "softgoodsdetail";
	}

    var url;
    if(qString==undefined){
    	url = sUrl+'/api/v1/shop/'+section+'?lang='+sLang;
    } else {
    	url = sUrl+'/api/v1/shop/'+section+'?'+qString+'&lang='+sLang;
    }

	//var boardListContainer = $('.shopitems_list');

	var products_placeholder =  $('#products-placeholder');

	var total_products = 0;

	var html = '';

	products_placeholder.empty();

	var loops = 0;

	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//boardListContainer.empty();

        // start new row
        html = '<div class="row">';

        for(var key in data){

        	loops++;
        	total_products++;

            //console.log( loops );

            var brand = data[key].brand;
            var id_product = data[key].id_product;
            var id_brand = data[key].id_brand;
            var name = data[key].name;
            var currency = data[key].currency;
            var minprice = data[key].minprice;
            var colors = data[key].variant_colors;
            var nrOfColors = colors.length;
            var tabContent = '';
            var tabNavContent = '';
            if(nrOfColors==0){
            	var name = data[key].name;
            	var minprice = data[key].minprice;
            	var mainimg = data[key].mainimg;
            	if( mainimg=="" ){
                	mainimg = "/images/pyzel_noimage.svg";
                }
            	tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+mainimg+'" ></div>';
            	tabNavContent = '';
            } else {
            	for(var key2 in colors){
				// this is not supposed to be part of the name..
                    //var name = colors[key2].name;
                    var hexcolor = colors[key2].hexcolor;
                    var img = colors[key2].img;
                    if( img=="" ){
                    		img = "/images/pyzel_noimage.svg";
                    }
                    if(key2==0){
	                    	var firstActive = 'active in';
	                    	var firstLinkActive = 'active';
	                    	tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+img+'" ></div>';
	                    	tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                    } else {
	                    	var firstActive = '';
	                    	var firstLinkActive = '';
	                    	tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="'+img+'" data-original="" ></div>';
	                    	tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                    }
                    //tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+img+'" ></div>';
                    //tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                  }
                }

            //console.log( 'name before: '+name );
            name = name.replace(brand, '');
            //console.log( 'name after:' +name );

            //name = 'here be name';
            html +=
            '<div class="col-sm-4 col-xs-12">\
            <div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
            <a href="/index.php?page='+shopdetail+'&id='+id_product+'&shop='+section+'" data-url="/index.php?page='+shopdetail+'&id='+id_product+'&shop='+section+'">\
            <div class="tab-content">'+tabContent+'</div>\
            <div class="shponlc_prodinfo_inner">\
            <p class="shponlcpi_prodname">'+brand+' '+name+'</p>\
            <p class="shponlcpi_proddetails"></p>\
            <p class="shponlcpi_prodprice"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>\
            </div>\
            <div class="variants_nav">\
            <ul>'+tabNavContent+'</ul>\
            </div>\
            </a>\
            </div>\
            </div>';


            // close previous row and open new
            if( loops == 3 ){

            	html += '</div><div class="row">';

            	loops = 0;

            }


		} // end for

        // close open row
        html += '</div>';

        //console.log('appending: '+html);

        products_placeholder.html( html );

        // total results on side bar
        $('.slfh_results').text( total_products );

        // and this does what?
        // removes the placeholder div when no text exists..
        $('.shponlcpi_proddetails').each(function(){
        	var t = $(this);
        	var text = t.text();
        	if(text==''){
        		t.remove();
        	}
        });

		//setListItemHeight($('.shopitem').parent());

		$("img.lazy").lazyload({
			effect: "fadeIn"
		});
	});

}

// PBS: hide / show filters according to device width..
$( document ).ready( function(){

	$(window).on("load resize",function(e){

		if($(document).width() < 767 ) {

            //console.log('width is smaller than 767, so collapsing');
            $( $('.slfg_toggle').attr('href') ).collapse('hide');

          }else{

            //console.log('width is bigger than 767, so expanding');
            $( $('.slfg_toggle').attr('href') ).collapse('show');

          }

        });

})



// this could be the same function as accessories just change the end point..
// done.
function service_productApparelList(qString){

	if(qString==undefined){
		url = sUrl+'/api/v1/shop/apparel?lang='+sLang;
	} else {
		url = sUrl+'/api/v1/shop/apparel?'+qString+'&lang='+sLang;
		console.log( sUrl );
	}

	var boardListContainer = $('.shopitems_list');
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		boardListContainer.empty();

		for(var key in data){
			var id_product = data[key].id_product;
			var id_brand = data[key].id_brand;

			var mainName = data[key].name;
			var currency = data[key].currency;
			var minprice = data[key].minprice;


			var colors = data[key].variant_colors;
			var nrOfColors = colors.length;
			var tabContent = '';
			var tabNavContent = '';

			if(nrOfColors==0){
				var name = data[key].name;
				var minprice = data[key].minprice;
				var mainimg = data[key].mainimg;
				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
				tabNavContent = '';
			} else {
				for(var key2 in colors){
					var name = colors[key2].name;
					var hexcolor = colors[key2].hexcolor;
					var img = colors[key2].img;


					if(key2==0){
						var firstActive = 'active in';
						var firstLinkActive = 'active';
					} else {
						var firstActive = '';
						var firstLinkActive = '';
					}
					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
				}
			}



			boardListContainer.append('																																					\
				<div class="col-sm-4 col-xs-12">																																		\
				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">																				\
				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel">						\
				<div class="si_img">																																		\
				<div class="tab-content">'+tabContent+'</div>																											\
				</div>																																						\
				<div class="shponlc_prodinfo">																																\
				<div class="shponlc_prodinfo_inner">																													\
				<p class="shponlcpi_prodname">'+mainName+'</p>																										\
				<p class="shponlcpi_proddetails"></p>																												\
				<p class="shponlcpi_prodprice"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>						\
				</div>																																					\
				<div class="variants_nav">																																\
				<ul>'+tabNavContent+'</ul>																															\
				</div>																																					\
				</div>																																						\
				</a>																																							\
				</div>																																								\
				</div>																																									\
				');
		}


		$('.shponlcpi_proddetails').each(function(){
			var t = $(this);
			var text = t.text();
			if(text==''){
				t.remove();
			}
		});


		setListItemHeight($('.shopitem').parent());
	});
}

// -------------------------- end PRODUCTS LIST ------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//

// /shop/surfboards and others..
// mainly it builds the filters, then call products of X category..

function service_productBoardsListFilter(shop){	

	var url;
	if( shop == 'boards' || shop == 'garage' ){
		url = sUrl+'/api/v1/shop/surfboards/filters?lang='+sLang;
	} else if(shop=='apparel'){
		url = sUrl+'/api/v1/shop/apparel/filters?lang='+sLang;
	} else if(shop=='accessories'){
		url = sUrl+'/api/v1/shop/accessories/filters?lang='+sLang;
	}else if(shop=='softgoods'){
		url = sUrl+'/api/v1/shop/softgoods/filters?lang='+sLang;
	}

	/*else if( shop == 'garage' ){

		url = sUrl+'/api/v1/shop/surfboards/filters?id_used_state=1&lang='+sLang;

	}*/
	
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var filterListContainer = $('.slf_filterlist');
		var rangeValueItems = new Array('6', '7', '11');
		var flcIndex = 1;

		for(var key in data){
			
			// disable price filter for now
			if( data[key].id == 11 ){
				
				continue;

			} 

			var id = data[key].id;
			var filterName = data[key].name;
			var filterVar = data[key].var;
			var filterItems = data[key].item;
			var itemsufix = data[key].itemsufix;
			
			if(itemsufix==undefined){
			
				itemsufix = '';

			}

			filterListContainer.append('																							\
				<div class="slf_group">																								\
				<a class="slfg_toggle" role="button" data-toggle="collapse" href="#collapse'+flcIndex+'" aria-expanded="true">	\
				<div class="slfg_toggle_inner">'+filterName+'</div>															\
				</a>																											\
				<div class="slfg_items collapse in" id="collapse'+flcIndex+'">													\
				<div class="slfg_items_inner" data-filterdataname=""></div>													\
				</div>																											\
				</div>																												\
				');

			var isRangeItem = rangeValueItems.indexOf(id);

            //console.log( 'isRangeItem: '+isRangeItem );

            if(isRangeItem>-1){

            	var rangeMin = filterItems.min;
            	var rangeMax = filterItems.max;
            	filterVar = filterVar.split(',');
            	$('.slf_group:last').find('.slfg_items_inner').append('														\
            		<label>																									\
            		<div class="row filterrange_preview">																\
            		<div class="col-xs-4 frp_col1">																	\
            		<input class="filterdata fr_min" type="text" name="'+filterVar[0]+'" value="" readonly>		\
            		<input class="fr_display fr_min_display" id="fr-min-display-'+id+'" value="" readonly>									\
            		</div>																							\
            		<div class="col-xs-4 frp_col2">TO</div>															\
            		<div class="col-xs-4 frp_col3">																	\
            		<input class="filterdata fr_max" type="text" name="'+filterVar[1]+'" value="" readonly>		\
            		<input class="fr_display fr_max_display" id="fr-max-display-'+id+'" value="" readonly>									\
            		</div>																							\
            		</div>																								\
            		<div class="filterrange_'+id+' filterrange" data-min="'+rangeMin+'" data-max="'+rangeMax+'"></div>	\
            		</label>																								\
            		');

            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filtertype', 'range');
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname', filterVar);
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname_min', filterVar[0]);
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname_max', filterVar[1]);
            	startBoardSizeSlider('filterrange_'+id+'', rangeMin, rangeMax);

            } else {

            	if( filterName=='By Sport' ){
            		$.each( filterItems, function( key, value ){

            			$('.slf_group:last').find('.slfg_items_inner').append('														\
            				<label data-itemsufix="'+itemsufix+'">																									\
            				<input class="sblf_filtercheck filterdata" type="radio" name="'+filterVar+'" value="'+key+'">	\
            				'+filterItems[key]+' 																				\
            				</label>																								\
            				');

            		})
            	}else{

            		$.each( filterItems, function( key, value ){

            			$('.slf_group:last').find('.slfg_items_inner').append('														\
            				<label data-itemsufix="'+itemsufix+'">																									\
            				<input class="sblf_filtercheck filterdata" type="checkbox" name="'+filterVar+'" value="'+key+'">	\
            				'+filterItems[key]+' 																				\
            				</label>																								\
            				');

            		})
            	}    

            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filtertype', 'list');
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname', filterVar);

            }

            flcIndex++;
          }

          $('.slfg_items_inner input[name=id_finsystem_nr]').parent().append(' - Fins');


          if(isMobile){
          	$('.slf_filterlist .slfg_toggle').trigger('click');
          }

          //try to mark the id_producttag of the board as selected if in url query string
		var id_producttag = getQueryString('id_producttag');
		var id_producttag_split = id_producttag.split(",");

		if( id_producttag != '' ){
			$('.filterdata[name="id_producttag"]').prop('checked', false);

			for (key in id_producttag_split){
	        		if( id_producttag_split[key] != '' ){
	        			$('.filterdata[name="id_producttag"][value="'+id_producttag_split[key]+'"]').prop('checked', true);
	        		}	
	        	}
		//	$('.filterdata[name=id_producttag][value="'+id_producttag+'"]').attr('checked',true)
		}

		//try to mark the model of the board as selected if in url query string
		var board_model = getQueryString('model');

		if( board_model != '' ){
			$('.filterdata[name=id_surfboardmodel][value="'+board_model+'"]').attr('checked',true)
		}

		//try to mark the brand of the board as selected if in url query string
		var _id_brand = getQueryString('id_brand');

		if( _id_brand != '' ){
			$('.filterdata[name=id_brand][value="'+_id_brand+'"]').attr('checked',true)
		}

		//try to mark the model of the board as selected if in url query string
		var board_sport = getQueryString('sport');

		if( board_sport != '' ){
			$('.filterdata[name=id_sport][value="'+board_sport+'"]').attr('checked',true)
		}		

        //PBS: try to mark the technology of the board aas selected if in url query string
        var technology = getQueryString('technology');

        if( technology != '' ){
        	$('.filterdata[value="'+technology+'"]').attr('checked',true)
        }

        // usedstate
        var id_usedstate = getQueryString('id_usedstate');
        var id_usedstate_split = id_usedstate.split(",");

        if( id_usedstate != "" ){
        	$('.filterdata[name="id_usedstate"]').prop('checked', false);

        	for (key in id_usedstate_split){
        		if( id_usedstate_split[key] != '' ){
        			$('.filterdata[name="id_usedstate"][value="'+id_usedstate_split[key]+'"]').prop('checked', true);
        		}	
        	}
        }else{
	  	// 02.08.2016: set as default new surfboards..
	  	$('[name="id_usedstate"]:input[value="0"]').prop( 'checked', true );
	  }

        // set length
        var length = getQueryString('length');

        if( length != '' ){

        	var length_inches = toInches( length );
            //var length_feet = toFeet( length );

            startBoardSizeSlider( "filterrange_6", window.rangeMin, window.rangeMax, length_inches, length_inches );
            //startBoardSizeSlider( "filterrange_6", 50, 50 );

          }

        	//this sets the filter, does stuff, and then call all the boards..
		//defined at shop_boards.js
		getStandarDimensionsFilter();

		//service_setFilterProperties();

	});


}


// --------------------------  PRODUCTS DETAIL -------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//

function setProductImgs(imgArray){

	// --- IMG VIEWR
	var imgs = imgArray;
	$('.sld_imgviewr .tab-content').empty();
	$('.sld_imgviewr .sld_imgviewr_thumbswrapper').empty();
	var imgLoopI = 1;
	var imgSize = $("#carousel-surfboard-detail .item.active").length;
	$("#carousel-surfboard-detail .carousel-indicators li").remove();
	for(var key in imgs){
		//var imgUrl = imgs[key].url;
		var imgUrl = imgs[key].img_dynamic;
		if( imgLoopI == 1 && imgSize == 0 ){
			// add imagem no carousel (active)
			$("#carousel-surfboard-detail .carousel-inner").html('\
					<div class="item active">\
				      	<img src="'+imgUrl+'" alt="Image" class="img-responsive image-larger-100">\
			      	</div>');
			// add indicator no carousel (active)
			$("#carousel-surfboard-detail .carousel-indicators").append('<li data-target="#carousel-surfboard-detail" data-slide-to="'+imgLoopI+'" class="active"></li>');
		}else{
			// add imagem no carousel
			$("#carousel-surfboard-detail .carousel-inner").append('\
					<div class="item">\
				      	<img src="'+imgUrl+'" alt="Image" class="img-responsive image-larger-100">\
			      	</div>');
			// add indicator no carousel
			$("#carousel-surfboard-detail .carousel-indicators").append('<li data-target="#carousel-surfboard-detail" data-slide-to="'+imgLoopI+'" class=""></li>');
		}
		imgLoopI++;
	}

	if( $(".sld_imgviewr .item").length==1 ){
		$(".sld_imgviewr .carousel-control").hide();
		$(".sld_imgviewr .carousel-indicators").hide();
	}

	$('.sld_imgviewr .tab-content .tab-pane:first').addClass('active');
	$('.sld_imgviewr .tab-content .tab-pane:first').addClass('in');

/*
	var allThumbs = $('.sld_imgviewr_thumbswrapper img');
	var nrOfItems = allThumbs.length;
	var loadedImgs = 0;
	allThumbs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfItems){
			verticalCenterThumbs();
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});
*/

	$(window).resize(function(){
		verticalCenterThumbs();
	});

	function verticalCenterThumbs(){
		var imgViewrHeight = $('.sld_imgviewr').height();
		var imgViewrthumbswrapper = $('.sld_imgviewr_thumbswrapper').height();
		var thumbsCenter = (imgViewrHeight/2)-(imgViewrthumbswrapper/2);
		$('.sld_imgviewr_thumbswrapper').stop().animate({ 'margin-top': thumbsCenter });
	}
	// --- end IMG VIEWR

}


function setOtherProducts(otherproducts) {

	if ( otherproducts == '' || otherproducts == undefined  ){
		$('.youmaybeinterested').empty();
	}
	
	//console.log( otherproducts );

	$('.ymbi_prodlist > .container > .row').empty();
	for(var key in otherproducts){
		var id = otherproducts[key].id;
		var id_producttypeOther = otherproducts[key].id_producttype;
		var id_variant = otherproducts[key].id_variant;
		var id_type = otherproducts[key].id_type;
		var name = otherproducts[key].name;
		var price = otherproducts[key].price;
		var img = otherproducts[key].img;
		var product_type = otherproducts[key].producttype.toLowerCase();

		//trick..
		if( product_type == 'surfboard' ) product_type = 'surfboards';

		//must get category of this product..
		$('.ymbi_prodlist > .container > .row').append('															\
			<div class="col-sm-2 col-xs-6">																			\
			<div class="shopitem">																				\
			<a href="/shop/'+product_type+'/detail.php?id='+id+'&shop='+product_type+'">																						\
			<div class="si_img">																		\
			<img src="'+img+'" class="img-responsive">												\
			</div>																						\
			<div class="shponlc_prodinfo">																\
			<div class="shponlc_prodinfo_inner">													\
			<p class="shponlcpi_prodname">'+name+'</p>											\
			<p class="shponlcpi_prodprice">$'+price+' <span class="currency">AUD</span></p>		\
			</div>																					\
			<div href="#" data-prdid="'+id+'" class="btn-addtocart addtocart addtocart_singleqty" data-id_product="'+id+'" data-id_producttype="'+id_producttypeOther+'" data-variant="">Add To Cart</div>		\
			</div>																						\
			</a>																							\
			</div>																								\
			</div>																									\
			');
	}
}

function service_productBoardsList_detail(){

	var boardId = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/'+boardId,
		method: 'GET',
		context: document.body
	}).done(function(data) {		

		console.log( 'data' );
		console.log( data );

		//console.log( 'webprice' );
		//console.log( data[0].webprice );

		//console.log( typeof data[0].webprice );

		//console.log( 'new stuff really new. really. really. oh rly?' );

		//console.log( typeof data[0].webprice );

		if( data == '' || ( typeof data[0].webprice !== 'undefined' && data[0].webprice == "" ) ){		
			
			$('#board-description-col').remove();

			var modal = '\
			<div class="modal fade" tabindex="-1" role="dialog" id="error-modal">\
  				<div class="modal-dialog" role="document">\
    				<div class="modal-content">\
      					<div class="modal-header">\
      						<h4 class="modal-title">Error</h4>\
      					</div>\
      					<div class="modal-body text-center">\
      						Selected board is not available at the moment.\
      					</div>\
      					<div class="modal-footer">\
        					<a href="/?page=shopsurfboard" class="btn btn-default">See other boards</a>\
      					</div>\
      				</div>\
      			</div>\
      		</div>';

      		$('body').append( modal );

      		$('#error-modal').modal({
      		
      			backdrop: 'static',
    			keyboard: false,
    			show:	  true

      		});

			throw new Error('Selected board is not available at the moment.');

		}

		var id_surfboard = data[0].id_surfboard;
		var id_producttype = data[0].id_producttype;
				
		var imgs = data[0].img;		

		console.log( imgs );

		// if no product images, do some trick..
		//console.log( 'imgs.length:' );
		//console.log( imgs.length );
		
		if( imgs != '' ){

			// show controls if image exists
			$('#surfboard-carousel-controls').removeClass('hidden');
			console.log('removed hidden class??');

		}else{

			console.log('no images are defined for this board');
			// try to load default images from model

		}
		
		var boardName = data[0].surfboardmodel;
		var boardPrice = data[0].price;
		var currency_iso = data[0].currency.iso;
		var currency_symbol = data[0].currency.symbol;
		var promo = data[0].promo;
		var boardSize = data[0].length_inches;
		var boardWidth = data[0].width_inches;
		var boardThickness = data[0].thickness_inches;
		var boardVolume = data[0].volume;
		var tailShape = data[0].tailname;
		var finSystem = data[0].finsystem +' '+ data[0].finsystemoption +' '+ data[0].fin_no +'fin setup';

		// show link if electralite
		if( data[0].id_surfboardconstructiontype == 818 )
			var construction = '<a href="/?page=technology&id=647&electralite-surfboards">'+data[0].surfboardconstructiontype+'</a>';
		else
			var construction = data[0].surfboardconstructiontype;			

		var glassing = data[0].glassing;
		var condition = data[0].condition;
		var waveSize = data[0].wh_min +' - '+ data[0].wh_max +' '+ data[0].wh_measure;
		// ---
		var skillLevel = data[0].skilllevel;
		var skillLevelString = '';
		for(var key in skillLevel){
			skillLevelString += skillLevel[key]+', ';
		}
		skillLevelString = skillLevelString.slice(0, -2);
		// ---
		var waveType = data[0].wavetype_txt;
		var locationName = data[0].location.name;
		var locationAddress = data[0].location.address;
		var locationCountry = data[0].location.country;
		var locationLat = data[0].location.gpslat;
		var locationLng = data[0].location.gpslong;
		var description = data[0].description;
		var paymentSecurity = data[0].payment_security_txt;
		var shippingText = data[0].shipping_txt;
		var otherproducts = data[0].otherproducts;
	     /* ======================================================= *
           * 	Define se a prancha é usada, nova, team e etc...
           * ======================================================= */
           var boardstate = data[0].stocktype;

           if(id_producttype=='1' || id_producttype=='4'){
           	$('.sldi_addtocart .addproduct_qty').prop('readonly', true).val(1);
           }

           $('.pp_currencysymbol').html(currency_symbol);
           $('.pp_currencyiso').html(currency_iso);
		
		setProductImgs(imgs);

		//alert('ranholas??');

		if( boardName!='' ){
			$('.breadcrumb .active').html(boardName+' '+boardSize);
		}
		
		$('.prod_top').html('ID '+id_surfboard);
		$('.prod_title').html(boardName);
		$('.prod_title_size').html(boardSize);
		$('.pprice_value').html(boardPrice);
		$('.prod_state_title').html(boardstate);

		$('.promo_wrapper').empty();

		for(var key in promo){
			var id = key;
			var text = promo[key];
			if(id!='-1'){
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/images/icon_'+id+'.jpg);">'+text+'</p>');
			} else {
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/assets/img/icon_45667.jpg);">'+text+'</p>');
			}
		}
		$('.bd_size').html(boardSize);
		$('.bd_width').html(boardWidth);
		$('.bd_thickness').html(boardThickness);
		if( boardVolume!='' ){
			$('.bd_volume').html(boardVolume+' L');
		}
		$('.bf_tailshape span').html(tailShape);
		$('.bf_finsystem span').html(finSystem);
		$('.bf_construction span').html(construction);
		$('.bf_glassing span').html(glassing);
		$('.bf_condition span').html(condition);
		$('.bf_wavesize span').html(waveSize);
		$('.bf_skilllevel span').html(skillLevelString);
		$('.bf_wavetype span').html(waveType);
		$('.sld_stocklocation strong').html(locationName);
		$('.sld_stocklocation .sldsl_text').html(locationAddress);
		$('.sld_stocklocation .sldsl_text').append('<br>'+locationCountry+'<br><br>');
		$('.sld_stocklocation a').attr('href', 'https://www.google.com/maps/dir/Current+Location/'+locationLat+','+locationLng); //https://www.google.com/maps/dir/Current+Location/'+locationLat+','+locationLng
		$('.sld_description .sldd_text').html(description);
		$('.sld_paymentandsecurity .sldps_text').html(paymentSecurity);
		$('.sld_shipping .sldshipping_text').html(shippingText);

		//$('ol.breadcrumb li.board_name a').attr('href', '/shop/boards/?model='+id_surfboardmodel);

		setOtherProducts(otherproducts);

        //$('.sldi_addtocart .addtocart').attr('data-id_product', id_surfboard);
        //$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);

        // PBS: work here
        $('#btn-add-to-cart').attr('data-id_product', id_surfboard);
        $('#btn-add-to-cart').attr('data-id_producttype', id_producttype);

        var is_on_cart = $.grep( surfboards_id_on_cart, function( value ){

        	return value == boardId;

        })

        if( is_on_cart.length > 0 ){

        	var el = $("#btn-add-to-cart[data-id_product='" + is_on_cart + "']");

        	var string_addedtocart = "ADDED TO CART";
        	if( sLang=="pt" ) string_addedtocart = "ADICIONADO AO CARRINHO";
        	
        	el.html('<i class="glyphicon glyphicon-ok"></i> '+string_addedtocart);
        	el.addClass('disabled');

        }else if( $("#btn-add-to-cart").hasClass('disabled') ){

        	var el = $("#btn-add-to-cart");

        	el.removeClass('disabled');
        	el.html('<i class="glyphicon glyphicon-shopping-cart"></i> ADD TO CART');

        }

        if(construction==''){
        	$('.bf_construction').hide();
        }
        if(glassing==''){
        	$('.bf_glassing').hide();
        }
        if(condition==''){
        	$('.bf_condition').hide();
        }
      });
}














function service_productAccessories_detail(){

    //console.log('service_productAccessories_detail()');

    var variantsData;
    var id_product;
    var id_producttype;

    $(document).on('click', '.vc_innactive', function(e){
    	e.preventDefault();
    })
    	$(document).on("click", ".variant_container ul li a:not(.vc_innactive)", function(e){
    	e.preventDefault();
    	var t = $(this);
    	var vContainer = t.closest('.variant_container');
    	var id_variant = '';
    	var old_price = '';
    	var price = '';
    	var matchFound_hascomb = false;
    	var matchFound_findcomb = false;
    	vContainer.find('.v_selected').removeClass('v_selected');
    	t.addClass('v_selected');
    	var activeV1 = $('.vc_1 ul li a.v_selected').parent().attr('data-id');
    	var activeV2 = $('.vc_2 ul li a.v_selected').parent().attr('data-id');
    	var activeV3 = $('.vc_3 ul li a.v_selected').parent().attr('data-id');
    	if(activeV1 == undefined){
    		activeV1 = '';
    	}
    	if(activeV2 == undefined){
    		activeV2 = '';
    	}
    	if(activeV3 == undefined){
    		activeV3 = '';
    	}
    	for(var key in variantsData){
    		var variant1 = variantsData[key].variant1;
    		var variant2 = variantsData[key].variant2;
    		var variant3 = variantsData[key].variant3;

    		if(activeV1==variant1 && activeV2==variant2 && activeV3==variant3){
    			id_variant = variantsData[key].id_variant;
    			matchFound_hascomb = true;

    			old_price = variantsData[key].old_price;
    			price = variantsData[key].price;
    			break;
    		}
    	}

    	if(matchFound_hascomb){
    		for(var key in variantsData){
    			var curr_id_variant = variantsData[key].id_variant;
    			if(curr_id_variant == id_variant){
    				var variantImgs = variantsData[key].img;
    				matchFound_findcomb = true;
    				break;
    			}
    		}
    		if( $("#carousel-surfboard-detail .item.active").length>0 ){
    			$("#carousel-surfboard-detail .item").remove();
    		}
    		setProductImgs(variantImgs);
    		$('.pprice_value').html(price);
    		$('.pp_oldprice').html(old_price);
    		if(old_price==''){
    			$('.oldprice_wrapper').hide();
    		} else {
    			$('.oldprice_wrapper').show();
    		}

            /*
			$('.sldi_addtocart .addtocart').attr('data-id_product', id_product);
			$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);
			$('.sldi_addtocart .addtocart').attr('data-variant', id_variant);
			*/

			$('#btn-add-to-cart').attr('data-id_product', id_product);
			$('#btn-add-to-cart').attr('data-id_producttype', id_producttype);
			$('#btn-add-to-cart').attr('data-variant', id_variant);

		}

		// ---------- FILTER AVAILABLE COMBINATIONS ------------- //
		var variantNr = t.closest('.variant_container').attr('data-variant');
		if(variantNr=='1'){
			var variantAvailableArray = new Array();
			for(var key in variantsData){
				var lVariant1 = variantsData[key].variant1;
				if(lVariant1==activeV1){
					if(variantAvailableArray.indexOf(variantsData[key].variant2)<0){
						variantAvailableArray.push(variantsData[key].variant2);
					}
					if(variantAvailableArray.indexOf(variantsData[key].variant3)<0){
						variantAvailableArray.push(variantsData[key].variant3);
					}
				} else {
					continue;
				}
			}

			$('.vc_2 ul li a').addClass('vc_innactive');
			$('.vc_3 ul li a').addClass('vc_innactive');;
			$('.vc_2 ul li a, .vc_3 ul li a').each(function(){
				var t = $(this);
				var tVariantName = t.parent().attr('data-id');
				var tVariantAvailable = variantAvailableArray.indexOf(tVariantName);
				if(tVariantAvailable>-1){
					t.removeClass('vc_innactive');
				}
			});

			var vc2_isSelectedInnactive = $('.vc_2 ul li a.v_selected.vc_innactive').length;
			var vc3_isSelectedInnactive = $('.vc_3 ul li a.v_selected.vc_innactive').length;

			if(vc2_isSelectedInnactive>0){
				$('.vc_2 ul li a:not(.vc_innactive)').first().trigger('click');
			}
			if(vc3_isSelectedInnactive>0){
				$('.vc_3 ul li a:not(.vc_innactive)').first().trigger('click');
			}
		}
		// -------- end FILTER AVAILABLE COMBINATIONS ----------- //

	});

    var boardId = getQueryString('id');
    var shop = getQueryString('shop');

    $('.bc_shop').text(shop);
    if(shop=='apparel'){
    	$('.bc_shop').attr('href', '/index.php?page=shopappareldetail&lang='+sLang+'' );
    } else {
    	$('.bc_shop').attr('href', '/index.php?page=shopaccessoriesdetail&lang='+sLang+'');
    }

    $.ajax({
    	url: sUrl+'/api/v1/shop/'+shop+'/'+boardId,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

        //console.log( data[0] );

		if( data == '' ){							

			var modal = '\
			<div class="modal fade" tabindex="-1" role="dialog" id="error-modal">\
  				<div class="modal-dialog" role="document">\
    				<div class="modal-content">\
      					<div class="modal-header">\
      						<h4 class="modal-title">Error</h4>\
      					</div>\
      					<div class="modal-body text-center">\
      						Selected product is not available at the moment.\
      					</div>\
      					<div class="modal-footer">\
        					<a href="javascript:history.go(-1)" class="btn btn-default">See other products</a>\
      					</div>\
      				</div>\
      			</div>\
      		</div>';

      		$('body').append( modal );

      		$('#error-modal').modal({
      		
      			backdrop: 'static',
    			keyboard: false,
    			show:	  true

      		});

			throw new Error('Selected product is not available at the moment.');

		}        

        var brand = data[0].brand;

        var name = data[0].name.replace(brand, '');
        var currency_symbol = data[0].currency.symbol;
        var currency_iso = data[0].currency.iso;
        var description = data[0].description;
        var spec = data[0].spec;
        var paymentSecurity = data[0].payment_security_txt;
        var shippingText = data[0].shipping_txt;
        var promo = data[0].promo;
        var otherproducts = data[0].otherproducts;
        var videos = data[0].videos;

        var variantColorsSize = data[0].variant_colors.length;

        if(variantColorsSize==0){
        	var old_price = data[0].old_price;
        	var price = data[0].minprice;
        	$('.pprice_value').html(price);
        	$('.pp_oldprice').html(old_price);
        	if(old_price==''){
        		$('.oldprice_wrapper').hide();
        	} else {
        		$('.oldprice_wrapper').show();
        	}
        }

        var variantImgs = data[0].variants[0].img;
        setProductImgs(variantImgs);

        var id_product = data[0].id_product;
        var id_producttype = data[0].id_producttype;
        var id_variant = data[0].variants[0].id_variant;

        /*
		$('.sldi_addtocart .addtocart').attr('data-id_product', id_product);
		$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);
		$('.sldi_addtocart .addtocart').attr('data-variant', id_variant);
		*/

		$('#btn-add-to-cart').attr('data-id_product', id_product);
		$('#btn-add-to-cart').attr('data-id_producttype', id_producttype);
		$('#btn-add-to-cart').attr('data-variant', id_variant);

		$('.breadcrumb .active a').html(name);
		$('.prod_title').html(brand+' '+name);
		$('.pp_currencysymbol').html(currency_symbol);
		$('.pp_currencyiso').html(currency_iso);

		$('.sld_description .sldd_text').html(description);
		$('.sld_description .sldspec_text').html(spec);

		if(description==''){
			$('.sldd_text_wrapper').hide();
		}

		if(spec==''){
			$('.sldspec_text_wrapper').hide();
		}

		$('.sld_paymentandsecurity .sldps_text').html(paymentSecurity);
		$('.sld_shipping .sldshipping_text').html(shippingText);

		for(var key in promo){
			var id = key;
			var text = promo[key];
			if(id!='-1'){
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(images/icon_'+id+'.jpg);">'+text+'</p>');
			} else {
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/assets/img/icon_45667.jpg);">'+text+'</p>');
			}
		}
		setOtherProducts(otherproducts);

		var videoLoopI = 0;

		for(var key in videos) {
			if(videoLoopI==-1){
				break;
			}
			var url = videos[key];
			var videoId;
			var videoSource;
			var videoHtml;
			var videoUrl = url;
			var isYoutube = videoUrl.indexOf('youtu') > -1;

			if(isYoutube){
				videoId = youtube_parser(videoUrl);
				videoSource = 'youtube';
			} else {
				var vimeoId = videoUrl.split('/');
				videoId = vimeoId[vimeoId.length - 1];
				videoSource = 'vimeo';
				videoUrl = 'https://player.vimeo.com/video/'+videoId;
			}

			if(videoSource=='vimeo'){
				videoHtml = '<iframe src="https://player.vimeo.com/video/'+videoId+'" width="90%" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			} else if(videoSource=='youtube'){
				videoHtml = '<iframe width="90%" height="315" src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
			}
			$('.sld_videoviewr').append(videoHtml);

			videoLoopI++;
		}

		variantsData = data[0].variants;

		var variantNames = data[0].variant_names;
		var variantsList = new Array();
		var nrOfVariants;
		var vli = 1;

        //console.log( variantNames );

        // defines the type of variants: size, color..
        for(var key in variantNames){
        	var variantName = variantNames[key].name;
        	var variantId = variantNames[key].id;
        	if(variantName != ''){
        		variantsList.push(variantName);
        		$('.vc_'+vli).addClass('vc_active');
        		$('.vc_'+vli).find('.variant_name').text(variantName);
        		switch(variantId) {
        			case '1':
        			$('.vc_'+vli).addClass('variant_colors_wrapper');
        			break;
        			case '2':
        			$('.vc_'+vli).addClass('variant_size_wrapper');
        			break;
        			default:
        			$('.vc_'+vli).addClass('variant_misc_wrapper');
        		}
        	}
        	vli++;
		}// end for


		nrOfVariants = variantsList.length;


        // what happens here..?
        for(var key in variantsData){

            //console.log( variantsData );

            var variant1 = variantsData[key].variant1;
            var variant1_id_type = variantsData[key].variant1_id_type;
            var variant1_type = variantsData[key].variant1_type;
            var hexcolor = variantsData[key].hexcolor;

            //console.log( hexcolor );

            if(variant1_id_type != ''){
            	var variantExist = $('.vc_1').find('ul li[data-id="'+variant1+'"]').length;
            	if(variantExist == 0){

                    if( variant1_id_type != 2 ) // NOT size - apply background color
                    	$('.vc_1').find('ul').append('<li data-id="'+variant1+'"><a href="#" style="background-color:'+hexcolor+';" >'+variant1+'</a></li>');
                    else // size - DON´T apply background..
                    	$('.vc_1').find('ul').append('<li data-id="'+variant1+'"><a href="#">'+variant1+'</a></li>');
                  }
                }
              }

              for(var key in variantsData){

              	var variant2 = variantsData[key].variant2;
              	var variant2_id_type = variantsData[key].variant2_id_type;
              	var variant2_type = variantsData[key].variant2_type;

              	if(variant2_id_type != ''){
              		var variantExist = $('.vc_2').find('ul li[data-id="'+variant2+'"]').length;
              		if(variantExist == 0){
              			$('.vc_2').find('ul').append('<li data-id="'+variant2+'"><a href="#">'+variant2+'</a></li>');
              		}
              	}
              }

              for(var key in variantsData){
              	var variant3 = variantsData[key].variant3;
              	var variant3_id_type = variantsData[key].variant3_id_type;
              	var variant3_type = variantsData[key].variant3_type;

              	if(variant3_id_type != ''){
              		var variantExist = $('.vc_3').find('ul li[data-id="'+variant3+'"]').length;
              		if(variantExist == 0){
              			$('.vc_3').find('ul').append('<li data-id="'+variant3+'"><a href="#">'+variant3+'</a></li>');
              		}
              	}

              }

              var initV1_value = variantsData[0].variant1;
              var initV2_value = variantsData[0].variant2;
              var initV3_value = variantsData[0].variant3;

              $('.vc_1').find('ul li[data-id="'+initV1_value+'"] a').trigger('click');
              $('.vc_2').find('ul li[data-id="'+initV2_value+'"] a').trigger('click');
              $('.vc_3').find('ul li[data-id="'+initV3_value+'"] a').trigger('click');
              $('.vc_1').find('ul li[data-id="'+initV1_value+'"] a').trigger('click');

              var selectedColor = getQueryString('variantcolor');
              $('.vc_1').find('ul li[data-id="'+selectedColor+'"] a').trigger('click');

            });

} // end get product detail

// --------------------------  PRODUCTS DETAIL -------------------------//


// ----- GET ----- //

// PBS: used at checkout.php and the popover
// which is not a good practise..
// added step var to knwo where we are

// store the id of boards to mark the button on the details page as "added to cart"
var surfboards_id_on_cart = [];

// create an object to store cart info to use elsewhere
var cart_info = {};
//cart_info.shipping_country_code = '';

//alert('no credentials v3');

function service_GetCart( step ){

	//alert();

	console.log('getting cart at step: '+step);

    //console.log('service_GetCart for the checkout.php and popover');    

    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
    	method: 'GET',
    	// using cookies may make the bellow unnecessary
    	// FIXME
    	// it is still needed - the API does not work well only with token
    	// the issue is that when adding the item to the cart, the token was not sent..
    	/*
        xhrFields: {
        	withCredentials: true
        },
        beforeSend: function(xhr){
        	xhr.withCredentials = true;
        },
        */
        crossDomain: true,
        context: document.body

      }).done(function(data) {

        //console.log( data );

        // set cookie if no token
        if( Cookies.get('token') == "" ){

            console.log('setting token: '+'/'+data.token);
            Cookies.set('token', '/'+data.token );

        }

        var currency = data.currency;
        var id_cart = data.id_cart;
        var shipping = data.shipping;
        var shipping_text = data.shipping_text;
        var shipping_alt_text = data.shipping_alt_text;
        var subtotal = data.subtotal;
        var tax = data.tax;
        var total = data.total;
        var items = data.items;
        var nrOfItems = items.length;
        var promoCodes = data.promocodes;
        var totalQty = 0;
        var totalgiftvouchers = data.totalgiftvouchers;
        var discount = data.discount;

        $('.cos_products').empty();
        $('.cpl_body').empty();
        $('.cci_insertedpromocodes').empty();


        $('.cos_products').attr('id', 'cart_'+id_cart);
        $('.cos_products').attr('data-id_cart', id_cart);
        $('.cos_totalprice .ccirr_currency').html(currency.symbol);
        $('.cos_totalprice .ccirr_totalprice').html(total.toFixed(2));

		//currency iso and symbol
		$('.currency-symbol').text(currency.symbol);
		$('.currency-iso').text(currency.iso);

        //$('#payment-row').text(data.payment_gateway);

        window.payment_gateway = data.payment_gateway;

        cart_info.shipping_country_code = data.shipping_info.ship_country;
        cart_info.id_shipping_method = data.shipping_info.id_shipping_method;
        cart_info.total = data.total;  

        //--------------------------------------------------------------------------------------------------------------

		// --- CHECKOUT FINAL, TOTAIS

		if( shipping > 0 ){

			console.log('shipping > 0');

			shipping_text = shipping;
			$('#checkout-shipping-row > .currency-symbol').show();
			$('#checkout-shipping-row > .currency-iso').show();

		} else {

			console.log('shipping < 0');

			$('#checkout-shipping-row > .currency-symbol').hide();
			$('#checkout-shipping-row > .currency-iso').hide();

		}

		totalgiftvouchers = Number(totalgiftvouchers);
		if(totalgiftvouchers=='0'){
			$('.totalgiftvouchers').closest('.ccir_row').hide();
		} else {
			$('.totalgiftvouchers').closest('.ccir_row').show();
		}

		if(promoCodes.length=='0'){
			$('.totalpromocode').closest('.ccir_row').hide();
		} else {
			if( Number(discount)>0 ){
				$(".ccir_row .totalpromocode").html(discount);
				$('.totalpromocode').closest('.ccir_row').show();
			}
		}

		for(var key in promoCodes){
			$('.cci_insertedpromocodes').append('<div class="div_promocode"> <span class="promocode_name">'+promoCodes[key].name+'</span> - <span class="promocode_description">'+promoCodes[key].description+'</span>  <a class="cpl_deletepromocode" href="#">delete</a><br></div>');
		}

		var total_global_itens = 0;

		for(var key in items){
			var id_product = items[key].id_product;
			var id_producttype = items[key].id_producttype;
			var id_variant = items[key].id_variant;
			var img = items[key].img;
			if( items[key].type != 'customboard' )
				var name = items[key].name;
			else
				var name = 'custom order surfboard';
			//alert( name);
			var qtdreadonly = items[key].qtdreadonly;
			var qty = items[key].qty;
			var sku = items[key].sku;
			var totalprice = items[key].totalprice;
			var type = items[key].type;
			var unitprice = items[key].unitprice;
			var description = items[key].description;
			var discount_value = items[key].discount_value;
			var discount_unitprice = items[key].discount_unitprice;
			totalQty = Number(totalQty)+Number(qty);

            //console.log( totalQty );

            total_global_itens += Number( qty );

            //PBS: is surfboard? if so, change the button, storing the id´s of the surfboards on cart on a array
            if( id_producttype == 1 ){

            	surfboards_id_on_cart.push( id_product );

            }

            var id_producttypeName;
            var productUrl;
            if(id_producttype=='1'){
            	id_producttypeName = 'surfboard';
            	productUrl = '/?page=shopsurfboarddetail&id='+id_product+'&lang='+sLang;
            } else if(id_producttype=='2'){
            	id_producttypeName = 'accessories';
            	productUrl = '/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories&lang='+sLang;
            } else if(id_producttype=='3'){
            	id_producttypeName = 'apparel';
            	productUrl = '/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel&lang='+sLang;
            } else if(id_producttype=='4'){
            	id_producttypeName = 'custom surfboard';
            	productUrl = '#';
            }


            var descriptionString = '';
            for(var key in description){
            	var nameDesc = description[key].name;
            	var value = description[key].value;
            	var id = description[key].id;
            	if ( nameDesc=="Surfboard Model" ){
            		var test = nameDesc.split(" ");
            		nameDesc = test[1];	
            	}
            	
            	descriptionString += '<span class="'+id_product+'_'+key+'_'+id+'" data-id="'+id+'"><strong>'+nameDesc+':</strong> '+value+'</span>';
            }
            descriptionString += '<span><strong>Qty:</strong> '+qty+'</span>';


            //$('.t_nrofitems').html(items.length);

            $('.t_nrofitems').html( total_global_itens );

            $('.t_subtotal').html(subtotal);
            $('.t_tax').html(tax);

            // define the cost of shipping
            //$('.t_shippingtext').html('here: '+shipping_text);                       

            if( shipping_text=="Free Shipping" ){

            	$(".t_shippingtext_currency_iso").hide();
            	$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').hide();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').hide();
            	$('.t_shippingtext').html( shipping_alt_text ); 

            }else{

            	$(".t_shippingtext_currency_iso").show();
            	$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').show();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').show();
            	$('.t_shippingtext').html( shipping_text );

            }
            
            $('.t_total').html(total.toFixed(2));
            $('.totalgiftvouchers').html(totalgiftvouchers);
            // ------------------------ //

           var img_minicart = "";
           if( img.indexOf("cart-images") != -1 ) {
			img_minicart = "img-minicart";
		}

            $('.cos_products').append('																\
            	<div class="cos_item cartproduct product-'+id_product+'" id="'+id_product+'" data-id_product="'+id_product+'" data-id_producttype="'+id_producttype+'" data-qty="'+qty+'" data-id_variant="'+id_variant+'">	\
            		<div class="col-xs-3 col-sm-3 hidden-xs cart-product-img-col">															\
            			<div class="cosi_img">														\
            				<a href="'+productUrl+'">												\
            					<img src="'+img+'" class="img-responsive '+img_minicart+'" style="width:50px;">							\
            				</a>																	\
            			</div>																		\
            		</div>																			\
            		<div class="col-xs-9 col-sm-6">															\
            			<div class="cpl_productdesc">												\
            				<p class="cplpd_ref">'+sku+'</p>										\
            				<p class="cplpd_name">'+name+'</p>										\
            				<p class="cplpd_aditionalinfo">'+descriptionString+'</p>				\
            			</div>																		\
            		</div>																			\
            		<div class="col-xs-3 col-sm-3 cart-product-price-col">															\
            			<div class="cpl_deleteproduct_wrapper">										\
            				<a href="#"><i class="glyphicon glyphicon-remove"></i></a>						\
            			</div>																		\
            		<div class="cosi_subtotal">													\
            		<span class="subtotal_label">Sub-Total</span>\
            		<br>\
            		<span class="subtotal_value">'+totalprice+'</span>\
            	</div>																		\
            	</div>																			\
            	<div class="clear_both">&nbsp;</div>											\
            	</div>\
            	'); 



            var cplItem = $('.cplitem_dummiecontainer .cpl_item').clone();
            cplItem.attr('data-id_product', id_product);
            cplItem.attr('data-id_producttype', id_producttype);
            cplItem.attr('data-qty', qty);
            cplItem.attr('data-id_variant', id_variant);

		// Verifica se a imagem gerada eh da custom-order
		if( img.indexOf("cart-images") != -1 ) {
			cplItem.find('.cpl_img img').addClass("img-cart");
		}else{
			cplItem.find('.cpl_img img').removeClass("img-cart");
		}

            cplItem.find('.cpl_img img').attr('src', img);
            cplItem.find('.cpl_img a').attr('href', productUrl);
            cplItem.find('.cplpd_ref').html(sku);
            cplItem.find('.cplpd_name').html(name);
            cplItem.find('.cplpd_aditionalinfo').html(descriptionString);
            cplItem.find('.cpl_pricecurrency').html(currency.symbol);
            cplItem.find('.cpl_pricevalue').html(unitprice);
            if( discount_value>0 ){
            	cplItem.find('.cpl_oldpricevalue').html(discount_unitprice+'<br>');
            }
            cplItem.find('.cplqs_value input').val(qty);
            cplItem.find('.cplh_totalcurrency').html(currency.symbol);
            cplItem.find('.cplh_totalprice').html(totalprice);

            if(qtdreadonly=='true'){
            	cplItem.find('.cpl_quantityselect').attr('qtdreadonly', true).addClass('qtdreadonly_true');
            }

            $('.cpl_body').append(cplItem);
            $('.bmc_nrofitems').html(totalQty);
          }

        checkGoToCheckoutButton();

        // PBS 06.2016: we need the id´s of surfboard on cart to be loaded first, then do a match
        $(document).trigger('cart-loaded');

        // PBS 11.2016
        // set cookie if no token
        if( Cookies.get('token') == "" ){
            console.log('setting token: '+'/'+data.token);
            Cookies.set('token', '/'+data.token );
        }

        //----------------------------------------------------------------------
        // if this is step 02 of the checkout
        // check the address defined on the API
        // and assign it to the form       

        // ONLY AFTER COUNTRIES BEING LOADED       

        // TO-DO: find another way to know that we are on the end of the checkout process
        // location may be another
        //if( window.location.pathname == '/index.php' && data.shipping_info.id_shipping_method ){
        var page = getQueryString('page');

        if( page == 'checkoutfinal' && data.shipping_info.id_shipping_method ){

        	//alert( 'page: '+page );
        	
			// ok, here we must defined the address on the form, and trigger the change to be listened..
			//$('#delivery-option-home').prop('checked', true).change();
			$('#delivery-option-home').trigger('click');

			//------------------------------------------------------------------
			// assign country 		
	        
	        getCountrys().then( function(){

	        	$('#ship_country').val( data.shipping_info.ship_country ).change();	        		        

	        	service_GetShippingMethod().then( function(){	        	

	        		console.log('i got shipping methods defined.');

	        		console.log('now set the choosen one: '+cart_info.id_shipping_method);

					//$('.shipping_method').val( cart_info.id_shipping_method );//.change();

					//return false;

	        		// now that we have countries defined, let´s listen to changes.
					$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){						

						//console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
					    service_GetCheckoutInfo(e);

					});		        		

	        	})

	        	if( data.shipping_info.ship_state ){
	        		
	        		getStates( data.shipping_info.ship_country ).then( function(){

						$('#ship_state').val( data.shipping_info.ship_state );

	        		})

	        	}

	        })

	        //------------------------------------------------------------------

        }else if( window.location.pathname == '/index.php' && data.shipping_info.id_shipping_method == "" ){

        	console.log( 'checkout step 2, but no shipping method is defined' );	

        	getCountrys();

			$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){						

				//console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
			    service_GetCheckoutInfo(e);

			});	        	

        }else{

        	console.log('none of the above verified..');

        }             

        //----------------------------------------------------------------------


      }).fail( function(xhr, textStatus, errorThrown){

        //console.log('get cart failed:'+ xhr, textStatus, errorThrown);

        $( document ).trigger('cart-loaded');

      });
    }











//console.log('loaded and working..!');

function service_AddToCart(id_product, id_producttype, id_variant, qty, elementTrigger){

	//console.log('service_AddToCart in the house! and arguments are: '+id_product+', '+id_producttype+', '+ id_variant+', '+ qty+', '+ elementTrigger);

    //return;

    var json = [
    {
    	id_product: ''+id_product+'',
    	id_producttype: ''+id_producttype+'',
    	id_variant: ''+id_variant+'',
    	qty: ''+qty+'',
    	type: 'product',
    	token: Cookies.get('token').replace('/','')
    }
    ];
    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
    	method: 'POST',
    	data: JSON.stringify(json),
    	contentType: 'application/json',
    	dataType: 'json',
    	xhrFields: {
    		withCredentials: true
    	},
    	crossDomain: true,
    	context: document.body
    }).done(function(data) {

    	//console.log('bellow is reponse of add to cart:');
    	//console.log(data);
    	//console.log( data.token );

    	// this is needed, also on other sites
    	if( Cookies.get('token') == "" )
    		Cookies.set('token', '/'+data.token );

    	service_GetCart();

    	if(elementTrigger!=undefined){
    		if(!elementTrigger.hasClass('prevent_showcart')){
    			var isCartOpen = $('.mycart_contents').attr('data-open');
    			if(isCartOpen == 'false'){
    				$('.btn_mycart').trigger('click');
    			}
    		}
    	} else {
    		var isCartOpen = $('.mycart_contents').attr('data-open');
    		//console.log( isCartOpen );
    		if(isCartOpen == 'false'){
    			$('.btn_mycart').trigger('click');
    		}
    	}

    	checkGoToCheckoutButton();
    });
  }



  function service_DeleteFromCart(id_product, id_producttype, id_variant, qty){
  	var json = [
  	{
  		id_product: ''+id_product+'',
  		id_producttype: ''+id_producttype+'',
  		id_variant: ''+id_variant+'',
  		qty: ''+qty+'',
  		type: 'product',
  		token: Cookies.get('token').replace('/','')
  	}
  	];

  	$.ajax({
  		url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
  		method: 'DELETE',
  		data: JSON.stringify(json),
  		contentType: 'application/json',
  		dataType: 'json',
  		xhrFields: {
  			withCredentials: true
  		},
  		crossDomain: true,
  		context: document.body
  	}).done(function(data) {
  		service_GetCart();
  		checkGoToCheckoutButton();

  		$( document ).trigger('cart-loaded');

  		//console.log('cart-loaded');

  		//console.log( 'before: '+surfboards_id_on_cart );

  		surfboards_id_on_cart = jQuery.grep( surfboards_id_on_cart, function(value) {
  			return value != id_product;
  		});

  		//console.log( 'after: '+surfboards_id_on_cart );

  	})
  }

  function checkGoToCheckoutButton(){
  	var nrOfItemsInCart = $('.checkout_productlist .cpl_body .cartproduct').length;
  	if(nrOfItemsInCart==0){
  		$('.securechckout_big').hide();
  	} else {
  		$('.securechckout_big').show();
  	}
  }



  $(function(){
	// ----- POST ----- //
	//$(document).on('click', '.addtocart', function(e){
		$(document).on('click', '#btn-add-to-cart', function(e){
			e.preventDefault();
			var t = $(this);
			var id_product = Number(t.attr('data-id_product'));
			var id_producttype = Number(t.attr('data-id_producttype'));
			var id_variant = t.attr('data-variant');
			var qty = Number(t.closest('.sldi_addtocart').find('.addproduct_qty').val());
			var isSingleQty = t.hasClass('addtocart_singleqty');
			if(isSingleQty){
				qty=1;
			}

			service_AddToCart(id_product, id_producttype, id_variant, qty);

			setTimeout(function(){
				$('.mycart_contents').stop().fadeOut(300, function(){
					$('.mycart_contents').attr('data-open', 'false');
				});
			}, 3500);

		});

	// ----- DELETE ----- //
	//$(document).on('click', '.cpl_deleteproduct', function(e){
		$(document).on('click', '.cpl_deleteproduct_wrapper .glyphicon-remove, .cpl_deleteproduct', function(e){
			e.preventDefault();
			var t = $(this);
			var item = t.closest('.cartproduct');
			var id_product = item.attr('data-id_product');
			var id_producttype = item.attr('data-id_producttype');
			var id_variant = item.attr('data-id_variant');
			var qty = item.attr('data-qty');

			t.remove();
			item.fadeOut(100);
			service_DeleteFromCart(id_product, id_producttype, id_variant, qty);
		});
	});


//when? - checkout_final.php
function service_GetCheckoutInfo(e){

	//return 0;
	//console.log('returning');	

	//console.log( e );

	var formData = $('.checkout_final').serializeArray();
	var formDataArray;
	var formDataString = '{ '
	for(var key in formData){
		var name = formData[key].name;
		var value = formData[key].value;
		formDataString += '"'+name+'": "'+value+'", ';
	}

	//Cookies.get('token')
	formDataString += '"token" : "'+Cookies.get('token').replace('/','')+'", ';

	formDataString = formDataString.slice(0, -2);
	
	formDataString += ' }'
	
	formDataArray = jQuery.parseJSON(formDataString);


	var useShippingAddressForBilling = $('.shipbillingaddresscheck input').prop('checked');

	if(useShippingAddressForBilling){

		formDataArray.bill_address1 = formDataArray.ship_address1;
		formDataArray.bill_address2 = formDataArray.ship_address2;
		formDataArray.bill_city = formDataArray.ship_city;
		formDataArray.bill_company_name = formDataArray.ship_company_name;
		formDataArray.bill_country = formDataArray.ship_country;
		formDataArray.bill_instructions = formDataArray.ship_instructions;
		formDataArray.bill_state = formDataArray.ship_state;
		formDataArray.bill_zipcode = formDataArray.ship_zipcode;

	}

	// remove shipping_method se for escolhido pickup my order
	if( $("input[name=delivery-option]:checked").val() == "pick-up" ){
		formDataArray["id_shipping_method"]="";
		$(".coconfirm_clientdetails_inner .cci_titleleft").text("You're Picking up your order from:");
	// remove id_pickuplocation se nao for escolhido pickup my order
}else{
	formDataArray["id_pickuplocation"]="";
	$(".coconfirm_clientdetails_inner .cci_titleleft").text("We're going to send your order to:");
}

//if(e.delegateTarget.activeElement.tagName!='BODY' || e.delegateTarget.activeElement.tagName!='body'){
	// if not body..? why and when?
	//if(e.delegateTarget.activeElement.tagName!='BODY' || e.delegateTarget.activeElement.tagName!='body'){
	if( 1 == 1 ){

		//console.log('getting checkout info, and delegate target was not body. - this is called 4 times?');

	$.ajax({
		//url: sUrlShop+'/api/v1/shop/carts/checkout?lang='+sLang,
		url: sUrlShop+'/api/v1/shop/carts/checkout'+Cookies.get('token'),
		method: 'POST',
		data: JSON.stringify(formDataArray),
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {

		console.log('response of service_GetCheckoutInfo:');
		console.log(data);

		var currency = data.currency;
		var id_cart = data.id_cart;
		var shipping = data.shipping;
		var shipping_text = data.shipping_text;
		var shipping_alt_text = data.shipping_alt_text;
		var subtotal = data.subtotal;
		var tax = data.tax;
		var total = data.total;
		var items = data.items;
		var nrOfItems = items.length;
		var promoCodes = data.promocodes;
		var giftvouchers = data.giftvouchers;
		var totalgiftvouchers = data.totalgiftvouchers;




		if(shipping>0){

			console.log('shipping > 0');

			shipping_text = shipping;
			$('.t_shippingtext_currency').show();
			$('.t_shippingtext_currency_iso').show();
		} else {
			$('.t_shippingtext_currency').hide();
			$('.t_shippingtext_currency_iso').hide();
		}

		totalgiftvouchers = Number(totalgiftvouchers);

		if(totalgiftvouchers=='0'){
			$('.totalgiftvouchers').closest('.ccir_row').hide();
		} else {
			$('.totalgiftvouchers').closest('.ccir_row').show();
		}


		$('.cos_products').attr('id', 'cart_'+id_cart);
		$('.cos_products').attr('data-id_cart', id_cart);
		$('.cos_totalprice .ccirr_currency').html(currency.symbol);
		$('.cos_totalprice .ccirr_totalprice').html(total.toFixed(2));
			// --- CHECKOUT FINAL, TOTAIS
			//$('.t_nrofitems').html(items.length);
	        //$('.t_nrofitems').html( total_global_itens );
	        $('.t_subtotal').html(subtotal);
	        $('.t_tax').html(tax);
	        $('.t_shippingtext_currency').html(currency.symbol);
	        $('.t_shippingtext_currency_iso').html(currency.iso);	
	        
	        if( shipping_text=="Free Shipping" ){
				
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').hide();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').hide();
				$('.t_shippingtext').html(shipping_alt_text);

			}else{

				$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').show();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').show();
				$('.t_shippingtext').html(shipping_text);

			}

	        $('.totalgiftvouchers').html(totalgiftvouchers);
	        $('.t_total_currency').html(currency.symbol);
	        $('.t_total').html(total.toFixed(2));
			// ------------------------ //

			// must be done after the country is select from the API
			if($(e.target).hasClass('shippingmethodtrigger')){
				service_GetShippingMethod();
			}

			var selectedShipingMethod = data.shipping_info.id_shipping_method;
			$('.shipping_method').val(selectedShipingMethod);




			$('.giftvoucher_insertedcodes').empty();
			for(var key in giftvouchers){
				var code = giftvouchers[key].code;
				var value = giftvouchers[key].value;
				$('.giftvoucher_insertedcodes').append('<span>'+code+'</span> - $<span>'+value+'</span><br>');
			}


			var shipping_info = data.shipping_info;
			var ship_address1 = shipping_info.ship_address1;
			var ship_city = shipping_info.ship_city;
			var ship_zipcode = shipping_info.ship_zipcode;
			var ship_state_name = shipping_info.ship_state_name;
			var ship_country_name = shipping_info.ship_country_name.ship_country_name;

			$('.finalcheckout_address').html('		\
				<span class="cci_subtitle">Address: </span><span>'+ship_address1+'</span><br>			\
				<span class="cci_subtitle">Zip Code: </span><span>'+ship_zipcode+'</span><br>			\
				<span class="cci_subtitle">City: </span><span>'+ship_city+'</span><br>					\
				<span class="cci_subtitle">State: </span><span>'+ship_state_name+'</span><br>			\
				<span class="cci_subtitle">Country: </span><span>'+ship_country_name+'</span><br>		\
				');

			
			console.log('before the loop');

			$.each( items, function(){

				console.log('inside the loop');
				console.log(this);	

				$('.product-'+this.id_product+' .subtotal_value').text( this.totalprice );

			})

		});
}else{
	$.ajax({
		url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
		method: 'GET',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {
		var currency = data.currency;
		$('.cos_totalprice .ccirr_currency').html(currency.symbol);
		$('.t_shippingtext_currency').html(currency.symbol);
		$('.t_shippingtext_currency_iso').html(currency.iso);
		$('.t_total_currency').html(currency.symbol);
		$('.t_total_currency_iso').html(currency.iso);
	});	
}
}

// this can only happen after the country is defined
// and after the shipping method is defined..

//$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){	
/*
$(document).on('change', '#id_shipping_method', function(e){	

	console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
	service_GetCart();
    service_GetCheckoutInfo(e);

});
*/





function service_GetShippingMethod(){

	$('.shipping_method').empty();

    // added and empty option to not add price of shipping
    $('.shipping_method').append('<option value="">please select</option>');

    var t = $(this);
	//var wrapper = t.closest('.calculateshipping_wrapper');
	var wrapper = t.closest('.shipping_address');
	
	/*
	var ship_country = wrapper.find('.country_wrapper select').val();
	var ship_state =  wrapper.find('.state_wraper select').val();
	var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
	*/
	
	var ship_country =  $('#ship_country option:selected').val();
	console.log( 'shipping country is: '+ship_country );
	var ship_state =  $('#ship_state option:selected').val();
	var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
	
	return $.when(
		
		$.ajax({
			//url: sUrlShop+'/api/v1/shop/carts/shipping_methods?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token')+'?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			method: 'GET',
			xhrFields: {
	                withCredentials: true
	            },
	                crossDomain: true,
	  		context: document.body
		}).done(function(data) {

			$('.shipping_method').empty();

			for(var key in data){
				var id_shipping_method = data[key].id_shipping_method;
				var name = data[key].name;
				var price = data[key].price;
				$('.shipping_method').append('<option value="'+id_shipping_method+'">'+name+'</option>');
			}

			//$('.shipping_method').change();

			// xpto
			//$('.shipping_method').val( cart_info.id_shipping_method ).change();

			if( cart_info.id_shipping_method )
				$('.shipping_method').val( cart_info.id_shipping_method ).change();
			//else
				//$('.shipping_method').change();


		})

	)	

		

	
}



function getCountrys(){

	console.log('getting countries');
	
	return $.when(

		$.ajax({
			url: sUrl+'/api/v1/countries?lang='+sLang,
			method: 'GET',
			context: document.body
		}).done(function(data) {

			$('.country_wrapper select').empty();

			var data = data.countries;

			for(var key in data){

				var iso = data[key].iso;
				var name = data[key].name;
				var selected = data[key].selected;
				if(selected){
					selected = 'selected'
				} else {
					selected = '';
				}

				$('.country_wrapper select').append('<option value="'+iso+'" '+selected+'>'+name+'</option>');

			}	

			$('.country_wrapper select').trigger('change');

			console.log('countries was loaded');
			
			$( document ).ready( function(){

				$( document ).trigger('countries-loaded')

			})

			//})			

		})		

	)

}

function getStates(iso, target){

    //console.log('getStates()');

	return $.when(

		$.ajax({
			url: sUrl+'/api/v1/countries/'+iso+'/states?lang='+sLang,
			method: 'GET',
			//context: document.body
		}).done(function(data) {

			if(target==undefined){
				$('.state_wraper select').empty();
				$('.state_wraper select').append('<option></option>');
		        //$('#ship_state').change();
		        //console.log( $('#ship_state') );
			} else {
				$('.'+target).empty();
				$('.'+target).append('<option></option>');
			}			

	        var data = data.states;

	        console.log( data );

			for(var key in data){
				var iso = data[key].iso;
				var name = data[key].name;
				if(target==undefined){
					$('.state_wraper select').append('<option value="'+iso+'">'+name+'</option>');
				} else {
					$('.'+target).append('<option value="'+iso+'">'+name+'</option>');
				}
			}// end for

	        //if( data.length > 0 )
	            $('#ship_state').change();

	           if( data.length == 0){
	           	$("#"+target).closest(".state_wraper").fadeOut("slow");
	           }else{
	           	$("#"+target).closest(".state_wraper").fadeIn("slow");	
	           }

	           $( document ).trigger('states-loaded');

		})

	)	

}


    function get_PaymentMethods(){
    	$.ajax({
    		url: sUrlShop+'/api/v1/shop/carts/payment_methods?lang='+sLang,
    		method: 'GET',
    		context: document.body
    	}).done(function(data) {
    		var data = data.payment_methods;
    		for(var key in data){
    			var name = data[key].name;
    			var available = data[key].available;
    			if(available){
    				$('.pm_'+name).show();
    			}
    		}
    	});
    }







    function service_SubmitOrder(){

    //var id_payment_method = $('#id_payment_method').val();
    var id_payment_method = $('#payment_method').val();
    var payment_card_number = $('#cc-number').val();
    var payment_card_name = $('#cc-name').val();
    var payment_card_cvc = $('#cc-cvc').val();
    var payment_card_expiry_month = $('#cc-exp-month').val();
    var payment_card_expiry_year = $('#cc-exp-year').val();
    var stripe_token = $('#stripe-token').val();
    console.log( stripe_token );
    
    //"token" : "'+Cookies.get('token').replace('/','')+'"\

    var submitData = '{														\
    	"id_payment_method":"'+id_payment_method+'",						\
    	"payment_card_number":"'+payment_card_number+'",					\
    	"payment_card_name": "'+payment_card_name+'",						\
    	"payment_card_cvc":"'+payment_card_cvc+'",							\
    	"payment_card_expiry_month": "'+payment_card_expiry_month+'",		\
    	"payment_card_expiry_year":"'+payment_card_expiry_year+'",			\
    	"stripe-token" : "'+stripe_token+'"                                 \
    }';

    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts/orders'+Cookies.get('token')+'?lang='+sLang,
    	method: 'POST',
    	data: submitData,
    	contentType: 'application/json',
    	dataType: 'json',
    	xhrFields: {
    		withCredentials: true
    	},
    	crossDomain: true,
    	error: function(data){
    		var status = data.status;
    		var message = jQuery.parseJSON(data.responseText).message;
    		$('.submitwindow_error').fadeIn();
    		$('.swe_errormessage').html(message);
    	},
    	context: document.body
    }).done(function(data) {

    	var order_no = data.order_no;
    	$('.sw_ordercode').html(order_no);
    	$('.submitwindow_success').fadeIn();

    	// clear token to get new one.
    	Cookies.set('token', '');
    	console.log('cleared token');

    });
  }

  $(function(){

  	$(document).on('click', '.checkout_submitorder', function(e){
  		e.preventDefault();

        //with stripe this maybe not needed..

        service_SubmitOrder();
		//$('body').addClass('ordersubmited');

		$('.submitwindow').fadeIn();

		$('#checkoutfinal_modal .close').trigger('click');

        //$('#form-checkout-final').submit();

        //console.log('form submited');

      });

  });








  $(function(){
  	$(document).on('change', '.country_wrapper select', function(){
  		var t = $(this);
  		var target = t.attr('data-statetarget');
  		var iso = t.val();
  		getStates(iso, target);
  	});


  	$(document).on('click', '.btn_giftvoucher', function(e){
  		e.preventDefault();
  		var t = $(this);
  		var code = t.closest('.giftvoucher_wrapper').find('.giftvoucher').val();
  		var code = '{ "giftvoucher": "'+code+'" }';

  		$.ajax({
  			url: sUrlShop+'/api/v1/shop/carts/giftvouchers?lang='+sLang,
  			method: 'POST',
  			data: code,
  			contentType: 'application/json',
  			dataType: 'json',
  			xhrFields: {
  				withCredentials: true
  			},
  			crossDomain: true,
  			context: document.body
  		}).done(function(data) {

			//console.log(data);

			service_GetCheckoutInfo(e);
		});
  	});
  });



  function initCFactoryMap(coordinates) {
  	var myLatlng = coordinates;
  	var mapOptions = {
  		center: myLatlng,
  		zoom: 16,
  		scrollwheel: false
  	};
  	var map = new google.maps.Map(document.getElementById('contactsfactory_map'), mapOptions);

  	var marker = new google.maps.Marker({
  		position: myLatlng,
	    /*icon: {
	    	url: 'images/chilli_mapmarker.png',
	    }*/
	  });
  	marker.setMap(map);
  }

  function service_Contacts(){
  	$.ajax({
  		url: sUrlShop+'/api/v1/contacts?lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		var target = $('.contacts_factory');
  		var labelAddress = data.labels.txt_address;
  		var labelPhone = data.labels.txt_sales_phone;
  		var labelEmail = data.labels.txt_email_sales;
  		var labelOpeningHours = data.labels.txt_workinghours;
  		var postalcode = data.postal_code;
  		var city = data.city;
  		var country = data.country;
  		var address = data.address;
  		var phone = data.phone_sales;
  		var email = data.email_sales;
  		var openingHours = data.business_hours;

  		var lat = data.gps_lat;
  		var lng = data.gps_long;
  		var coordinates = new google.maps.LatLng(lat,lng);


  		target.find('.ci_labeladdress').hide().html(labelAddress).fadeIn();
  		target.find('.ci_address').hide().html(address).append(', '+postalcode+' '+city+' - '+country).fadeIn();
  		target.find('.ci_labelphone').hide().html(labelPhone).fadeIn();
  		target.find('.ci_phone').hide().html(phone).fadeIn();
  		target.find('.ci_labelemail').hide().html(labelEmail).fadeIn();
  		target.find('.ci_email').hide().html(email).fadeIn();
  		target.find('.ci_labelwork').hide().html(labelOpeningHours).fadeIn();
  		target.find('.ci_work').hide().html(openingHours).fadeIn();

  		setTimeout(function(){
  			initCFactoryMap(coordinates);
  		}, 1000);
  	});
  }

/* ========================================================================
 *   Surfboard Details
 * ======================================================================== */
 function service_SurfboardModelDetail(){
 	var surfboardmodelId = getQueryString('id');
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels/'+surfboardmodelId+'/build?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		var id_surfboardmodel = data[0].id_surfboardmodel;
 		var surfboardmodel = data[0].surfboardmodel;
 		var id_brand = data[0].id_brand;
 		var id_sport = data[0].id_sport;
 		var brand = data[0].brand;
 		var images = data[0].img;
 		var wavesize_min = data[0].wavesize.min;
 		var wavesize_max = data[0].wavesize.max;
 		var skilllevel = data[0].skilllevel;
 		var skillString = '';
 		var surfboardmodeltype = data[0].surfboardmodeltype;
 		var description = data[0].description;
 		var img_logo = data[0].img_logo;
 		var technology = data[0].technology;
 		var price = data[0].min_price;
 		var currencySymbol = data[0].currency.symbol;
 		var currencyIso = data[0].currency.iso;
 		var shopavailable = data[0].shopavailable;
 		var features = data[0].features;
 		var img_logo = data[0].img_brand_logo;

 		if( id_sport==undefined ){
 			id_sport="";
 		}

 		if( img_logo!=undefined && img_logo!='' ){
 			$(".surfboardmodel-content .row-img img").attr("src", img_logo);
 		}
 		if( data[0].bottom.img == '' ){
 			//console.log( 'data[0].bottom.length = '+data[0].bottom.length );
 			$('.boardbottomfeatures').remove();
 		} else {
 			var bottomImg = data[0].bottom.img;
 			var bottomText = data[0].bottom.text;
 		}
 		if(data[0].videos.length==0){
 			var videoUrl = '';
 		} else {
 			var videoUrl = data[0].videos[0].url;
			/* ========================================================================
		     *   Assign url to social share
		     * ======================================================================== */
		     $('.social-share-video-link').each(function(){
		     	initial_href = this.href;
		     	final_href = initial_href += videoUrl;
		     	this.href = final_href;
		     });

		   }
		   var standard_dimensions = data[0].standard_dimensions;
		   var other_models = data[0].other_models;
		   if( price=='' ){
		   	$('.bdp_price').remove();
		   }

		/* ========================================================================
	     *   Board Image Slider
	     * ======================================================================== */
	     $('#carousel-surfboardmodel-1 .carousel-indicators').empty();
	     var crslIndex = 0;
	     var screen_width = $(window).width();
	     var img_width;
	     if( screen_width<=400 ){ img_width='370'; }
	     else if( screen_width<=500 ){ img_width='400'; }
	     else if( screen_width<=600 ){ img_width='500'; }
	     else if( screen_width<=700 ){ img_width='600'; }
	     else if( screen_width<=800 ){ img_width='700'; }
	     else if( screen_width<=900 ){ img_width='760'; }
	     else if( screen_width<=1000 ){ img_width='710'; }
	     else if( screen_width<=1100 ){ img_width='800'; }
	     else if( screen_width<=1200 ){ img_width='970'; }
	     else if( screen_width<=1300 ){ img_width='1060'; }
	     else{ img_width=screen_width*0.55555555555556; }

		//var paramUrl = "?or=90&w="+img_width;   
		var paramUrl = "?w=1000&h=340&fit=crop&or=90";

		//style removido no div data-phototype '  style="background:url('+imgUrl+''+paramUrl+'); background-position: center; background-repeat: no-repeat;" '

		if( images.length==undefined ){
			for(var key in images){
				var imgUrl = images[key].img_dynamic;
				var cover = images[key].cover;
				
				if(cover==1){
					$('#carousel-surfboardmodel-1 .carousel-indicators').prepend('						\
						<li data-target="#carousel-surfboardmodel-1" data-slide-to="'+crslIndex+'"></li>\
						');
					$('#carousel-surfboardmodel-1 .carousel-inner').prepend('	\
						<div data-phototype="'+images[key].phototype+'" data-index="'+crslIndex+'" class="item" >\
						<img class="img-responsive" src="'+imgUrl+''+paramUrl+'" style="margin:0 auto; position: relative; top: 50%; transform: translateY(-50%); ">\
						<div class="container">\
						<div class="carousel-caption">\
						<div class="row">\
						<div class=" col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">\
						<div class="caption">\
						\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						');
				} else{
					$('#carousel-surfboardmodel-1 .carousel-indicators').append('						\
						<li data-target="#carousel-surfboardmodel-1" data-slide-to="'+crslIndex+'"></li>																			\
						');
					$('#carousel-surfboardmodel-1 .carousel-inner').append('	\
						<div data-phototype="'+images[key].phototype+'" data-index="'+crslIndex+'" class="item">\
						<img class="img-responsive" src="'+imgUrl+''+paramUrl+'" style="margin:0 auto; position: relative; top: 50%; transform: translateY(-50%); ">\
						<div class="container">\
						<div class="carousel-caption">\
						<div class="row">\
						<div class=" col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">\
						<div class="caption">\
						\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						');
				}

				crslIndex++;
			}
		}else{
			$('.carousel-control').fadeOut(500);
		}
		var setImgNrI = 0;
		$('#carousel-surfboardmodel-1 .carousel-indicators > li').each(function(){
			var t = $(this);
			t.attr('data-slide-to', setImgNrI);
			setImgNrI++;
		});
		$('#carousel-surfboardmodel-1 .carousel-indicators li:first').addClass('active');
		$('#carousel-surfboardmodel-1 .carousel-inner .item:first').addClass('active');


		// --- MISC
		$('.breadcrumb .active').html(surfboardmodel);
		$('.bm_brand').html(brand);
		$('.bm_model').html(surfboardmodel);

		if( price!='' ){
			$('.bm_currency_symbol').html(currencySymbol);
			$('.bm_price').html(price);
			$('.bm_currency_iso').html(currencyIso);
		}else{
			$('.bm_price').html('');
			$('.bm_currency_symbol').fadeOut(500);
			$('.bm_currency_iso').fadeOut(500);
		}	

		$('.row-bm-text p.text').html(description);
		$('.bm_wave_min').html(wavesize_min);
		$('.bm_wave_max').html(wavesize_max);
		


 		/* ========================================================================
	     *   Construction
	     * ======================================================================== */
	     var technology = data[0].construction_type;
	     var technology_text = '';
	     for(var key in technology){	
	     	var technology_name = technology[key].constructiontype;
	     	technology_text += '<li>'+technology_name+'</li>';
	     }
	     $('.bm_technology').html(technology_text);

 		/* ========================================================================
	     *   Fin Setup
	     * ======================================================================== */
	     var fin_setup = data[0].fin_setup;
	     var fin_setup_text = '';
	     for(var key in fin_setup){	
	     	var fin_setup_name = fin_setup[key].name;
	     	if( key==0 ){
	     		fin_setup_text += fin_setup_name;
	     	}else{
	     		fin_setup_text += ', '+fin_setup_name;
	     	}
	     }
	     $('.bm_fin_setup').html(fin_setup_text);

 		/* ========================================================================
	     *   Fin System
	     * ======================================================================== */
	     var finsystem = data[0].finsystem;
	     var finsystem_text = '';
	     for(var key in finsystem){	
	     	var finsystem_name = finsystem[key].name;
	     	if( key==0 ){
	     		finsystem_text += finsystem_name;
	     	}else{
	     		finsystem_text += ', '+finsystem_name;
	     	}

	     }
	     $('.bm_finsystem').html(finsystem_text);

 		/* ========================================================================
	     *   Concave
	     * ======================================================================== */
	     var bottoms = data[0].bottoms;
	     var bottoms_text = '';
	     for(var key in bottoms){	
	     	var bottoms_name = bottoms[key].bottom;
	     	bottoms_text += '<li>'+bottoms_name+'</li>';
	     }
	     $('.bm_bottoms').html(bottoms_text);

 		/* ========================================================================
	     *   Tail Shape
	     * ======================================================================== */
	     var tail_shape = data[0].tail_shape;
	     var tail_shape_text = '';
	     for(var key in tail_shape){	
	     	var tail_shape_name = tail_shape[key].name;
	     	tail_shape_text += '<li>'+tail_shape_name+'</li>';
	     }
	     $('.bm_tail_shape').html(tail_shape_text);

		/* ========================================================================
	     *   Skill Level
	     * ======================================================================== */
	     for(var key in skilllevel){
	     	var skill = skilllevel[key].name;
	     	skillString += skill+', ';
	     }
	     skillString = skillString.slice(0, -2)
	     $('.bm_skilllevel').html(skillString);
	     $('.bdpts_surfboardmodeltype').html(surfboardmodeltype);

		/* ========================================================================
	     *   Technology
	     * ======================================================================== */
	     if(technology.length==0){
	     	$('.bdp_textdesc_technology').remove();
	     } else {
	     	for(var key in technology){
	     		var imgUrl = technology[key].img;
	     		$('.bdp_textdesc_technology .bdp_textdesc_technology_imgs').append('<img src="'+imgUrl+'">');
	     	}
	     }

		/* ========================================================================
	     *   Logo
	     * ======================================================================== */
	     $('.bdp_logo').empty();
		//$('.bdp_logo').append('<img src="'+img_logo+'"></img>');
		$('#model-logo').append('<img src="'+img_logo+'" class="img-responsive">');
		$('.sd_boardname').text(surfboardmodel);
		$('.vhbd_boardname').text(surfboardmodel);

		if( shopavailable > 0 ){
			//$('.bdppl_shop').show().attr('href', '/shop/boards/?model='+id_surfboardmodel);
            	//$('#surfboard-buy-stock-btn').fadeIn().attr('href', '/shop/boards/?model='+id_surfboardmodel);
            	$('#surfboard-buy-stock-btn').css('display','block').attr('href', '/?page=shopsurfboarddetail&model='+id_surfboardmodel);
            }

		/* ========================================================================
	     *   Features
	     * ======================================================================== */
	     for(var key in features){
	     	var imgUrl = features[key].img;
	     	var name = features[key].name;
	     	var value = features[key].value;
	     	$('.bf_list').append('											\
	     		<div class="col-sm-4 col-xs-12">							\
	     		<img src="'+imgUrl+'" class="img-responsive">		\
	     		<p class="bf_featuretitle">'+name+':</p>			\
	     		<p class="bf_feature">'+value+'</p>				\
	     		</div>														\
	     		');
	     }

	     $('.boardbottomfeatures_imgwrapper img').attr('src', bottomImg);
	     $('.bbf_disclaimer').html(bottomText);



		// --- VIDEO
		/*if(videoUrl==''){
			$('.video_home').remove();
		} else {
			var isYoutube = videoUrl.indexOf('youtu') > -1;
			if(isYoutube){
				var videoId = youtube_parser(videoUrl);
				var videoEmbed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
			} else {
				var vimeoId = videoUrl.split('/');
				vimeoId = vimeoId[vimeoId.length - 1];
				var videoEmbed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			}
			$('.videoembed_wrapper').html(videoEmbed);
		}*/

		//simple custom order button
		$('#surfboard-custom-order-btn').attr('href','/custom-order?model='+id_surfboardmodel);

		// --- STANDARD DIMENSIONS
		for(var key in standard_dimensions){
			var t = standard_dimensions[key];
			var size = t.length_inches;
			var width = t.width_inches;
			var thickness = t.thickness_inches;
			var volume = t.volume;
			if( t.volume!='' ){
				volume = t.volume+' L';
			}
			var weightRange = t.weight_range;
			var tail = t.tail;
			var finOptions = t.fin_options;
			var length_complete = t.length_complete;
			var currentavailability = t.currentavailability;

			var buyQString = 'id_sport='+id_sport+'&id_brand='+id_brand+'&model='+id_surfboardmodel+'&length='+t.length+'&width='+t.width+'&thickness='+t.thickness;
			//var buyQString = 'model='+id_surfboardmodel+'&length='+length+'&width='+t.width;
			var buyUrl = '/?page=shopsurfboarddetail&'+buyQString;

			if(currentavailability=='0'){
				buyNowHtml = '<a class="btn btn-default btn-customorder" href="/custom-order?'+buyQString+'">Custom Order</div>';
			} else {
				buyNowHtml = '<a class="btn btn-default btn-buynow" href="'+buyUrl+'">Buy Now</div>';
			}
			//var buyNowHtml = '';
			//buyNowHtml = '<a class="sd_buynow" href="'+buyUrl+'">Buy Now</div>';

			$('#table-sizerange table tbody').append('												\
				<tr>																					\
				<td>'+size+'</td>																	\
				<td>'+width+'</td>																	\
				<td>'+thickness+'</td>																\
				<td>'+volume+'</td>																	\
				<td>'+buyNowHtml+'</td>																\
				</tr>																					\
				');
		}
		// ---/ STANDARD DIMENSIONS

		var count = 0;

		for(var key in other_models){
			var t = other_models[key];
			var id_surfboardmodel = t.id_surfboardmodel;
			var img = t.img_dynamic;
			var surfboardmodel = t.surfboardmodel;
			var min_price = t.min_price;
			var brand = t.brand;
			

			if( count<4 ){
				if( img!='' ){
					count ++;
					$('#othermodels .othermodels').append('								\
						<div class="col-sm-3 board text-center">\
						<div class="row">\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'">\
						<div class="col-sm-12">\
						<img src="'+img+'?h=506" class="img-responsive" alt="board">\
						</div>\
						<div class="col-sm-12 brand brand_detail">'+brand+'</div>\
						<div class="col-sm-12 model model_detail">'+surfboardmodel+'</div>\
						</a>\
						</div>\
						</div>\
						');
				}
			}

			
		}
		var widget = $('.othersurfboards');
		otherBoardsInit(widget);


		for(var key in skilllevel){
			var skillId = key;
			$('.skli_'+skillId).find('.skli_active').show();
			$('.skli_'+skillId).find('.skli_inactive').hide();
		}


		wavesize_min = Number(wavesize_min);
		for(var i=wavesize_min;i<=wavesize_max;i++){
			var divNr = i+1;
			$('.sws_wrapper .sws_'+divNr).find('.sws_inactive').hide();
			$('.sws_wrapper .sws_'+divNr).find('.sws_active').show();
		}

		$('.bmcb').empty();
		if( shopavailable>0 ){
			$('.bmcb').append('\
				<div class="col-sm-6 align-right">\
				<a href="/shop/boards/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Buy Stock</a>\
				</div>\
				<div class="col-sm-6 align-left">\
				<a href="/custom-order/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Custom Order</a>\
				</div>\
				');
		}else{
			$('.bmcb').append('\
				<div class="col-sm-6 col-sm-offset-3">\
				<a href="/custom-order/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Custom Order</a>\
				</div>\
				');
		}

		//$('.bmcb .align-right a').attr('href', '/shop/boards/?model='+surfboardmodelId );
		//$('.bmcb .align-left a').attr('href', '/custom-order/?model='+surfboardmodelId );
	});
}











function service_BlogList(){

	$.ajax({
		url: sUrl+'/api/v1/cms/zones/45/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log( data );

		for(var key in data){

			var id_cmsconteudo = data[key].id_cmsconteudo;
			var title = data[key].hptitle;
			var postDate = data[key].dt_publication.en;
			var postResume = data[key].hpresume.substring(0, 100)+' (...)';
			var multimedia = data[key].multimedia[0];
			if(multimedia!=undefined){
				var multimediatype = multimedia.multimediatype;
				var multimediaContent = '';
				if(multimediatype=='Image'){
					var img = multimedia.filename;
					multimediaContent = '<img src="'+img+'" class="img-responsive" style="width:100%">';
				} else if(multimediatype=='URL'){
					var videoUrl = multimedia.url;
					var isYoutube = videoUrl.indexOf('youtu') > -1;
					var embed = '';
					if(isYoutube){
						var videoId = youtube_parser(videoUrl);
						var embed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
					} else {
						var vimeoId = videoUrl.split('/');
						vimeoId = vimeoId[vimeoId.length - 1];
						var embed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
					}
					multimediaContent = embed;
				}
			}

			var hostname = window.location.hostname;

			$('.blog_list_itemcontainer').append('\
				<div class="row blogitem"> \
				<div class="col-md-12">\
				<a href="detail.php?id='+id_cmsconteudo+'">\
				<div class="row">\
				<div class="col-md-9 col-sm-12">\
				<p class="bi_title">'+title+'</p>\
				<p class="bi_postdate">posted on '+postDate+'</p>\
				<p class="bi_textresume">'+postResume+'</p>\
				</div>\
				<div class="col-md-3 col-sm-12">\
				<div class="bi_postdate">share</div>\
				<ul class="social-share-list">\
				<li>\
				<a href="https://www.facebook.com/sharer/sharer.php?u=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social_fb.png" alt="facebook">\
				</a>\
				</li>\
				<li>\
				<a href="https://twitter.com/intent/tweet?text='+title+' - Chilli Surfboards Blog https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social_twitter.png" alt="twitter">\
				</a>\
				</li>\
				<li>\
				<a href="https://plus.google.com/share?url=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social-google-plus.png" alt="google plus">\
				</a>\
				</li>\
				<li>\
				<a href="https://www.tumblr.com/share/link?url=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social-tumblr.png" alt="google plus">\
				</a>\
				</li>\
				</ul>\
				</div>\
				</div>\
				'+multimediaContent+'\
				</a>\
				</div>\
				<div class="row">\
				</div>\
				');
		}
	});
}

function service_BlogDetail(){
	var id_cmsconteudo = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/45/objects/'+id_cmsconteudo+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var id_cmsconteudo = data[0].id_cmsconteudo;
		var title = data[0].hptitle;
		var postDate = data[0].dt_publication.en;
		var postResume = data[0].hpresume;
		var multimedia = data[0].multimedia[0];
		if(multimedia!=undefined){
			var multimediatype = multimedia.multimediatype;
			var multimediaContent = '';
			if(multimediatype=='Image'){
				var img = multimedia.filename;
				multimediaContent = '<img src="'+img+'" class="img-responsive">';
			} else if(multimediatype=='URL'){
				var videoUrl = multimedia.url;
				var isYoutube = videoUrl.indexOf('youtu') > -1;
				var embed = '';
				if(isYoutube){
					var videoId = youtube_parser(videoUrl);
					var embed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
				} else {
					var vimeoId = videoUrl.split('/');
					vimeoId = vimeoId[vimeoId.length - 1];
					var embed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'?loop=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
				}
				multimediaContent = embed;
			}
		}

		$('.breadcrumb .active').text(title);

		$('.blog_list_itemcontainer').prepend('						\
			<div class="blogitem">									\
			<p class="bi_title">'+title+'</p>					\
			<p class="bi_postdate">'+postDate+'</p>				\
			<p class="bi_textresume">'+postResume+'</p>			\
			'+multimediaContent+'								\
			</div>													\
			');
	});
}












function submitToNewsletter(mail) {
	var email = '{ "email": "'+mail+'" }';
	$.ajax({
		url: sUrl+'/api/v1/subscribers?lang='+sLang,
		method: 'POST',
		data: email,
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {

		//console.log(data);

		if(data.subscribe == 'OK'){
			//$('#newsletter-sign-up-heading').text('You will be the first to know!');
			$('.submit_mailinglist_message').fadeIn(1300);
		}

	});
}
$(function(){
	$(document).on('click', '.ml_submit', function(){

		//alert('here');

		var email = $('.maillist_input').val();
		var isEmailValid = validateEmail(email);
		if(isEmailValid){
			submitToNewsletter(email);
			$('.submit_mailinglist').fadeOut(600);
		} else {
			$('.maillist_input').addClass('invalid_field');
			//var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
			//$('.maillist_input').addClass('animated wobble').one(animationEnd, function() {
		    //    $('.maillist_input').removeClass('animated wobble');
		    //});
			//$('.maillist_input').closest('.submit_mailinglist').addClass('invalid_field');
		}
	});
	$(document).on('submit', '.submit_mailinglist', function(e){
		e.preventDefault();
	});
	$(document).on('focusin', '.maillist_input', function(){
		$(this).removeClass('invalid_field');
		//$(this).closest('.submit_mailinglist').removeClass('invalid_field');
	});
});




















function home_getProducts(){

	$.ajax({
		url: sUrl+'/api/v1/shop/products/summary?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var itemsI = 0;

		var loops = 0;

        // holds the build html
        var html = '';

        // on the second row, cols change place, as according to the design
        var push_img = '';
        var pull_text = '';

        for(var key in data){

        	itemsI++;

        	var surfboardmodel = data[key].surfboardmodel;
        	var img = data[key].img.deck;
        	var currency = data[key].currency;
        	var price = data[key].price;
        	var subtitle = data[key].subtitle;
        	var id_surfboard = data[key].id_surfboard;
        	var id_producttype = data[key].id_producttype;

        	var destination = '';
			//if(id_producttype=='1' && id_producttype=='4'){ PBS says: WTF????
				if( id_producttype == '1'){
					destination = '/shop/boards/detail.php?id='+id_surfboard;
				} else {
					destination = '/index.php?page=shopaccessoriesdetail&id='+id_surfboard;
				}

            // PBS: build first row
            if( loops == 0 ){

            	html = '<div class="row">';

            }

            html +=
            '<div class="col-sm-6 shop-display-item">\
            <div class="row">\
            <div class="col-sm-5 '+push_img+' col-xs-6 shponlc_prodpic">\
            <a href="'+destination+'">\
            <img src="'+img+'" class="img-responsive">\
            </a>\
            </div>\
            <div class="col-sm-7 '+pull_text+' col-xs-6">\
            <h1>'+surfboardmodel+'</h1>\
            <p class="shop-display-details">'+subtitle+'</p>\
            <p class="shop-display-price">'+price+' </p>\
            <p class="currency-iso"></p>\
            <a href="'+destination+'" class="btn btn-default btn-130x30">buy now</a>\
            </div>\
            </div>\
            </div>';

            // close actual row and add new
            if( loops == 1 ){

            	html += '</div><div class="row border-top">';

                //push_img = 'col-sm-push-7';
                //pull_text = 'col-sm-pull-5';

              }

              loops++;

		} // end for

        // close open row
        html += '</div>';

        $('#shop-display-placeholder-surfboards').append( html );

      });

    // use same code for accessories and apparel
    // using data-section on the clicked item

    // cache ajax data
    var stored_data = [];

    $('#tab-accessories, #tab-apparel').on('click', function(e) {

    	var section = $(this).data('section');

        //console.log( section );

        var loops = 0;

        // holds the build html
        var html = '';

        // on the second row, cols change place, as according to the design
        var push_img = '';
        var pull_text = '';

        // return cached response or get fresh results
        return stored_data[section] || $.ajax({

        	url: sUrl + '/api/v1/shop/'+section+'?top=4',
        	method: 'GET',
        	context: document.body

        }).done(function (data) {

        	//console.log('getting new data');

        	stored_data[section] = data;

        	var itemsI = 0;

        	for (var key in data) {

        		var id_product = data[key].id_product;
                //var id_brand = data[key].id_brand;

                var brand = data[key].brand;

                var productName = brand+' '+ data[key].name.replace(brand,'');
                var currency = data[key].currency;
                var minprice = data[key].minprice;

                var colors = data[key].variant_colors;
                var nrOfColors = colors.length;
                var tabContent = '';
                var tabNavContent = '';

                if (nrOfColors == 0) {

                	var name = data[key].name;
                	var minprice = data[key].minprice;
                	var mainimg = data[key].mainimg;

                	tabContent += '<div class="tab-pane fade active in" id="prdvariant_' + key + '_1"><img src="' + mainimg + '" class="img-responsive"></div>';
                	tabNavContent = '';

                } else {

                	for (var key2 in colors) {

                        //var name = colors[key2].name;
                        var hexcolor = colors[key2].hexcolor;
                        var img = colors[key2].img;

                        if (key2 == 0) {

                        	var firstActive = 'active in';
                        	var firstLinkActive = 'active';

                        } else {

                        	var firstActive = '';
                        	var firstLinkActive = '';

                        }

                        tabContent += '<div class="tab-pane fade ' + firstActive + '" id="prdvariant_' + key + '_' + key2 + '"><img src="' + img + '" class="img-responsive"></div>';
                        tabNavContent += '<li class="' + firstLinkActive + '"><div class="variant_color" href="#prdvariant_' + key + '_' + key2 + '" data-toggle="tab" style="background-color:' + hexcolor + ';" data-colorname="' + colors[key2].name + '" data-id-product="'+id_product+'">' + key2 + '</div></li>';

                    } // end for key in colors

                } // end else



                // PBS: build first row
                if( loops == 0 ){

                	html = '<div class="row">';

                }

                html +=
                '<div class="col-sm-6 shop-display-item">\
                <div class="row">\
                <div class="col-sm-5 '+push_img+' col-xs-6 shponlc_prodpic">\
                <a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'">\
                <div class="tab-content">'+tabContent+'</div>\
                </a>\
                <div class="variants_nav">\
                <ul>'+tabNavContent+'</ul>\
                </div>\
                </div>\
                <div class="col-sm-7 '+pull_text+' col-xs-6">\
                <h1>'+productName+'</h1>\
                <p class="shop-display-price">'+minprice+' </p>\
                <p class="currency-iso"></p>\
                <a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'" class="btn btn-default btn-130x30" id="link-product-'+id_product+'" data-initial-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'">buy now</a>\
                </div>\
                </div>\
                </div>';

                // close actual row and add new
                if( loops == 1 ){

                	html += '</div><div class="row border-top">';

                    //push_img = 'col-sm-push-7';
                    //pull_text = 'col-sm-pull-5';

                  }

                  loops++;

            }// end for key in data

            // close open row
            html += '</div>';

            $('#shop-display-placeholder-'+section).append( html );

        }) // end done

      })


    // PBS - default btn does not have link with variant..
    $(document).on('click', '.variant_color', function(){

    	//console.log( $( this ).data('id-product'));
    	var link = $( '#link-product-' + $( this ).data('id-product') );

    	//console.log( link.data('initial-url') );

        //console.log( $( link ) );

        //console.log( link.prop('data-initial-url') );
        //console.log( link.prop('data', 'initial-url') );

        link.prop('href',$(link).data('initial-url')+'&variantcolor='+$(this).data('colorname') );

      })

  }


  function get_ShopHomeList(){
  	$.ajax({
  		url: sUrl+'/api/v1/shop/surfboards?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var surfboardmodel = data[key].surfboardmodel;
  			var img = data[key].img.deck;
  			var currency = data[key].currency;
  			var price = data[key].price;
  			var subtitle = data[key].subtitle;
  			var id_surfboard = data[key].id_surfboard;

            // PBS: simplify things!
            $('.shophome_surfboards').prepend('\
            	<div class="col-sm-3">\
            	<a href="/shop/boards/detail.php?id='+id_surfboard+'">\
            	<img src="'+img+'" class="img-responsive center-block">\
            	<h1>'+surfboardmodel+'</h1>\
            	<p>'+subtitle+'</p>\
            	<p class="price">\
            	'+currency.symbol+''+price+'\
            	<span class="currency">'+currency.iso+'</span>\
            	</p>\
            	</a>\
            	</div>\
            	');
          }
        });



  	$.ajax({
  		url: sUrl+'/api/v1/shop/accessories?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var id_product = data[key].id_product;
  			var id_brand = data[key].id_brand;

  			var name = data[key].name;
  			var currency = data[key].currency;
  			var minprice = data[key].minprice;


  			var colors = data[key].variant_colors;
  			var nrOfColors = colors.length;
			var tabContent = ''; //service_SurfboardModelDetail();
			var tabNavContent = '';

			if(nrOfColors==0){
				var name = data[key].name;
				var minprice = data[key].minprice;
				var mainimg = data[key].mainimg;
				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
				tabNavContent = '';
			} else {
				for(var key2 in colors){
					var name = colors[key2].name;
					var hexcolor = colors[key2].hexcolor;
					var img = colors[key2].img;


					if(key2==0){
						var firstActive = 'active in';
						var firstLinkActive = 'active';
					} else {
						var firstActive = '';
						var firstLinkActive = '';
					}
					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
				}
			}

			$('.shophome_accessories').prepend('\
				<div class="col-sm-3">\
				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories">\
				<div class="tab-content">'+tabContent+'</div>\
				<h1>'+name+'</h1>\
				<p class="price">\
				<span>'+currency.symbol+'</span>\
				'+minprice+'<span class="currency"> '+currency.iso+'</span>\
				</p>\
				<div class="variants_nav">\
				<ul>'+tabNavContent+'</ul>\
				</div>\
				</a>\
				</div>\
				</div>\
				');
		}

        /*
		setListItemHeight($('.si_img'));
		setTimeout(function(){
			setListItemHeight($('.si_img'));
		}, 100);
		*/

	});



  	$.ajax({
  		url: sUrl+'/api/v1/shop/apparel?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var id_product = data[key].id_product;
  			var id_brand = data[key].id_brand;

  			var name = data[key].name;
  			var currency = data[key].currency;
  			var minprice = data[key].minprice;


  			var colors = data[key].variant_colors;
  			var nrOfColors = colors.length;
  			var tabContent = '';
  			var tabNavContent = '';

  			if(nrOfColors==0){
  				var name = data[key].name;
  				var minprice = data[key].minprice;
  				var mainimg = data[key].mainimg;
  				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
  				tabNavContent = '';
  			} else {
  				for(var key2 in colors){
  					var name = colors[key2].name;
  					var hexcolor = colors[key2].hexcolor;
  					var img = colors[key2].img;


  					if(key2==0){
  						var firstActive = 'active in';
  						var firstLinkActive = 'active';
  					} else {
  						var firstActive = '';
  						var firstLinkActive = '';
  					}
  					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
  					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
  				}
  			}

  			$('.shophome_apparel').prepend('\
  				<div class="col-sm-3">\
  				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
  				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel">\
  				<div class="tab-content">'+tabContent+'</div>\
  				<h1>'+name+'</h1>\
  				<p class="price"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>\
  				<div class="variants_nav">\
  				<ul>'+tabNavContent+'</ul>\
  				</div>\
  				</a>\
  				</div>\
  				</div>\
  				');
  		}




        /*
		setListItemHeight($('.si_img'));
		setTimeout(function(){
			setListItemHeight($('.si_img'));
		}, 100);
		*/
	});
  }


//gets miscellaneous pages
function service_miscpage(id){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/47/objects/'+id+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var headerImg = data[0].multimedia[0].filename;
		var hptitle = data[0].hptitle;
		var atext = data[0].atext;

		$('#chilli_carousel .item img').attr('src', headerImg);
		$('.breadcrumb .active').text(hptitle);
		$('.carousel-caption p').text(hptitle);
		$('.miscpage_container .miscpage_container_inner').append(atext);
	});
}


//PBS 05.2016: instagram sprays
function instagram_sprays(){

    //alert('olé!');

    $.ajax({
    	type: "GET",
    	dataType: "jsonp",
    	cache: false,
        //url: "https://api.instagram.com/v1/users/2326332367/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //@pedrosilvashaperbuddy
        url: "https://api.instagram.com/v1/users/2326332367/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d",
        success: function(response) {

            //console.log( response );
            
            //first row
            var instagram_sprays_html = '<div class="row">';

            $.each(response.data, function(){

                //console.log(this.images);
                //console.log(this.likes);

                instagram_sprays_html +=
                '<div class="col-md-4 col-sm-3 col-xs-6 instagram-sprays-col">\
                <a href="'+this.link+'" target="_blank">\
                <div class="instagram-sprays-inner">\
                <div class="instagram-sprays-overlay">'+this.likes.count+'<i class="glyphicon glyphicon-heart"></i></div>\
                <img src="'+this.images.standard_resolution.url+'" class="img-responsive" alt="instagram spray">\
                </div>\
                </a>\
                </div>';

              })

            //close open row
            instagram_sprays_html += '</div>';

            $('#instagram-sprays-container').append( instagram_sprays_html );

            var loops = 0;

            //some anim..
            $.each( $('.instagram-sprays-col'), function(){

            	//console.log( this );

            	loops++;

            	$(this).delay( loops * 500).fadeIn();

            })

          }
        });

  }





/**
 *
 * HOME PAGE
 *
 */

//	Load BY TYPE and BY BRAND in shop boards section
function service_LoadTypeBrand(){
	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/filters?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			if( data[key].name == "By Sport" ){

        		//$.each( data[key].item, function(){
        			for(var key2 in data[key].item){
        				$('#by-type-dropdown').append(
        					'<li>\
        					<a href="#" data-filter-id="'+key2+'" data-filter-by="type" data-filter-value="'+data[key].item[key2]+'">\
        					'+data[key].item[key2]+'\
        					</a>\
        					</li>'
        					);
        			}

        		}

        	}

        });

	$.ajax({
		url: sUrlShop+'/api/v1/brands?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			$('#by-brand-dropdown').append(
				'<li>\
				<a href="#" data-filter-id="'+key+'" data-filter-by="brand" data-filter-value="'+data[key]+'">\
				'+data[key]+'\
				</a>\
				</li>'
				);
			
		}

	});

}

// change by type or by brand
//$('#by-type-dropdown a, #by-brand-dropdown a').on('click', function( e ){
	$(document).on('click', '#by-type-dropdown a, #by-brand-dropdown a', function(e){	
		e.preventDefault();
		var _this = $(this);

    // remove previous
    _this.closest('ul').find('.active').removeClass('active');
    _this.addClass('active');
    
    build_shop_boards_carousel( $('#by-type-dropdown a.active').data('filter-id'), $('#by-brand-dropdown a.active').data('filter-id') );
  })

// function for load the surfboardmodels
function build_shop_boards_carousel( type_id, brand_id ){
	$('#boards-carousel').fadeOut(500 , function(){

		var item_content = '';
		var id_sport = '';
		var id_brand = '';
		var board_loops = total_board_loops = item_loops = 0;   

		if( type_id != undefined ){
			id_sport = type_id;
		}
		
		if( brand_id != undefined ){
			id_brand = brand_id;
		}

		$.ajax({
			url: sUrl+'/api/v1/surfboardmodels?id_sport='+id_sport+'&id_brand='+id_brand+'&order=latestmodel&lang='+sLang,
			method: 'GET',
			context: document.body
		}).done(function(data) {
			
			if( data.length == 0 ){
				item_content += 
				'<div class="col-xs-12 col-md-4 board text-center">\
				<div class="row">\
				<a href="#">\
				<div class="board-btn-wrapper">\
				<!-- button -->\
				</div>\
				<div class="col-xs-12">\
				<!-- img -->\
				</div>\
				<div class="col-xs-12 brand">\
				<!-- brand -->\
				</div>\
				<div class="col-xs-12 model">\
				<!-- model -->\
				</div>\
				<div class="col-xs-12 price">\
				<!-- price -->\
				</div>\
				</a>\
				</div>\
				</div>';
			}

			var board_loops_max = 2;
			var data_key_max = 14;
			if( $(window).width()<577 ){
				board_loops_max = 0;
				data_key_max = 5;
			}

	        //$.each( data, function(){     
	        	for(var key in data){   

	        		if( key <= data_key_max ){
		            //start new slide / item if board_loops == 0
		            if( board_loops == 0 && item_loops ==  0 )
		            	item_content += '<div class="item active">';
		            else if( board_loops == 0 )
		            	item_content += '<div class="item">';

		            // image board
		            var img_surfboard = "/assets/img/surfboard.png";
		            //console.log( data[key].img_dynamic );
		            if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
		            	img_surfboard = data[key].img_dynamic;
		            }
		            
		            // currency symbol and currency iso
		            var currency_symbol = currency_iso = '';
		            var min_price = '';
		            if( data[key].min_price != '' ){
		            	currency_symbol = data[key].currency.symbol;
		            	currency_iso = data[key].currency.iso;
		            	min_price = '<small>From</small> '+data[key].min_price;
		            }

		            item_content += 
		            '<div class="col-xs-12 col-md-4 board text-center">\
		            <div class="row">\
		            <a href="/shop/boards/?model='+data[key].id_surfboardmodel+'">\
		            <div class="board-btn-wrapper">\
		            <button class="btn btn-primary">SHOP BOARD</button>\
		            </div>\
		            <div class="col-xs-12">\
		            <img src="'+img_surfboard+'?h=506" class="-img-responsive" alt="board">\
		            </div>\
		            <div class="col-xs-12 brand">\
		            '+data[key].brand+'\
		            </div>\
		            <div class="col-xs-12 model">\
		            '+data[key].surfboardmodel+'\
		            </div>\
		            <div class="col-xs-12 price">\
		            '+currency_symbol+' '+min_price+' '+currency_iso+'\
		            </div>\
		            </a>\
		            </div>\
		            </div>';

		            board_loops ++;
		            total_board_loops ++;

		            // if board_loops > 1 close slide
		            // or reached the end
		            if( board_loops > board_loops_max || total_board_loops == data.length ){

		            	board_loops = 0;
		            	item_loops ++;
		            	item_content += '</div>';
		            }   
		          }         
		        }
		        $('#shop-boards-carousel-row-inner #boards-carousel .carousel-inner').html( item_content );
	        //console.log( item_content );

	        var indicators = '';
	        for( var i= 0; i < item_loops; i++ ){
	        	if( i == 0 )
	        		indicators += '<li data-target="#boards-carousel" data-slide-to="'+i+'" class="active"></li>';
	        	else
	        		indicators += '<li data-target="#boards-carousel" data-slide-to="'+i+'"></li>';
	        }
	        $('#shop-boards-carousel-controls .carousel-indicators').html( indicators ); 
	      })

        /*if( filter_type == 'brand' ){
            var boards = ['02.png','02.png','02.png','02.png','02.png','02.png'];
        }
        else{
            var boards = ['01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png'];
          }*/

        //console.log( item_content );

        //$('#shop-boards-carousel-row-inner #boards-carousel .carousel-inner').html( item_content );

    })// end fadeOut    
$('#boards-carousel').fadeIn();
}

/**
 *
 * BRANDS PAGE
 *
 */

//	Carrega as Brands na página brands.php 
function service_Brands(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/59/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			if( data[key].ordemnp!='' ){	

				$('#brands-logo-row').append('\
					<a href="'+data[key].hpurl+'" data-hptitle="'+data[key].hptitle+'">\
					<div class="col-xs-6 col-sm-2 brand_flip text-center">\
					<img class="img-responsive" src="'+data[key].bannerimg+'" alt="" style="margin: 0 auto; margin-top:50%; transform:translateY(-50%);">\
					<h1 style="transform: translateY(-150%);">'+data[key].hptitle+'</h1>\
					</div>\
					</a>\
					');

			}

		}

		var brand_flip_width = $('.brand_flip:first').width();
		$('.brand_flip').each(function(){
			$(this).css('height', brand_flip_width);
		})

	});
}
$(document).on('mouseover', '.brand_flip', function(){
	var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	$(this).addClass('animated flipInY').one(animationEnd, function() {
		$(this).removeClass('animated flipInY');
	});
})

/**
 *
 * BOARDS PAGE
 *
 */

// Carrega todas as pranchas de todas as marcas (4 pranchas por cada marca)
function service_getBoardsPage(){

	$.ajax({
		url: sUrlShop+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var id_brand = "";
		var count = 0;
		var count_max = 5;

		$('#surfboards-container .board-container').fadeOut(1000).empty();

		for (var key in data) {

		// image board
		var img_surfboard = "/assets/img/surfboard.png";
		if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
			img_surfboard = data[key].img_dynamic;
		}

          // logo image
          var img_logo = "/assets/img/brands/rusty.png";
          if( data[key].img_brand_logo != '' && data[key].img_brand_logo != undefined ){
          	img_logo = data[key].img_brand_logo;
          }

          // min price
          var min_price = '';
          var currency_symbol = '';
          var currency_iso = '';
          if( data[key].min_price != '' ){
          	currency_symbol = data[key].currency.symbol;
          	currency_iso = data[key].currency.iso;
          	min_price = '<small>From</small> '+data[key].min_price;
          }

          if( data[key].id_brand != id_brand ){
          	id_brand = data[key].id_brand;
          	count = 1;
				//console.log( '1: '+count );
				$('#surfboards-container .board-container').append('\
					<div class="brand-content col-sm-12" data-id_brand="'+data[key].id_brand+'" id="brand_'+data[key].id_brand+'">\
					<div class="row text-center">\
					<img class="brand-img" src="'+img_logo+'" alt="Logo">\
					</div>\
					<div class="row">\
					<h2 class="spacemono">'+data[key].brand+'</h2>\
					</div>\
					<div class="row board-row-content"></div>\
					<div class="row text-center">\
					<button class="btn btn-primary">View All Available Models</button>\
					</div>\
					</div>\
					<div class="clearfix">&nbsp;</div>').hide().fadeIn(1000);
			}
			if( data[key].id_brand == id_brand ){
				count ++;
				//console.log( '2: '+count );
				if( count <= count_max ){
					$('#surfboards-container .board-container .brand-content[data-id_brand='+data[key].id_brand+'] .board-row-content').append('\
						<div class="col-sm-3 board text-center">\
						<div class="row">\
						<a href="/boards/detail.php?id='+data[key].id_surfboardmodel+'">\
						<div class="col-sm-12">\
						<img src="'+img_surfboard+'?h=506" class="img-responsive" alt="board">\
						</div>\
						<div class="col-sm-12 brand spacemono">'+data[key].brand+'</div>\
						<div class="col-sm-12 model spacemono">'+data[key].surfboardmodel+'</div>\
						<div class="col-xs-12 price spacemono">'+currency_symbol+' '+min_price+' '+currency_iso+'</div>\
						</a>\
						</div>\
						</div>\
						').hide().fadeIn(1000);
				}
				/*<div class="col-sm-3 board text-center">\
		                        <div class="row">\
		                            <a href="#">\
		                                <div class="col-sm-12">\
		                                    <img src="/assets/img/homepage-boards-carousel/01.png" class="-img-responsive" alt="board">\
		                                </div>\
		                                <div class="col-sm-12 brand">brand</div>\
		                                <div class="col-sm-12 model">model</div>\
		                            </a>\
		                        </div>\
		                        </div>\*/
		                      }


		                    }

		                  });
}

 /* ========================================================================
 * Carrega apenas as pranchas de uma marca específica ao clicar no botao 
 * ======================================================================== */
 function service_getBoardsPage_detail(_id_brand){

 	$.ajax({
 		url: sUrlShop+'/api/v1/surfboardmodels?id_brand='+_id_brand+'&lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		var id_brand = "";
 		var count = 0;

 		$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+']').fadeOut("slow").empty();
 		for (var key in data) {
			/* ========================================================================
			 * image board
			 * ======================================================================== */
			 var img_surfboard = "/assets/img/surfboard.png";
			 if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
			 	img_surfboard = data[key].img_dynamic;
			 }

            	// min price
            	var min_price = '';
            	var currency_symbol = '';
            	var currency_iso = '';
            	if( data[key].min_price != '' ){
            		currency_symbol = data[key].currency.symbol;
            		currency_iso = data[key].currency.iso;
            		min_price = '<small>From</small> '+data[key].min_price;
            	}

            	// logo image
            	var img_logo = "/assets/img/brands/rusty.png";
            	if( data[key].img_brand_logo != '' && data[key].img_brand_logo != undefined ){
            		img_logo = data[key].img_brand_logo;
            	}
            	if( data[key].id_brand != id_brand ){
            		id_brand = data[key].id_brand;
            		count = 1;
            		$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+']').append('\
            			<div class="row text-center">\
            			<img class="brand-img" src="'+img_logo+'" alt="">\
            			</div>\
            			<div class="row">\
            			<h2 class="spacemono">'+data[key].brand+'</h2>\
            			</div>\
            			<div class="row board-row-content"></div>\
            			<div class="row text-center">\
            			</div>\
            			<div class="clearfix">&nbsp;</div>')
				//.hide().fadeIn(1000);
				.stop().slideDown("slow");
			}
			if( data[key].id_brand == id_brand ){
				count ++;
				$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+'] .board-row-content').append('\
					<div class="col-sm-3 board text-center">\
					<div class="row">\
					<a href="/boards/detail.php?id='+data[key].id_surfboardmodel+'">\
					<div class="col-sm-12">\
					<img src="'+img_surfboard+'?h=506" class="img-responsive" alt="board">\
					</div>\
					<div class="col-sm-12 brand spacemono">'+data[key].brand+'</div>\
					<div class="col-sm-12 model spacemono">'+data[key].surfboardmodel+'</div>\
					<div class="col-xs-12 price spacemono">'+currency_symbol+' '+min_price+' '+currency_iso+'</div>\
					</a>\
					</div>\
					</div>\
					')
				//.hide().fadeIn(1000);
				.stop().slideDown("slow");
			}
		}
	});
 }
// Quando carrega no botao para exibir mais pranchas dessa marca
$(document).on('click', '.brand-content button.btn.btn-primary', function(){
	var _this = $(this);
	var id_brand = _this.closest('.brand-content').attr('data-id_brand');
	if( id_brand!=undefined ){
		service_getBoardsPage_detail(id_brand);
		//_this.fadeOut(1000);	
		_this.slideUp("3000");
	}
	
})

/**
 *
 * ABOUT PAGE
 *
 */

// Carrega as informações no About
function service_getAbout(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/563?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#about-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o título do texto
			$('.about-text .text h1').hide().text( data[key].atitle ).fadeIn();
			// Aplica o conteudo do texto
			$('.about-text .text .p_text').hide().html( data[key].atext ).fadeIn();
			// Aplica a imagem de fundo
			$('.about-img img').hide().attr('src', data[key].multimedia[0].filename).fadeIn();

		}
	});

}

/**
 *
 * SHIPPING PAGE
 *
 */

// Carrega as informações no Shipping
function service_getShipping(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/562?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#shipping-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o título do texto
			$('#shipping-container h1.atitle').hide().text( data[key].atitle ).fadeIn();
			// Aplica o conteudo do texto
			$('#shipping-container .atext').hide().html( data[key].atext ).fadeIn();
			// Aplica a imagem de fundo
			$('.about-img img').hide().attr('src', data[key].multimedia[0].filename).fadeIn();

		}
	});

}

/*
 *
 *	STORES PAGE
 *
 */

// Carrega as informações na pagina de stores (conteudo esta estatico mas carrega o mapa)
function initCStoresMap(coordinates) {
	var myLatlng = coordinates;
	var mapOptions = {
		center: myLatlng,
		zoom: 16,
		scrollwheel: false
	};
	var map = new google.maps.Map(document.getElementById('stores1_map'), mapOptions);
	var marker = new google.maps.Marker({
		position: myLatlng,
	});
	marker.setMap(map);
}
function service_getStores(){
	setTimeout(function(){
		var coordinates = new google.maps.LatLng('38.716308','-9.166803');
		initCStoresMap(coordinates);
	}, 1000);
}


/**
 *
 * RETURN AND POLICY PAGE
 *
 */

// Carrega as informações no Return and Policy
function service_getReturnPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/577?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * WARRANTY POLICY PAGE
 *
 */

// Carrega as informações no Warranty Policy
function service_getWarrantyPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/578?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * PRIVACY POLICY PAGE
 *
 */

// Carrega as informações no Privacy and Policy
function service_getPrivacyPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/599?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * HOME PAGE
 *
 */

// Carrega as informações da loja na homepage
function service_getTheBaseStores(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/56/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#the-base-stores-container h1.cross').hide().text( data[0].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#the-base-stores-container .atext').hide().html( data[0].atext ).fadeIn();
			// Aplica o url no botao "view all locations"
			if( data[0].hpurl!=null ){
				$('#the-base-stores-container .btn-viewalllocations').attr('href', data[0].hpurl);
			}else{
				//$('#the-base-stores-container .btn-viewalllocations').attr('href', '/stores.php');
				$('#the-base-stores-container .btn-viewalllocations').fadeOut(500);
			}
			// Aplica a imagem de fundo
			//$('#the-base-stores-container #shop-carousel-row img').hide().attr('src', data[0].multimedia[0].filename).fadeIn();
			$('#the-base-stores-container #shop-carousel-row .carousel-inner').empty();
			$('#the-base-stores-container #shop-carousel-row #carousel-controllers-wrapper .carousel-indicators').empty();
			if( data[0].multimedia.length==1 ){
				$('#the-base-stores-container #shop-carousel-row .carousel-inner').append('\
					<!-- carousel item 1 -->\
					<img src="'+data[0].multimedia[0].filename+'" class="img-responsive" alt="shop">\
					<!--/ carousel item 1 -->\
					');
				$("#shop-carousel-row #carousel-controllers-wrapper").remove();
			}else if( data[0].multimedia.length>1 ){
				for(key in data[0].multimedia){
					
					var itemclass = "";
					if( key == 0 ){
						itemclass = "active";
					}

					// Insere a imagem no slider
					$('#the-base-stores-container #shop-carousel-row .carousel-inner').append('\
						<div class="item '+itemclass+'"><img src="'+data[0].multimedia[key].filename+'" class="img-responsive" alt="shop"></div>\
						');
					// Insere o indicador no slider
					$('#the-base-stores-container #shop-carousel-row #carousel-controllers-wrapper .carousel-indicators').append('\
						<li data-target="#shop-carousel-row" data-slide-to="'+key+'" class="'+itemclass+'"></li>\
						');	

				}
			}
		}
	});

}

// Carrega as imagens no carousel header
function service_getCarouselHeader(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/57/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// HOMEPAGE: TEXTO DO BANNER
			if( data[key].hptitle!=undefined ){
				var string_home = data[key].hptitle;		//var string_home = "only online | 25% | off on all JR Surfboards";
				string_home = string_home.replace('||','<br>');
				var string_home_array = string_home.split('|');
				var string_home_final = '';
				for (key2 in string_home_array) {
					if( key2==1 ){
						if( string_home_array[key2]!='' ){
							string_home_final += '<span class="text2">'+string_home_array[key2]+'</span>';
						}
					}else{
						string_home_final += '<span class="text1">'+string_home_array[key2]+'</span>';
					}
				}
			}
			// end HOMEPAGE: TEXTO DO BANNER

			var itemclass = "";
			if( key == 0 ){
				itemclass = "active";
			}



			$('#carousel-header .carousel-inner').append('\
				<!--carousel item -->\
				<div class="item '+itemclass+'" style="background:url('+data[key].bannerimg+'); background-size:cover; background-position: center center;">\
				<div class="container">\
				<div class="carousel-caption">\
				<div class="row">\
				<div class=" col-xs-12 col-sm-8 col-sm-offset-1 col-md-6 col-md-offset-2">\
				<div class="caption">\
				'+string_home_final+'\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				<!--/carousel item-->');

			$('#carousel-header #carousel-controllers-wrapper ol').append('\
				<li data-target="#carousel-header" data-slide-to="'+key+'" class="'+itemclass+'"></li>\
				');
		}

	});

}

//	Carrega as Brands na página home 
function service_BrandsHome(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/59/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var count = 0;
		var brands = {};
		brands.ordemhp = [];
		brands.hptitle = [];
		brands.bannerimg = [];
		brands.hpurl = [];
		//var brands_array = new Array(); // [0]-ordemhp  [1]-hptitle  [2]-bannerimg 

		for(var key in data){

			if( data[key].ordemhp!='' ){

				brands.ordemhp.push(data[key].ordemhp);
				brands.hptitle.push(data[key].hptitle);
				brands.bannerimg.push(data[key].bannerimg);
				brands.hpurl.push(data[key].hpurl);
				count ++;

			}

		}

		var aux = 0;
		function ordenarBrands(key2, ordemhp, hptitle, bannerimg, hpurl){
			if( ordemhp >= aux && aux < 6 ){
				$('#brands-logo-row').append('\
					<a href="'+hpurl+'" data-hptitle="'+hptitle+'">\
					<div class="col-xs-6 col-sm-2 brand_flip text-center">\
					<img class="img-responsive" src="'+bannerimg+'" alt="" style="margin: 0 auto; margin-top:50%; transform:translateY(-50%);">\
					<h1 style="transform: translateY(-150%);">'+hptitle+'</h1>\
					</div>\
					</a>\
					');
				aux ++;
			}
		}

		do {
			for(var key2 in brands.ordemhp){
				ordenarBrands(key2, brands.ordemhp[key2], brands.hptitle[key2], brands.bannerimg[key2], brands.hpurl[key2]);	
			}
		}
		while (aux <= 5);


		var brand_flip_width = $('.brand_flip:first').width();
		$('.brand_flip').each(function(){
			$(this).css('height', brand_flip_width);
		})

	});
}

// Carrega as informações dos destaques na homepage
function service_getFeatures(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/60/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		$('#main-links-first-row').empty();

		for(var key in data){

			var button = '';
			if( data[key].atitle!='' ){
				button = '<a href="'+data[key].hpurl+'" class="btn btn-primary">'+data[key].atitle+'</a>';
			}

			$('#main-links-first-row').append('\
				<!-- imagem destaque '+key+' -->\
				<a href="'+data[key].hpurl+'">\
				<div class="img-hover col-xs-12 col-sm-12 col-md-6">\
				<div class="img-mask">\
				<img height="300px" src="'+data[key].bannerimg+'" class="img-responsive" alt="imagem destaque">\
				</div>\
				<div class="xpto" style="position:absolute; z-index:999; top:0; width:100%; right:15px;">\
				<div class="row">\
				<div class="col-xs-12 text-center" style="position:relative">\
				<div class="main-links-text spacemono">\
				<h1 class="text-center">\
				'+data[key].hptitle+'\
				<br>\
				'+data[key].atext+'\
				</h1>\
				'+button+'\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				</a>\
				<!--/ imagem destaque '+key+' -->\
				');
			
		}
	});

}

/*

Tooltip

$(document).ready(function(){
//$(function(){	
	$('a').each(function(){
		if( $(this).attr('href') == '#' ){
			$(this).attr('title', 'Comming Soon');
			$(this).attr('data-toggle', 'tooltip');
		}
	})

	$('[data-toggle="tooltip"]').tooltip({
		position: {
			my: "left center",
			at: "right+30 center"
		}
	});
});

*/

/*
 *
 *	SHOP Surfboards (Filter Properties) 
 *
 */
// Seta as informacoes de marca e desporto nos modelos para o filtro funcionar dinamicamente
function service_setFilterProperties(){

	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/filters/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var aux_id_brand = 0;
		var aux_id_sport = 0;

		$('.slfg_items_inner[data-filterdataname=id_surfboardmodel]').empty();

		for(var key in data){
			var label_sport = '';
			var label_brand = '';

			if( data[key].id_brand!=aux_id_brand || data[key].id_sport!=aux_id_sport ){
				aux_id_brand = data[key].id_brand;
				label_brand = '<label class="label_brand" data-id_sport="'+data[key].id_sport+'" data-id_brand="'+data[key].id_brand+'"><span>'+data[key].brand+'</span></label>';
			}

			if( data[key].id_sport!=aux_id_sport ){
				aux_id_sport = data[key].id_sport;
				label_sport = '<label class="label_sport" data-id_sport="'+data[key].id_sport+'"><span>'+data[key].sport+'</span></label>';
			}

			$('.slfg_items_inner[data-filterdataname=id_surfboardmodel]').append('\
				'+label_sport+'																					\
				'+label_brand+'																					\
				<label data-itemsufix="">																		\
				<input class="sblf_filtercheck filterdata" type="checkbox" name="id_surfboardmodel" 		\
				value="'+data[key].id_surfboardmodel+'" 													\
				data-id_sport="'+data[key].id_sport+'" 														\
				data-id_brand="'+data[key].id_brand+'">														\
				'+data[key].surfboardmodel+' 																\
				</label>																						\
				');
			
		}

	});

}



/**
 *
 * CUSTOM ORDER - INFO
 *
 */

// Carrega as informações no Privacy and Policy
function service_getCustomOrderInfo(){

	$.ajax({
		url: sUrl+'/api/v1/shop/texts/customerorderinfo',
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// custom order info
		$(".container-customorder #info .cms-content").html( data[0].texto );
		
	});

}

/**
 *
 * CHECKOUT - ( PAYMENT OPTIONS | SHIPPING OPTIONS | CuSTOMER SERVICE )
 *
 */

// Carrega as informações no Privacy and Policy
function service_getCheckoutTablesInfo(){

	$.ajax({
		url: sUrl+'/api/v1/shop/texts/checkout',
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// 1
		// title
		//$(".checkout_disclaimer .table1_info h3").text();
		// content
		$(".checkout_disclaimer .table1_info .cms-content").html( data[0].texto );
		
		// 2
		// title
		//$(".checkout_disclaimer .table2_info h3").text();
		// content
		$(".checkout_disclaimer .table2_info .cms-content").html( data[1].texto );
		// button
		//$(".checkout_disclaimer .table2_info .cdi_btnwrapper a").attr("src", "/shipping.php");
		//$(".checkout_disclaimer .table2_info .cdi_btnwrapper a").text("Check Shipping Rates");
		
		// 3
		// title
		//$(".checkout_disclaimer .table3_info h3").text();
		// content
		$(".checkout_disclaimer .table3_info .cms-content").html( data[2].texto );
		
	});

}

/**
 *
 * ARTICLE PAGE
 *
 */

// Carrega as informações dos detalhes na pagina do produto (shop)
function service_getArticlePageInfo(){

	$.ajax({
		url: sUrlShop+'/api/v1/shop/texts/articlepage?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// Article Page (Payment and Security)
		$(".sld_paymentandsecurity .cms-content").html( data[0].texto );

		// Article Page (Shipping)
		$(".sld_shipping .cms-content").html( data[1].texto );
		
	});

}
function toFeet(n) {
    return Math.floor(n / 12) + "'" + (n % 12) + '"';
}



function getStandarDimensionsFilter(){
	
	var id_surfboardmodel = getQueryString('id_surfboardmodel');
	var length_complete = getQueryString('length_complete');
	
	$('.sblf_filtercheck[name=id_surfboardmodel]').each(function(){
		var t = $(this);
		var val = t.val();
		
		if(val==id_surfboardmodel){
			t.prop('checked', true);
		}
	});

    // it´ already done elsewhere..
    /*
	$('.filterrange_6').slider({
		range: true,
		values: [length_complete, length_complete]
	});

	$('.filterrange_6').closest('label').find('.fr_display').val(toFeet(length_complete)+' Ft');
     */
	
	filterShopBoards();
	
}


// PBS slider change update
// 26.06.2016: added value_min and value_max to use in case o model and length being passed via GET
function startBoardSizeSlider(element, rangeMin, rangeMax, value_min, value_max){

    //console.log( element, rangeMin, rangeMax, value_min, value_max );

    if( value_min == undefined ) value_min = rangeMin;
    if( value_max == undefined ) value_max = rangeMax;

    var slider = $('.'+element+'');
    var isBoardSize = slider.hasClass('filterrange_6');
    var isBoardVolume = slider.hasClass('filterrange_7');
    var isBoardPrice = slider.hasClass('filterrange_11');

    //return;

    slider.slider({
        range: true,
        min: rangeMin,
        max: rangeMax,
        values: [value_min, value_max],
        slide: function(event, ui) {

            //$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
            //$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

            //filterShopBoards();

        },

        change: function(ev, ui){

        }

    });

    slider.closest('label').find('.frp_col1 input').val(slider.slider('values', 0));
    slider.closest('label').find('.frp_col3 input').val(slider.slider('values', 1));

    if(isBoardSize){

        window.rangeMin = rangeMin;
        window.rangeMax = rangeMax;

        slider.slider({

            slide: function(event, ui) {

                //if( event != undefined ){

                var minFeetVal = toFeet(ui.values[0]);
                var maxFeetVal = toFeet(ui.values[1]);
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Ft');
                $(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Ft');

                //}

                console.log('sliding..');

                // where are the values stored?
                filterShopBoards();
            },

            change: function(ev, ui){

                //console.log('change event');
                //console.log(ev, ui);

            },

            stop: function(event, ui){


                // PBS: applying filters only on stop..
                filterShopBoards();

            }

        });

        var minVal = toFeet(slider.closest('label').find('.frp_col1 input').val());
        var maxVal = toFeet(slider.closest('label').find('.frp_col3 input').val());
        slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Ft')
        slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Ft')

        /*
         slider.slider('values', 50, 50);
         slider.slider('values', 50, 50);
         slider.slider('option', 'slide').call($slider);
         */
        //$(".filterrange_6").slider('values', new_length, new_length);

        //$(".filterrange_6").slider('values',0,50); // sets first handle (index 0) to 50
        //$(".filterrange_6").slider('values',1,80);
        //$(".filterrange_6").slider('refresh');



    }




    if(isBoardVolume){
        slider.slider({
            slide: function(event, ui) {
                var minFeetVal = ui.values[0];
                var maxFeetVal = ui.values[1];
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Lt');
                $(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Lt');

                filterShopBoards();
            }
        });

        var minVal = slider.closest('label').find('.frp_col1 input').val();
        var maxVal = slider.closest('label').find('.frp_col3 input').val();
        slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
        slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')
    }


    if(isBoardPrice){
        slider.slider({
            slide: function(event, ui) {
                var minPriceVal = ui.values[0];
                var maxPriceVal = ui.values[1];
                //$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                //$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val('$ '+minPriceVal+' USD');
                $(this).closest('label').find('.frp_col3 .fr_display').val('$ '+maxPriceVal+' USD');
                
                
            },
            change: function(ev, ui){

                console.log('change event');
                var minPriceVal = ui.values[0];
                var maxPriceVal = ui.values[1];
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
                $(this).closest('label').find('.frp_col1 .fr_display').val('$ '+minPriceVal+' USD');
                $(this).closest('label').find('.frp_col3 .fr_display').val('$ '+maxPriceVal+' USD');
                filterShopBoards();

            }
        });

        var minVal = slider.closest('label').find('.frp_col1 input').val();
        var maxVal = slider.closest('label').find('.frp_col3 input').val();
        slider.closest('label').find('.frp_col1 .fr_display').val('$ '+minVal+' USD')
        slider.closest('label').find('.frp_col3 .fr_display').val('$ '+maxVal+' USD')
    }


}




function startBoardSizeSlider_OLD(element, rangeMin, rangeMax){

    console.log( element, rangeMin, rangeMax );

	var slider = $('.'+element+'');
	var isBoardSize = slider.hasClass('filterrange_6');
	var isBoardVolume = slider.hasClass('filterrange_7');
	
	slider.slider({
		range: true,
		min: rangeMin,
		max: rangeMax,
		values: [rangeMin, rangeMax],
		slide: function(event, ui) {
			$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
			$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
			filterShopBoards();
		}
	});

	slider.closest('label').find('.frp_col1 input').val(slider.slider('values', 0));
	slider.closest('label').find('.frp_col3 input').val(slider.slider('values', 1));
	
    /*
	if(isBoardSize){
		slider.slider({
			slide: function(event, ui) {
				var minFeetVal = toFeet(ui.values[0]);
				var maxFeetVal = toFeet(ui.values[1]);
				$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
				$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
				
				$(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Ft');
				$(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Ft');
                //$('.fr_display_min').val(minFeetVal+' Ft');
                //$('.fr_display_max').val(maxFeetVal+' Ft');
				
				filterShopBoards();
			}
		});
		
		var minVal = toFeet(slider.closest('label').find('.frp_col1 input').val()); 
		var maxVal = toFeet(slider.closest('label').find('.frp_col3 input').val()); 
		slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Ft')
		slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Ft')

	}
     */
	
			
			
	//if(isBoardVolume){
		slider.slider({
			slide: function(event, ui) {

                console.log('sliding: '+isBoardSize);

				var minVal = ui.values[0];
				var maxVal = ui.values[1];
				$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
				$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
				
				//$(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Lt');
				//$(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Lt');

                if(isBoardSize){

                    //console.log('is board size');

                    slider.closest('label').find('.frp_col1 .fr_display').val( toFeet( minVal )+' Ft');
                    slider.closest('label').find('.frp_col3 .fr_display').val( toFeet( maxVal )+' Ft');
                    //$('.fr_display_max').val( toFeet( maxVal )+' Ft');

                }else if( isBoardVolume ){

                    slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
                    slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')

                }

				//filterShopBoards();
			},

            stop: function(event, ui){


                // PBS: applying filters only on stop..
                filterShopBoards();

            }
		});

        // when loaded

		var minVal = slider.closest('label').find('.frp_col1 input').val(); 
		var maxVal = slider.closest('label').find('.frp_col3 input').val();

        if(isBoardSize){

            slider.closest('label').find('.frp_col1 .fr_display').val( toFeet( minVal )+' Ft')
            slider.closest('label').find('.frp_col3 .fr_display').val( toFeet( maxVal )+' Ft')

        }else if( isBoardVolume ){

            slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
            slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')

        }

	//}
	
	
}

// listen to size.. later..
$('#fr-max-display-6').on('change', function(){

    console.log('mudasti');

})



function clearAllFilters(){
	$(document).on('click', '.btn_clearallfilters', function(e){
		e.preventDefault();
		$('.sblf_filtercheck').prop('checked', false);

		$('.filterrange').each(function(){
			var t = $(this);
			var rangeMin = Number(t.attr('data-min'));
			var rangeMax = Number(t.attr('data-max'));
			t.slider({
				values: [rangeMin, rangeMax]
			});
			t.closest('label').find('.filterrange_preview .fr_min').val(rangeMin);
			t.closest('label').find('.filterrange_preview .fr_max').val(rangeMax);
		});
		
		$('.sblf_filtercheck:first').trigger('change');
	});
}





// this is used for all shop sections..
function filterShopBoards(){
	var qString = '';
	$('.slf_filterlist .slfg_items_inner').each(function(){
		var t = $(this);
		var filterType = t.attr('data-filtertype');
		var filterName = t.attr('data-filterdataname');
		filterName = filterName.split(',');
		var filterNameSize = filterName.length;
		var currFilterString = '';

		if(filterType=='list') {
			t.find('.filterdata:checked').each(function(){
				var tfd = $(this);
				var value = tfd.val();
				currFilterString += value+',';
			});
		} else if(filterType=='range'){
			t.find('.filterdata').each(function(){
				var tfd = $(this);
				var value = tfd.val();
				currFilterString += value+',';
			});
		}
		currFilterString = currFilterString.slice(0,-1);

		if(filterNameSize==1){
			var grpQuery = filterName+'='+currFilterString;
		} else if(filterNameSize==2){
			currFilterString = currFilterString.split(',')
			var grpQuery = filterName[0]+'='+currFilterString[0]+'&'+filterName[1]+'='+currFilterString[1];
		}
		qString += grpQuery+'&';
	});
	qString = qString.slice(0,-1);



	var shop = $('.shoplist').attr('data-shop');

    //console.log( shop );

	if( shop=='boards' ) {
		
        service_productBoardsList(qString);

    }else{

        products_list( shop, qString );

    }
    /*
	} else if(shop=='apparel'){
        //alert('apparel');
		service_productApparelList(qString);
        //service_productAccessoriesList(qString);
	} else if(shop=='accessories'){
		//service_productAccessoriesList(qString);
        products_list( shop );
	}
	*/
}

function filterBoardsInit(){
	$(document).on('change', '.sblf_filtercheck', function(){
		filterShopBoards();
	});
}


$(function(){
	clearAllFilters();
	filterBoardsInit();
});



/*

mover o filtro conforme o ecra vai descendo

function setFilterTop(){
	var t = $(window);
	var checkoutTopExist = $('.shoplist').size();
	if(checkoutTopExist>0){
		var checkOutHeight = $('.shoplist').height();
		var checkOutTop = $('.shoplist').offset().top;
		var checkOutBottom = checkOutTop+checkOutHeight;
		var orderSummaryHeight = $('.shoplist #shop-products-filter').height();
		var scrollTop = t.scrollTop();
		var bottomLimitOfset = 140;
		var bottomLimit = (checkOutBottom-orderSummaryHeight)-bottomLimitOfset;
		function moveOrderSum(pos){
			$('.shoplist #shop-products-filter').stop().animate({
				'top': pos
			});
		}
		if(scrollTop>checkOutTop && scrollTop<bottomLimit){
			moveOrderSum((scrollTop-checkOutTop)+40);
		} else if(scrollTop<checkOutTop){
			moveOrderSum(0);
		} else if(scrollTop>bottomLimit){
			moveOrderSum((((checkOutBottom-checkOutTop)-orderSummaryHeight))-bottomLimitOfset);
		}
	}	
}
$(function(){
	$(window).on('scroll', function(){setFilterTop()});
	$(window).on('resize', function(){setFilterTop()});
});

*/


// Snap.svg 0.4.1
//
// Copyright (c) 2013 ? 2015 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//
// build: 2015-04-13

!function(a){var b,c,d="0.4.2",e="hasOwnProperty",f=/[\.\/]/,g=/\s*,\s*/,h="*",i=function(a,b){return a-b},j={n:{}},k=function(){for(var a=0,b=this.length;b>a;a++)if("undefined"!=typeof this[a])return this[a]},l=function(){for(var a=this.length;--a;)if("undefined"!=typeof this[a])return this[a]},m=function(a,d){a=String(a);var e,f=c,g=Array.prototype.slice.call(arguments,2),h=m.listeners(a),j=0,n=[],o={},p=[],q=b;p.firstDefined=k,p.lastDefined=l,b=a,c=0;for(var r=0,s=h.length;s>r;r++)"zIndex"in h[r]&&(n.push(h[r].zIndex),h[r].zIndex<0&&(o[h[r].zIndex]=h[r]));for(n.sort(i);n[j]<0;)if(e=o[n[j++]],p.push(e.apply(d,g)),c)return c=f,p;for(r=0;s>r;r++)if(e=h[r],"zIndex"in e)if(e.zIndex==n[j]){if(p.push(e.apply(d,g)),c)break;do if(j++,e=o[n[j]],e&&p.push(e.apply(d,g)),c)break;while(e)}else o[e.zIndex]=e;else if(p.push(e.apply(d,g)),c)break;return c=f,b=q,p};m._events=j,m.listeners=function(a){var b,c,d,e,g,i,k,l,m=a.split(f),n=j,o=[n],p=[];for(e=0,g=m.length;g>e;e++){for(l=[],i=0,k=o.length;k>i;i++)for(n=o[i].n,c=[n[m[e]],n[h]],d=2;d--;)b=c[d],b&&(l.push(b),p=p.concat(b.f||[]));o=l}return p},m.on=function(a,b){if(a=String(a),"function"!=typeof b)return function(){};for(var c=a.split(g),d=0,e=c.length;e>d;d++)!function(a){for(var c,d=a.split(f),e=j,g=0,h=d.length;h>g;g++)e=e.n,e=e.hasOwnProperty(d[g])&&e[d[g]]||(e[d[g]]={n:{}});for(e.f=e.f||[],g=0,h=e.f.length;h>g;g++)if(e.f[g]==b){c=!0;break}!c&&e.f.push(b)}(c[d]);return function(a){+a==+a&&(b.zIndex=+a)}},m.f=function(a){var b=[].slice.call(arguments,1);return function(){m.apply(null,[a,null].concat(b).concat([].slice.call(arguments,0)))}},m.stop=function(){c=1},m.nt=function(a){return a?new RegExp("(?:\\.|\\/|^)"+a+"(?:\\.|\\/|$)").test(b):b},m.nts=function(){return b.split(f)},m.off=m.unbind=function(a,b){if(!a)return void(m._events=j={n:{}});var c=a.split(g);if(c.length>1)for(var d=0,i=c.length;i>d;d++)m.off(c[d],b);else{c=a.split(f);var k,l,n,d,i,o,p,q=[j];for(d=0,i=c.length;i>d;d++)for(o=0;o<q.length;o+=n.length-2){if(n=[o,1],k=q[o].n,c[d]!=h)k[c[d]]&&n.push(k[c[d]]);else for(l in k)k[e](l)&&n.push(k[l]);q.splice.apply(q,n)}for(d=0,i=q.length;i>d;d++)for(k=q[d];k.n;){if(b){if(k.f){for(o=0,p=k.f.length;p>o;o++)if(k.f[o]==b){k.f.splice(o,1);break}!k.f.length&&delete k.f}for(l in k.n)if(k.n[e](l)&&k.n[l].f){var r=k.n[l].f;for(o=0,p=r.length;p>o;o++)if(r[o]==b){r.splice(o,1);break}!r.length&&delete k.n[l].f}}else{delete k.f;for(l in k.n)k.n[e](l)&&k.n[l].f&&delete k.n[l].f}k=k.n}}},m.once=function(a,b){var c=function(){return m.unbind(a,c),b.apply(this,arguments)};return m.on(a,c)},m.version=d,m.toString=function(){return"You are running Eve "+d},"undefined"!=typeof module&&module.exports?module.exports=m:"function"==typeof define&&define.amd?define("eve",[],function(){return m}):a.eve=m}(this),function(a,b){if("function"==typeof define&&define.amd)define(["eve"],function(c){return b(a,c)});else if("undefined"!=typeof exports){var c=require("eve");module.exports=b(a,c)}else b(a,a.eve)}(window||this,function(a,b){var c=function(b){var c={},d=a.requestAnimationFrame||a.webkitRequestAnimationFrame||a.mozRequestAnimationFrame||a.oRequestAnimationFrame||a.msRequestAnimationFrame||function(a){setTimeout(a,16)},e=Array.isArray||function(a){return a instanceof Array||"[object Array]"==Object.prototype.toString.call(a)},f=0,g="M"+(+new Date).toString(36),h=function(){return g+(f++).toString(36)},i=Date.now||function(){return+new Date},j=function(a){var b=this;if(null==a)return b.s;var c=b.s-a;b.b+=b.dur*c,b.B+=b.dur*c,b.s=a},k=function(a){var b=this;return null==a?b.spd:void(b.spd=a)},l=function(a){var b=this;return null==a?b.dur:(b.s=b.s*a/b.dur,void(b.dur=a))},m=function(){var a=this;delete c[a.id],a.update(),b("mina.stop."+a.id,a)},n=function(){var a=this;a.pdif||(delete c[a.id],a.update(),a.pdif=a.get()-a.b)},o=function(){var a=this;a.pdif&&(a.b=a.get()-a.pdif,delete a.pdif,c[a.id]=a)},p=function(){var a,b=this;if(e(b.start)){a=[];for(var c=0,d=b.start.length;d>c;c++)a[c]=+b.start[c]+(b.end[c]-b.start[c])*b.easing(b.s)}else a=+b.start+(b.end-b.start)*b.easing(b.s);b.set(a)},q=function(){var a=0;for(var e in c)if(c.hasOwnProperty(e)){var f=c[e],g=f.get();a++,f.s=(g-f.b)/(f.dur/f.spd),f.s>=1&&(delete c[e],f.s=1,a--,function(a){setTimeout(function(){b("mina.finish."+a.id,a)})}(f)),f.update()}a&&d(q)},r=function(a,b,e,f,g,i,s){var t={id:h(),start:a,end:b,b:e,s:0,dur:f-e,spd:1,get:g,set:i,easing:s||r.linear,status:j,speed:k,duration:l,stop:m,pause:n,resume:o,update:p};c[t.id]=t;var u,v=0;for(u in c)if(c.hasOwnProperty(u)&&(v++,2==v))break;return 1==v&&d(q),t};return r.time=i,r.getById=function(a){return c[a]||null},r.linear=function(a){return a},r.easeout=function(a){return Math.pow(a,1.7)},r.easein=function(a){return Math.pow(a,.48)},r.easeinout=function(a){if(1==a)return 1;if(0==a)return 0;var b=.48-a/1.04,c=Math.sqrt(.1734+b*b),d=c-b,e=Math.pow(Math.abs(d),1/3)*(0>d?-1:1),f=-c-b,g=Math.pow(Math.abs(f),1/3)*(0>f?-1:1),h=e+g+.5;return 3*(1-h)*h*h+h*h*h},r.backin=function(a){if(1==a)return 1;var b=1.70158;return a*a*((b+1)*a-b)},r.backout=function(a){if(0==a)return 0;a-=1;var b=1.70158;return a*a*((b+1)*a+b)+1},r.elastic=function(a){return a==!!a?a:Math.pow(2,-10*a)*Math.sin(2*(a-.075)*Math.PI/.3)+1},r.bounce=function(a){var b,c=7.5625,d=2.75;return 1/d>a?b=c*a*a:2/d>a?(a-=1.5/d,b=c*a*a+.75):2.5/d>a?(a-=2.25/d,b=c*a*a+.9375):(a-=2.625/d,b=c*a*a+.984375),b},a.mina=r,r}("undefined"==typeof b?function(){}:b),d=function(a){function c(a,b){if(a){if(a.nodeType)return w(a);if(e(a,"array")&&c.set)return c.set.apply(c,a);if(a instanceof s)return a;if(null==b)return a=y.doc.querySelector(String(a)),w(a)}return a=null==a?"100%":a,b=null==b?"100%":b,new v(a,b)}function d(a,b){if(b){if("#text"==a&&(a=y.doc.createTextNode(b.text||b["#text"]||"")),"#comment"==a&&(a=y.doc.createComment(b.text||b["#text"]||"")),"string"==typeof a&&(a=d(a)),"string"==typeof b)return 1==a.nodeType?"xlink:"==b.substring(0,6)?a.getAttributeNS(T,b.substring(6)):"xml:"==b.substring(0,4)?a.getAttributeNS(U,b.substring(4)):a.getAttribute(b):"text"==b?a.nodeValue:null;if(1==a.nodeType){for(var c in b)if(b[z](c)){var e=A(b[c]);e?"xlink:"==c.substring(0,6)?a.setAttributeNS(T,c.substring(6),e):"xml:"==c.substring(0,4)?a.setAttributeNS(U,c.substring(4),e):a.setAttribute(c,e):a.removeAttribute(c)}}else"text"in b&&(a.nodeValue=b.text)}else a=y.doc.createElementNS(U,a);return a}function e(a,b){return b=A.prototype.toLowerCase.call(b),"finite"==b?isFinite(a):"array"==b&&(a instanceof Array||Array.isArray&&Array.isArray(a))?!0:"null"==b&&null===a||b==typeof a&&null!==a||"object"==b&&a===Object(a)||J.call(a).slice(8,-1).toLowerCase()==b}function f(a){if("function"==typeof a||Object(a)!==a)return a;var b=new a.constructor;for(var c in a)a[z](c)&&(b[c]=f(a[c]));return b}function h(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return a.push(a.splice(c,1)[0])}function i(a,b,c){function d(){var e=Array.prototype.slice.call(arguments,0),f=e.join("?"),g=d.cache=d.cache||{},i=d.count=d.count||[];return g[z](f)?(h(i,f),c?c(g[f]):g[f]):(i.length>=1e3&&delete g[i.shift()],i.push(f),g[f]=a.apply(b,e),c?c(g[f]):g[f])}return d}function j(a,b,c,d,e,f){if(null==e){var g=a-c,h=b-d;return g||h?(180+180*D.atan2(-h,-g)/H+360)%360:0}return j(a,b,e,f)-j(c,d,e,f)}function k(a){return a%360*H/180}function l(a){return 180*a/H%360}function m(a){var b=[];return a=a.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g,function(a,c,d){return d=d.split(/\s*,\s*|\s+/),"rotate"==c&&1==d.length&&d.push(0,0),"scale"==c&&(d.length>2?d=d.slice(0,2):2==d.length&&d.push(0,0),1==d.length&&d.push(d[0],0,0)),b.push("skewX"==c?["m",1,0,D.tan(k(d[0])),1,0,0]:"skewY"==c?["m",1,D.tan(k(d[0])),0,1,0,0]:[c.charAt(0)].concat(d)),a}),b}function n(a,b){var d=ab(a),e=new c.Matrix;if(d)for(var f=0,g=d.length;g>f;f++){var h,i,j,k,l,m=d[f],n=m.length,o=A(m[0]).toLowerCase(),p=m[0]!=o,q=p?e.invert():0;"t"==o&&2==n?e.translate(m[1],0):"t"==o&&3==n?p?(h=q.x(0,0),i=q.y(0,0),j=q.x(m[1],m[2]),k=q.y(m[1],m[2]),e.translate(j-h,k-i)):e.translate(m[1],m[2]):"r"==o?2==n?(l=l||b,e.rotate(m[1],l.x+l.width/2,l.y+l.height/2)):4==n&&(p?(j=q.x(m[2],m[3]),k=q.y(m[2],m[3]),e.rotate(m[1],j,k)):e.rotate(m[1],m[2],m[3])):"s"==o?2==n||3==n?(l=l||b,e.scale(m[1],m[n-1],l.x+l.width/2,l.y+l.height/2)):4==n?p?(j=q.x(m[2],m[3]),k=q.y(m[2],m[3]),e.scale(m[1],m[1],j,k)):e.scale(m[1],m[1],m[2],m[3]):5==n&&(p?(j=q.x(m[3],m[4]),k=q.y(m[3],m[4]),e.scale(m[1],m[2],j,k)):e.scale(m[1],m[2],m[3],m[4])):"m"==o&&7==n&&e.add(m[1],m[2],m[3],m[4],m[5],m[6])}return e}function o(a){var b=a.node.ownerSVGElement&&w(a.node.ownerSVGElement)||a.node.parentNode&&w(a.node.parentNode)||c.select("svg")||c(0,0),d=b.select("defs"),e=null==d?!1:d.node;return e||(e=u("defs",b.node).node),e}function p(a){return a.node.ownerSVGElement&&w(a.node.ownerSVGElement)||c.select("svg")}function q(a,b,c){function e(a){if(null==a)return I;if(a==+a)return a;d(j,{width:a});try{return j.getBBox().width}catch(b){return 0}}function f(a){if(null==a)return I;if(a==+a)return a;d(j,{height:a});try{return j.getBBox().height}catch(b){return 0}}function g(d,e){null==b?i[d]=e(a.attr(d)||0):d==b&&(i=e(null==c?a.attr(d)||0:c))}var h=p(a).node,i={},j=h.querySelector(".svg---mgr");switch(j||(j=d("rect"),d(j,{x:-9e9,y:-9e9,width:10,height:10,"class":"svg---mgr",fill:"none"}),h.appendChild(j)),a.type){case"rect":g("rx",e),g("ry",f);case"image":g("width",e),g("height",f);case"text":g("x",e),g("y",f);break;case"circle":g("cx",e),g("cy",f),g("r",e);break;case"ellipse":g("cx",e),g("cy",f),g("rx",e),g("ry",f);break;case"line":g("x1",e),g("x2",e),g("y1",f),g("y2",f);break;case"marker":g("refX",e),g("markerWidth",e),g("refY",f),g("markerHeight",f);break;case"radialGradient":g("fx",e),g("fy",f);break;case"tspan":g("dx",e),g("dy",f);break;default:g(b,e)}return h.removeChild(j),i}function r(a){e(a,"array")||(a=Array.prototype.slice.call(arguments,0));for(var b=0,c=0,d=this.node;this[b];)delete this[b++];for(b=0;b<a.length;b++)"set"==a[b].type?a[b].forEach(function(a){d.appendChild(a.node)}):d.appendChild(a[b].node);var f=d.childNodes;for(b=0;b<f.length;b++)this[c++]=w(f[b]);return this}function s(a){if(a.snap in V)return V[a.snap];var b;try{b=a.ownerSVGElement}catch(c){}this.node=a,b&&(this.paper=new v(b)),this.type=a.tagName||a.nodeName;var d=this.id=S(this);if(this.anims={},this._={transform:[]},a.snap=d,V[d]=this,"g"==this.type&&(this.add=r),this.type in{g:1,mask:1,pattern:1,symbol:1})for(var e in v.prototype)v.prototype[z](e)&&(this[e]=v.prototype[e])}function t(a){this.node=a}function u(a,b){var c=d(a);b.appendChild(c);var e=w(c);return e}function v(a,b){var c,e,f,g=v.prototype;if(a&&"svg"==a.tagName){if(a.snap in V)return V[a.snap];var h=a.ownerDocument;c=new s(a),e=a.getElementsByTagName("desc")[0],f=a.getElementsByTagName("defs")[0],e||(e=d("desc"),e.appendChild(h.createTextNode("Created with Snap")),c.node.appendChild(e)),f||(f=d("defs"),c.node.appendChild(f)),c.defs=f;for(var i in g)g[z](i)&&(c[i]=g[i]);c.paper=c.root=c}else c=u("svg",y.doc.body),d(c.node,{height:b,version:1.1,width:a,xmlns:U});return c}function w(a){return a?a instanceof s||a instanceof t?a:a.tagName&&"svg"==a.tagName.toLowerCase()?new v(a):a.tagName&&"object"==a.tagName.toLowerCase()&&"image/svg+xml"==a.type?new v(a.contentDocument.getElementsByTagName("svg")[0]):new s(a):a}function x(a,b){for(var c=0,d=a.length;d>c;c++){var e={type:a[c].type,attr:a[c].attr()},f=a[c].children();b.push(e),f.length&&x(f,e.childNodes=[])}}c.version="0.4.0",c.toString=function(){return"Snap v"+this.version},c._={};var y={win:a.window,doc:a.window.document};c._.glob=y;{var z="hasOwnProperty",A=String,B=parseFloat,C=parseInt,D=Math,E=D.max,F=D.min,G=D.abs,H=(D.pow,D.PI),I=(D.round,""),J=Object.prototype.toString,K=/^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,L=(c._.separator=/[,\s]+/,/[\s]*,[\s]*/),M={hs:1,rg:1},N=/([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,O=/([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,P=/(-?\d*\.?\d*(?:e[\-+]?\\d+)?)[\s]*,?[\s]*/gi,Q=0,R="S"+(+new Date).toString(36),S=function(a){return(a&&a.type?a.type:I)+R+(Q++).toString(36)},T="http://www.w3.org/1999/xlink",U="http://www.w3.org/2000/svg",V={};c.url=function(a){return"url('#"+a+"')"}}c._.$=d,c._.id=S,c.format=function(){var a=/\{([^\}]+)\}/g,b=/(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g,c=function(a,c,d){var e=d;return c.replace(b,function(a,b,c,d,f){b=b||d,e&&(b in e&&(e=e[b]),"function"==typeof e&&f&&(e=e()))}),e=(null==e||e==d?a:e)+""};return function(b,d){return A(b).replace(a,function(a,b){return c(a,b,d)})}}(),c._.clone=f,c._.cacher=i,c.rad=k,c.deg=l,c.sin=function(a){return D.sin(c.rad(a))},c.tan=function(a){return D.tan(c.rad(a))},c.cos=function(a){return D.cos(c.rad(a))},c.asin=function(a){return c.deg(D.asin(a))},c.acos=function(a){return c.deg(D.acos(a))},c.atan=function(a){return c.deg(D.atan(a))},c.atan2=function(a){return c.deg(D.atan2(a))},c.angle=j,c.len=function(a,b,d,e){return Math.sqrt(c.len2(a,b,d,e))},c.len2=function(a,b,c,d){return(a-c)*(a-c)+(b-d)*(b-d)},c.closestPoint=function(a,b,c){function d(a){var d=a.x-b,e=a.y-c;return d*d+e*e}for(var e,f,g,h,i=a.node,j=i.getTotalLength(),k=j/i.pathSegList.numberOfItems*.125,l=1/0,m=0;j>=m;m+=k)(h=d(g=i.getPointAtLength(m)))<l&&(e=g,f=m,l=h);for(k*=.5;k>.5;){var n,o,p,q,r,s;(p=f-k)>=0&&(r=d(n=i.getPointAtLength(p)))<l?(e=n,f=p,l=r):(q=f+k)<=j&&(s=d(o=i.getPointAtLength(q)))<l?(e=o,f=q,l=s):k*=.5}return e={x:e.x,y:e.y,length:f,distance:Math.sqrt(l)}},c.is=e,c.snapTo=function(a,b,c){if(c=e(c,"finite")?c:10,e(a,"array")){for(var d=a.length;d--;)if(G(a[d]-b)<=c)return a[d]}else{a=+a;var f=b%a;if(c>f)return b-f;if(f>a-c)return b-f+a}return b},c.getRGB=i(function(a){if(!a||(a=A(a)).indexOf("-")+1)return{r:-1,g:-1,b:-1,hex:"none",error:1,toString:Z};if("none"==a)return{r:-1,g:-1,b:-1,hex:"none",toString:Z};if(!(M[z](a.toLowerCase().substring(0,2))||"#"==a.charAt())&&(a=W(a)),!a)return{r:-1,g:-1,b:-1,hex:"none",error:1,toString:Z};var b,d,f,g,h,i,j=a.match(K);return j?(j[2]&&(f=C(j[2].substring(5),16),d=C(j[2].substring(3,5),16),b=C(j[2].substring(1,3),16)),j[3]&&(f=C((h=j[3].charAt(3))+h,16),d=C((h=j[3].charAt(2))+h,16),b=C((h=j[3].charAt(1))+h,16)),j[4]&&(i=j[4].split(L),b=B(i[0]),"%"==i[0].slice(-1)&&(b*=2.55),d=B(i[1]),"%"==i[1].slice(-1)&&(d*=2.55),f=B(i[2]),"%"==i[2].slice(-1)&&(f*=2.55),"rgba"==j[1].toLowerCase().slice(0,4)&&(g=B(i[3])),i[3]&&"%"==i[3].slice(-1)&&(g/=100)),j[5]?(i=j[5].split(L),b=B(i[0]),"%"==i[0].slice(-1)&&(b/=100),d=B(i[1]),"%"==i[1].slice(-1)&&(d/=100),f=B(i[2]),"%"==i[2].slice(-1)&&(f/=100),("deg"==i[0].slice(-3)||"�"==i[0].slice(-1))&&(b/=360),"hsba"==j[1].toLowerCase().slice(0,4)&&(g=B(i[3])),i[3]&&"%"==i[3].slice(-1)&&(g/=100),c.hsb2rgb(b,d,f,g)):j[6]?(i=j[6].split(L),b=B(i[0]),"%"==i[0].slice(-1)&&(b/=100),d=B(i[1]),"%"==i[1].slice(-1)&&(d/=100),f=B(i[2]),"%"==i[2].slice(-1)&&(f/=100),("deg"==i[0].slice(-3)||"�"==i[0].slice(-1))&&(b/=360),"hsla"==j[1].toLowerCase().slice(0,4)&&(g=B(i[3])),i[3]&&"%"==i[3].slice(-1)&&(g/=100),c.hsl2rgb(b,d,f,g)):(b=F(D.round(b),255),d=F(D.round(d),255),f=F(D.round(f),255),g=F(E(g,0),1),j={r:b,g:d,b:f,toString:Z},j.hex="#"+(16777216|f|d<<8|b<<16).toString(16).slice(1),j.opacity=e(g,"finite")?g:1,j)):{r:-1,g:-1,b:-1,hex:"none",error:1,toString:Z}},c),c.hsb=i(function(a,b,d){return c.hsb2rgb(a,b,d).hex}),c.hsl=i(function(a,b,d){return c.hsl2rgb(a,b,d).hex}),c.rgb=i(function(a,b,c,d){if(e(d,"finite")){var f=D.round;return"rgba("+[f(a),f(b),f(c),+d.toFixed(2)]+")"}return"#"+(16777216|c|b<<8|a<<16).toString(16).slice(1)});var W=function(a){var b=y.doc.getElementsByTagName("head")[0]||y.doc.getElementsByTagName("svg")[0],c="rgb(255, 0, 0)";return(W=i(function(a){if("red"==a.toLowerCase())return c;b.style.color=c,b.style.color=a;var d=y.doc.defaultView.getComputedStyle(b,I).getPropertyValue("color");return d==c?null:d}))(a)},X=function(){return"hsb("+[this.h,this.s,this.b]+")"},Y=function(){return"hsl("+[this.h,this.s,this.l]+")"},Z=function(){return 1==this.opacity||null==this.opacity?this.hex:"rgba("+[this.r,this.g,this.b,this.opacity]+")"},$=function(a,b,d){if(null==b&&e(a,"object")&&"r"in a&&"g"in a&&"b"in a&&(d=a.b,b=a.g,a=a.r),null==b&&e(a,string)){var f=c.getRGB(a);a=f.r,b=f.g,d=f.b}return(a>1||b>1||d>1)&&(a/=255,b/=255,d/=255),[a,b,d]},_=function(a,b,d,f){a=D.round(255*a),b=D.round(255*b),d=D.round(255*d);var g={r:a,g:b,b:d,opacity:e(f,"finite")?f:1,hex:c.rgb(a,b,d),toString:Z};return e(f,"finite")&&(g.opacity=f),g};c.color=function(a){var b;return e(a,"object")&&"h"in a&&"s"in a&&"b"in a?(b=c.hsb2rgb(a),a.r=b.r,a.g=b.g,a.b=b.b,a.opacity=1,a.hex=b.hex):e(a,"object")&&"h"in a&&"s"in a&&"l"in a?(b=c.hsl2rgb(a),a.r=b.r,a.g=b.g,a.b=b.b,a.opacity=1,a.hex=b.hex):(e(a,"string")&&(a=c.getRGB(a)),e(a,"object")&&"r"in a&&"g"in a&&"b"in a&&!("error"in a)?(b=c.rgb2hsl(a),a.h=b.h,a.s=b.s,a.l=b.l,b=c.rgb2hsb(a),a.v=b.b):(a={hex:"none"},a.r=a.g=a.b=a.h=a.s=a.v=a.l=-1,a.error=1)),a.toString=Z,a},c.hsb2rgb=function(a,b,c,d){e(a,"object")&&"h"in a&&"s"in a&&"b"in a&&(c=a.b,b=a.s,d=a.o,a=a.h),a*=360;var f,g,h,i,j;return a=a%360/60,j=c*b,i=j*(1-G(a%2-1)),f=g=h=c-j,a=~~a,f+=[j,i,0,0,i,j][a],g+=[i,j,j,i,0,0][a],h+=[0,0,i,j,j,i][a],_(f,g,h,d)},c.hsl2rgb=function(a,b,c,d){e(a,"object")&&"h"in a&&"s"in a&&"l"in a&&(c=a.l,b=a.s,a=a.h),(a>1||b>1||c>1)&&(a/=360,b/=100,c/=100),a*=360;var f,g,h,i,j;return a=a%360/60,j=2*b*(.5>c?c:1-c),i=j*(1-G(a%2-1)),f=g=h=c-j/2,a=~~a,f+=[j,i,0,0,i,j][a],g+=[i,j,j,i,0,0][a],h+=[0,0,i,j,j,i][a],_(f,g,h,d)},c.rgb2hsb=function(a,b,c){c=$(a,b,c),a=c[0],b=c[1],c=c[2];var d,e,f,g;return f=E(a,b,c),g=f-F(a,b,c),d=0==g?null:f==a?(b-c)/g:f==b?(c-a)/g+2:(a-b)/g+4,d=(d+360)%6*60/360,e=0==g?0:g/f,{h:d,s:e,b:f,toString:X}},c.rgb2hsl=function(a,b,c){c=$(a,b,c),a=c[0],b=c[1],c=c[2];var d,e,f,g,h,i;return g=E(a,b,c),h=F(a,b,c),i=g-h,d=0==i?null:g==a?(b-c)/i:g==b?(c-a)/i+2:(a-b)/i+4,d=(d+360)%6*60/360,f=(g+h)/2,e=0==i?0:.5>f?i/(2*f):i/(2-2*f),{h:d,s:e,l:f,toString:Y}},c.parsePathString=function(a){if(!a)return null;var b=c.path(a);if(b.arr)return c.path.clone(b.arr);var d={a:7,c:6,o:2,h:1,l:2,m:2,r:4,q:4,s:4,t:2,v:1,u:3,z:0},f=[];return e(a,"array")&&e(a[0],"array")&&(f=c.path.clone(a)),f.length||A(a).replace(N,function(a,b,c){var e=[],g=b.toLowerCase();if(c.replace(P,function(a,b){b&&e.push(+b)}),"m"==g&&e.length>2&&(f.push([b].concat(e.splice(0,2))),g="l",b="m"==b?"l":"L"),"o"==g&&1==e.length&&f.push([b,e[0]]),"r"==g)f.push([b].concat(e));else for(;e.length>=d[g]&&(f.push([b].concat(e.splice(0,d[g]))),d[g]););}),f.toString=c.path.toString,b.arr=c.path.clone(f),f};var ab=c.parseTransformString=function(a){if(!a)return null;var b=[];return e(a,"array")&&e(a[0],"array")&&(b=c.path.clone(a)),b.length||A(a).replace(O,function(a,c,d){{var e=[];c.toLowerCase()}d.replace(P,function(a,b){b&&e.push(+b)}),b.push([c].concat(e))}),b.toString=c.path.toString,b};c._.svgTransform2string=m,c._.rgTransform=/^[a-z][\s]*-?\.?\d/i,c._.transform2matrix=n,c._unit2px=q;y.doc.contains||y.doc.compareDocumentPosition?function(a,b){var c=9==a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a==d||!(!d||1!=d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)for(;b;)if(b=b.parentNode,b==a)return!0;return!1};c._.getSomeDefs=o,c._.getSomeSVG=p,c.select=function(a){return a=A(a).replace(/([^\\]):/g,"$1\\:"),w(y.doc.querySelector(a))},c.selectAll=function(a){for(var b=y.doc.querySelectorAll(a),d=(c.set||Array)(),e=0;e<b.length;e++)d.push(w(b[e]));return d},setInterval(function(){for(var a in V)if(V[z](a)){var b=V[a],c=b.node;("svg"!=b.type&&!c.ownerSVGElement||"svg"==b.type&&(!c.parentNode||"ownerSVGElement"in c.parentNode&&!c.ownerSVGElement))&&delete V[a]}},1e4),s.prototype.attr=function(a,c){var d=this,f=d.node;if(!a){if(1!=f.nodeType)return{text:f.nodeValue};for(var g=f.attributes,h={},i=0,j=g.length;j>i;i++)h[g[i].nodeName]=g[i].nodeValue;return h}if(e(a,"string")){if(!(arguments.length>1))return b("snap.util.getattr."+a,d).firstDefined();var k={};k[a]=c,a=k}for(var l in a)a[z](l)&&b("snap.util.attr."+l,d,a[l]);return d},c.parse=function(a){var b=y.doc.createDocumentFragment(),c=!0,d=y.doc.createElement("div");if(a=A(a),a.match(/^\s*<\s*svg(?:\s|>)/)||(a="<svg>"+a+"</svg>",c=!1),d.innerHTML=a,a=d.getElementsByTagName("svg")[0])if(c)b=a;else for(;a.firstChild;)b.appendChild(a.firstChild);return new t(b)},c.fragment=function(){for(var a=Array.prototype.slice.call(arguments,0),b=y.doc.createDocumentFragment(),d=0,e=a.length;e>d;d++){var f=a[d];f.node&&f.node.nodeType&&b.appendChild(f.node),f.nodeType&&b.appendChild(f),"string"==typeof f&&b.appendChild(c.parse(f).node)}return new t(b)},c._.make=u,c._.wrap=w,v.prototype.el=function(a,b){var c=u(a,this.node);return b&&c.attr(b),c},s.prototype.children=function(){for(var a=[],b=this.node.childNodes,d=0,e=b.length;e>d;d++)a[d]=c(b[d]);return a},s.prototype.toJSON=function(){var a=[];return x([this],a),a[0]},b.on("snap.util.getattr",function(){var a=b.nt();a=a.substring(a.lastIndexOf(".")+1);var c=a.replace(/[A-Z]/g,function(a){return"-"+a.toLowerCase()});return bb[z](c)?this.node.ownerDocument.defaultView.getComputedStyle(this.node,null).getPropertyValue(c):d(this.node,a)});var bb={"alignment-baseline":0,"baseline-shift":0,clip:0,"clip-path":0,"clip-rule":0,color:0,"color-interpolation":0,"color-interpolation-filters":0,"color-profile":0,"color-rendering":0,cursor:0,direction:0,display:0,"dominant-baseline":0,"enable-background":0,fill:0,"fill-opacity":0,"fill-rule":0,filter:0,"flood-color":0,"flood-opacity":0,font:0,"font-family":0,"font-size":0,"font-size-adjust":0,"font-stretch":0,"font-style":0,"font-variant":0,"font-weight":0,"glyph-orientation-horizontal":0,"glyph-orientation-vertical":0,"image-rendering":0,kerning:0,"letter-spacing":0,"lighting-color":0,marker:0,"marker-end":0,"marker-mid":0,"marker-start":0,mask:0,opacity:0,overflow:0,"pointer-events":0,"shape-rendering":0,"stop-color":0,"stop-opacity":0,stroke:0,"stroke-dasharray":0,"stroke-dashoffset":0,"stroke-linecap":0,"stroke-linejoin":0,"stroke-miterlimit":0,"stroke-opacity":0,"stroke-width":0,"text-anchor":0,"text-decoration":0,"text-rendering":0,"unicode-bidi":0,visibility:0,"word-spacing":0,"writing-mode":0};b.on("snap.util.attr",function(a){var c=b.nt(),e={};c=c.substring(c.lastIndexOf(".")+1),e[c]=a;var f=c.replace(/-(\w)/gi,function(a,b){return b.toUpperCase()}),g=c.replace(/[A-Z]/g,function(a){return"-"+a.toLowerCase()});bb[z](g)?this.node.style[f]=null==a?I:a:d(this.node,e)}),function(){}(v.prototype),c.ajax=function(a,c,d,f){var g=new XMLHttpRequest,h=S();if(g){if(e(c,"function"))f=d,d=c,c=null;else if(e(c,"object")){var i=[];for(var j in c)c.hasOwnProperty(j)&&i.push(encodeURIComponent(j)+"="+encodeURIComponent(c[j]));c=i.join("&")}return g.open(c?"POST":"GET",a,!0),c&&(g.setRequestHeader("X-Requested-With","XMLHttpRequest"),g.setRequestHeader("Content-type","application/x-www-form-urlencoded")),d&&(b.once("snap.ajax."+h+".0",d),b.once("snap.ajax."+h+".200",d),b.once("snap.ajax."+h+".304",d)),g.onreadystatechange=function(){4==g.readyState&&b("snap.ajax."+h+"."+g.status,f,g)},4==g.readyState?g:(g.send(c),g)}},c.load=function(a,b,d){c.ajax(a,function(a){var e=c.parse(a.responseText);d?b.call(d,e):b(e)})};var cb=function(a){var b=a.getBoundingClientRect(),c=a.ownerDocument,d=c.body,e=c.documentElement,f=e.clientTop||d.clientTop||0,h=e.clientLeft||d.clientLeft||0,i=b.top+(g.win.pageYOffset||e.scrollTop||d.scrollTop)-f,j=b.left+(g.win.pageXOffset||e.scrollLeft||d.scrollLeft)-h;return{y:i,x:j}};return c.getElementByPoint=function(a,b){var c=this,d=(c.canvas,y.doc.elementFromPoint(a,b));if(y.win.opera&&"svg"==d.tagName){var e=cb(d),f=d.createSVGRect();f.x=a-e.x,f.y=b-e.y,f.width=f.height=1;var g=d.getIntersectionList(f,null);g.length&&(d=g[g.length-1])}return d?w(d):null},c.plugin=function(a){a(c,s,v,y,t)},y.win.Snap=c,c}(a||this);return d.plugin(function(d,e,f,g,h){function i(a,b){if(null==b){var c=!0;if(b=a.node.getAttribute("linearGradient"==a.type||"radialGradient"==a.type?"gradientTransform":"pattern"==a.type?"patternTransform":"transform"),!b)return new d.Matrix;b=d._.svgTransform2string(b)}else b=d._.rgTransform.test(b)?o(b).replace(/\.{3}|\u2026/g,a._.transform||""):d._.svgTransform2string(b),n(b,"array")&&(b=d.path?d.path.toString.call(b):o(b)),a._.transform=b;var e=d._.transform2matrix(b,a.getBBox(1));return c?e:void(a.matrix=e)}function j(a){function b(a,b){var c=q(a.node,b);c=c&&c.match(f),c=c&&c[2],c&&"#"==c.charAt()&&(c=c.substring(1),c&&(h[c]=(h[c]||[]).concat(function(c){var d={};d[b]=URL(c),q(a.node,d)})))}function c(a){var b=q(a.node,"xlink:href");b&&"#"==b.charAt()&&(b=b.substring(1),b&&(h[b]=(h[b]||[]).concat(function(b){a.attr("xlink:href","#"+b)})))}for(var d,e=a.selectAll("*"),f=/^\s*url\(("|'|)(.*)\1\)\s*$/,g=[],h={},i=0,j=e.length;j>i;i++){d=e[i],b(d,"fill"),b(d,"stroke"),b(d,"filter"),b(d,"mask"),b(d,"clip-path"),c(d);var k=q(d.node,"id");k&&(q(d.node,{id:d.id}),g.push({old:k,id:d.id}))}for(i=0,j=g.length;j>i;i++){var l=h[g[i].old];if(l)for(var m=0,n=l.length;n>m;m++)l[m](g[i].id)}}function k(a,b,c){return function(d){var e=d.slice(a,b);return 1==e.length&&(e=e[0]),c?c(e):e}}function l(a){return function(){var b=a?"<"+this.type:"",c=this.node.attributes,d=this.node.childNodes;if(a)for(var e=0,f=c.length;f>e;e++)b+=" "+c[e].name+'="'+c[e].value.replace(/"/g,'\\"')+'"';if(d.length){for(a&&(b+=">"),e=0,f=d.length;f>e;e++)3==d[e].nodeType?b+=d[e].nodeValue:1==d[e].nodeType&&(b+=u(d[e]).toString());a&&(b+="</"+this.type+">")}else a&&(b+="/>");return b}}var m=e.prototype,n=d.is,o=String,p=d._unit2px,q=d._.$,r=d._.make,s=d._.getSomeDefs,t="hasOwnProperty",u=d._.wrap;m.getBBox=function(a){if(!d.Matrix||!d.path)return this.node.getBBox();var b=this,c=new d.Matrix;if(b.removed)return d._.box();for(;"use"==b.type;)if(a||(c=c.add(b.transform().localMatrix.translate(b.attr("x")||0,b.attr("y")||0))),b.original)b=b.original;else{var e=b.attr("xlink:href");b=b.original=b.node.ownerDocument.getElementById(e.substring(e.indexOf("#")+1))}var f=b._,g=d.path.get[b.type]||d.path.get.deflt;try{return a?(f.bboxwt=g?d.path.getBBox(b.realPath=g(b)):d._.box(b.node.getBBox()),d._.box(f.bboxwt)):(b.realPath=g(b),b.matrix=b.transform().localMatrix,f.bbox=d.path.getBBox(d.path.map(b.realPath,c.add(b.matrix))),d._.box(f.bbox))}catch(h){return d._.box()}};var v=function(){return this.string};m.transform=function(a){var b=this._;if(null==a){for(var c,e=this,f=new d.Matrix(this.node.getCTM()),g=i(this),h=[g],j=new d.Matrix,k=g.toTransformString(),l=o(g)==o(this.matrix)?o(b.transform):k;"svg"!=e.type&&(e=e.parent());)h.push(i(e));for(c=h.length;c--;)j.add(h[c]);return{string:l,globalMatrix:f,totalMatrix:j,localMatrix:g,diffMatrix:f.clone().add(g.invert()),global:f.toTransformString(),total:j.toTransformString(),local:k,toString:v}}return a instanceof d.Matrix?(this.matrix=a,this._.transform=a.toTransformString()):i(this,a),this.node&&("linearGradient"==this.type||"radialGradient"==this.type?q(this.node,{gradientTransform:this.matrix}):"pattern"==this.type?q(this.node,{patternTransform:this.matrix}):q(this.node,{transform:this.matrix})),this},m.parent=function(){return u(this.node.parentNode)},m.append=m.add=function(a){if(a){if("set"==a.type){var b=this;return a.forEach(function(a){b.add(a)}),this}a=u(a),this.node.appendChild(a.node),a.paper=this.paper}return this},m.appendTo=function(a){return a&&(a=u(a),a.append(this)),this},m.prepend=function(a){if(a){if("set"==a.type){var b,c=this;return a.forEach(function(a){b?b.after(a):c.prepend(a),b=a}),this}a=u(a);var d=a.parent();this.node.insertBefore(a.node,this.node.firstChild),this.add&&this.add(),a.paper=this.paper,this.parent()&&this.parent().add(),d&&d.add()}return this},m.prependTo=function(a){return a=u(a),a.prepend(this),this},m.before=function(a){if("set"==a.type){var b=this;return a.forEach(function(a){var c=a.parent();b.node.parentNode.insertBefore(a.node,b.node),c&&c.add()}),this.parent().add(),this}a=u(a);var c=a.parent();return this.node.parentNode.insertBefore(a.node,this.node),this.parent()&&this.parent().add(),c&&c.add(),a.paper=this.paper,this},m.after=function(a){a=u(a);var b=a.parent();return this.node.nextSibling?this.node.parentNode.insertBefore(a.node,this.node.nextSibling):this.node.parentNode.appendChild(a.node),this.parent()&&this.parent().add(),b&&b.add(),a.paper=this.paper,this},m.insertBefore=function(a){a=u(a);var b=this.parent();return a.node.parentNode.insertBefore(this.node,a.node),this.paper=a.paper,b&&b.add(),a.parent()&&a.parent().add(),this},m.insertAfter=function(a){a=u(a);var b=this.parent();return a.node.parentNode.insertBefore(this.node,a.node.nextSibling),this.paper=a.paper,b&&b.add(),a.parent()&&a.parent().add(),this},m.remove=function(){var a=this.parent();return this.node.parentNode&&this.node.parentNode.removeChild(this.node),delete this.paper,this.removed=!0,a&&a.add(),this},m.select=function(a){return u(this.node.querySelector(a))},m.selectAll=function(a){for(var b=this.node.querySelectorAll(a),c=(d.set||Array)(),e=0;e<b.length;e++)c.push(u(b[e]));return c},m.asPX=function(a,b){return null==b&&(b=this.attr(a)),+p(this,a,b)},m.use=function(){var a,b=this.node.id;return b||(b=this.id,q(this.node,{id:b})),a="linearGradient"==this.type||"radialGradient"==this.type||"pattern"==this.type?r(this.type,this.node.parentNode):r("use",this.node.parentNode),q(a.node,{"xlink:href":"#"+b}),a.original=this,a},m.clone=function(){var a=u(this.node.cloneNode(!0));return q(a.node,"id")&&q(a.node,{id:a.id}),j(a),a.insertAfter(this),a},m.toDefs=function(){var a=s(this);return a.appendChild(this.node),this},m.pattern=m.toPattern=function(a,b,c,d){var e=r("pattern",s(this));return null==a&&(a=this.getBBox()),n(a,"object")&&"x"in a&&(b=a.y,c=a.width,d=a.height,a=a.x),q(e.node,{x:a,y:b,width:c,height:d,patternUnits:"userSpaceOnUse",id:e.id,viewBox:[a,b,c,d].join(" ")}),e.node.appendChild(this.node),e},m.marker=function(a,b,c,d,e,f){var g=r("marker",s(this));return null==a&&(a=this.getBBox()),n(a,"object")&&"x"in a&&(b=a.y,c=a.width,d=a.height,e=a.refX||a.cx,f=a.refY||a.cy,a=a.x),q(g.node,{viewBox:[a,b,c,d].join(" "),markerWidth:c,markerHeight:d,orient:"auto",refX:e||0,refY:f||0,id:g.id}),g.node.appendChild(this.node),g};var w=function(a,b,d,e){"function"!=typeof d||d.length||(e=d,d=c.linear),this.attr=a,this.dur=b,d&&(this.easing=d),e&&(this.callback=e)};d._.Animation=w,d.animation=function(a,b,c,d){return new w(a,b,c,d)},m.inAnim=function(){var a=this,b=[];for(var c in a.anims)a.anims[t](c)&&!function(a){b.push({anim:new w(a._attrs,a.dur,a.easing,a._callback),mina:a,curStatus:a.status(),status:function(b){return a.status(b)},stop:function(){a.stop()}})}(a.anims[c]);return b},d.animate=function(a,d,e,f,g,h){"function"!=typeof g||g.length||(h=g,g=c.linear);var i=c.time(),j=c(a,d,i,i+f,c.time,e,g);return h&&b.once("mina.finish."+j.id,h),j},m.stop=function(){for(var a=this.inAnim(),b=0,c=a.length;c>b;b++)a[b].stop();return this},m.animate=function(a,d,e,f){"function"!=typeof e||e.length||(f=e,e=c.linear),a instanceof w&&(f=a.callback,e=a.easing,d=a.dur,a=a.attr);var g,h,i,j,l=[],m=[],p={},q=this;for(var r in a)if(a[t](r)){q.equal?(j=q.equal(r,o(a[r])),g=j.from,h=j.to,i=j.f):(g=+q.attr(r),h=+a[r]);var s=n(g,"array")?g.length:1;p[r]=k(l.length,l.length+s,i),l=l.concat(g),m=m.concat(h)}var u=c.time(),v=c(l,m,u,u+d,c.time,function(a){var b={};for(var c in p)p[t](c)&&(b[c]=p[c](a));q.attr(b)},e);return q.anims[v.id]=v,v._attrs=a,v._callback=f,b("snap.animcreated."+q.id,v),b.once("mina.finish."+v.id,function(){delete q.anims[v.id],f&&f.call(q)}),b.once("mina.stop."+v.id,function(){delete q.anims[v.id]}),q};var x={};m.data=function(a,c){var e=x[this.id]=x[this.id]||{};if(0==arguments.length)return b("snap.data.get."+this.id,this,e,null),e;
    if(1==arguments.length){if(d.is(a,"object")){for(var f in a)a[t](f)&&this.data(f,a[f]);return this}return b("snap.data.get."+this.id,this,e[a],a),e[a]}return e[a]=c,b("snap.data.set."+this.id,this,c,a),this},m.removeData=function(a){return null==a?x[this.id]={}:x[this.id]&&delete x[this.id][a],this},m.outerSVG=m.toString=l(1),m.innerSVG=l(),m.toDataURL=function(){if(a&&a.btoa){var b=this.getBBox(),c=d.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>',{x:+b.x.toFixed(3),y:+b.y.toFixed(3),width:+b.width.toFixed(3),height:+b.height.toFixed(3),contents:this.outerSVG()});return"data:image/svg+xml;base64,"+btoa(unescape(encodeURIComponent(c)))}},h.prototype.select=m.select,h.prototype.selectAll=m.selectAll}),d.plugin(function(a){function b(a,b,d,e,f,g){return null==b&&"[object SVGMatrix]"==c.call(a)?(this.a=a.a,this.b=a.b,this.c=a.c,this.d=a.d,this.e=a.e,void(this.f=a.f)):void(null!=a?(this.a=+a,this.b=+b,this.c=+d,this.d=+e,this.e=+f,this.f=+g):(this.a=1,this.b=0,this.c=0,this.d=1,this.e=0,this.f=0))}var c=Object.prototype.toString,d=String,e=Math,f="";!function(c){function g(a){return a[0]*a[0]+a[1]*a[1]}function h(a){var b=e.sqrt(g(a));a[0]&&(a[0]/=b),a[1]&&(a[1]/=b)}c.add=function(a,c,d,e,f,g){var h,i,j,k,l=[[],[],[]],m=[[this.a,this.c,this.e],[this.b,this.d,this.f],[0,0,1]],n=[[a,d,f],[c,e,g],[0,0,1]];for(a&&a instanceof b&&(n=[[a.a,a.c,a.e],[a.b,a.d,a.f],[0,0,1]]),h=0;3>h;h++)for(i=0;3>i;i++){for(k=0,j=0;3>j;j++)k+=m[h][j]*n[j][i];l[h][i]=k}return this.a=l[0][0],this.b=l[1][0],this.c=l[0][1],this.d=l[1][1],this.e=l[0][2],this.f=l[1][2],this},c.invert=function(){var a=this,c=a.a*a.d-a.b*a.c;return new b(a.d/c,-a.b/c,-a.c/c,a.a/c,(a.c*a.f-a.d*a.e)/c,(a.b*a.e-a.a*a.f)/c)},c.clone=function(){return new b(this.a,this.b,this.c,this.d,this.e,this.f)},c.translate=function(a,b){return this.add(1,0,0,1,a,b)},c.scale=function(a,b,c,d){return null==b&&(b=a),(c||d)&&this.add(1,0,0,1,c,d),this.add(a,0,0,b,0,0),(c||d)&&this.add(1,0,0,1,-c,-d),this},c.rotate=function(b,c,d){b=a.rad(b),c=c||0,d=d||0;var f=+e.cos(b).toFixed(9),g=+e.sin(b).toFixed(9);return this.add(f,g,-g,f,c,d),this.add(1,0,0,1,-c,-d)},c.x=function(a,b){return a*this.a+b*this.c+this.e},c.y=function(a,b){return a*this.b+b*this.d+this.f},c.get=function(a){return+this[d.fromCharCode(97+a)].toFixed(4)},c.toString=function(){return"matrix("+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)].join()+")"},c.offset=function(){return[this.e.toFixed(4),this.f.toFixed(4)]},c.determinant=function(){return this.a*this.d-this.b*this.c},c.split=function(){var b={};b.dx=this.e,b.dy=this.f;var c=[[this.a,this.c],[this.b,this.d]];b.scalex=e.sqrt(g(c[0])),h(c[0]),b.shear=c[0][0]*c[1][0]+c[0][1]*c[1][1],c[1]=[c[1][0]-c[0][0]*b.shear,c[1][1]-c[0][1]*b.shear],b.scaley=e.sqrt(g(c[1])),h(c[1]),b.shear/=b.scaley,this.determinant()<0&&(b.scalex=-b.scalex);var d=-c[0][1],f=c[1][1];return 0>f?(b.rotate=a.deg(e.acos(f)),0>d&&(b.rotate=360-b.rotate)):b.rotate=a.deg(e.asin(d)),b.isSimple=!(+b.shear.toFixed(9)||b.scalex.toFixed(9)!=b.scaley.toFixed(9)&&b.rotate),b.isSuperSimple=!+b.shear.toFixed(9)&&b.scalex.toFixed(9)==b.scaley.toFixed(9)&&!b.rotate,b.noRotation=!+b.shear.toFixed(9)&&!b.rotate,b},c.toTransformString=function(a){var b=a||this.split();return+b.shear.toFixed(9)?"m"+[this.get(0),this.get(1),this.get(2),this.get(3),this.get(4),this.get(5)]:(b.scalex=+b.scalex.toFixed(4),b.scaley=+b.scaley.toFixed(4),b.rotate=+b.rotate.toFixed(4),(b.dx||b.dy?"t"+[+b.dx.toFixed(4),+b.dy.toFixed(4)]:f)+(1!=b.scalex||1!=b.scaley?"s"+[b.scalex,b.scaley,0,0]:f)+(b.rotate?"r"+[+b.rotate.toFixed(4),0,0]:f))}}(b.prototype),a.Matrix=b,a.matrix=function(a,c,d,e,f,g){return new b(a,c,d,e,f,g)}}),d.plugin(function(a,c,d,e,f){function g(d){return function(e){if(b.stop(),e instanceof f&&1==e.node.childNodes.length&&("radialGradient"==e.node.firstChild.tagName||"linearGradient"==e.node.firstChild.tagName||"pattern"==e.node.firstChild.tagName)&&(e=e.node.firstChild,n(this).appendChild(e),e=l(e)),e instanceof c)if("radialGradient"==e.type||"linearGradient"==e.type||"pattern"==e.type){e.node.id||p(e.node,{id:e.id});var g=q(e.node.id)}else g=e.attr(d);else if(g=a.color(e),g.error){var h=a(n(this).ownerSVGElement).gradient(e);h?(h.node.id||p(h.node,{id:h.id}),g=q(h.node.id)):g=e}else g=r(g);var i={};i[d]=g,p(this.node,i),this.node.style[d]=t}}function h(a){b.stop(),a==+a&&(a+="px"),this.node.style.fontSize=a}function i(a){for(var b=[],c=a.childNodes,d=0,e=c.length;e>d;d++){var f=c[d];3==f.nodeType&&b.push(f.nodeValue),"tspan"==f.tagName&&b.push(1==f.childNodes.length&&3==f.firstChild.nodeType?f.firstChild.nodeValue:i(f))}return b}function j(){return b.stop(),this.node.style.fontSize}var k=a._.make,l=a._.wrap,m=a.is,n=a._.getSomeDefs,o=/^url\(#?([^)]+)\)$/,p=a._.$,q=a.url,r=String,s=a._.separator,t="";b.on("snap.util.attr.mask",function(a){if(a instanceof c||a instanceof f){if(b.stop(),a instanceof f&&1==a.node.childNodes.length&&(a=a.node.firstChild,n(this).appendChild(a),a=l(a)),"mask"==a.type)var d=a;else d=k("mask",n(this)),d.node.appendChild(a.node);!d.node.id&&p(d.node,{id:d.id}),p(this.node,{mask:q(d.id)})}}),function(a){b.on("snap.util.attr.clip",a),b.on("snap.util.attr.clip-path",a),b.on("snap.util.attr.clipPath",a)}(function(a){if(a instanceof c||a instanceof f){if(b.stop(),"clipPath"==a.type)var d=a;else d=k("clipPath",n(this)),d.node.appendChild(a.node),!d.node.id&&p(d.node,{id:d.id});p(this.node,{"clip-path":q(d.node.id||d.id)})}}),b.on("snap.util.attr.fill",g("fill")),b.on("snap.util.attr.stroke",g("stroke"));var u=/^([lr])(?:\(([^)]*)\))?(.*)$/i;b.on("snap.util.grad.parse",function(a){a=r(a);var b=a.match(u);if(!b)return null;var c=b[1],d=b[2],e=b[3];return d=d.split(/\s*,\s*/).map(function(a){return+a==a?+a:a}),1==d.length&&0==d[0]&&(d=[]),e=e.split("-"),e=e.map(function(a){a=a.split(":");var b={color:a[0]};return a[1]&&(b.offset=parseFloat(a[1])),b}),{type:c,params:d,stops:e}}),b.on("snap.util.attr.d",function(c){b.stop(),m(c,"array")&&m(c[0],"array")&&(c=a.path.toString.call(c)),c=r(c),c.match(/[ruo]/i)&&(c=a.path.toAbsolute(c)),p(this.node,{d:c})})(-1),b.on("snap.util.attr.#text",function(a){b.stop(),a=r(a);for(var c=e.doc.createTextNode(a);this.node.firstChild;)this.node.removeChild(this.node.firstChild);this.node.appendChild(c)})(-1),b.on("snap.util.attr.path",function(a){b.stop(),this.attr({d:a})})(-1),b.on("snap.util.attr.class",function(a){b.stop(),this.node.className.baseVal=a})(-1),b.on("snap.util.attr.viewBox",function(a){var c;c=m(a,"object")&&"x"in a?[a.x,a.y,a.width,a.height].join(" "):m(a,"array")?a.join(" "):a,p(this.node,{viewBox:c}),b.stop()})(-1),b.on("snap.util.attr.transform",function(a){this.transform(a),b.stop()})(-1),b.on("snap.util.attr.r",function(a){"rect"==this.type&&(b.stop(),p(this.node,{rx:a,ry:a}))})(-1),b.on("snap.util.attr.textpath",function(a){if(b.stop(),"text"==this.type){var d,e,f;if(!a&&this.textPath){for(e=this.textPath;e.node.firstChild;)this.node.appendChild(e.node.firstChild);return e.remove(),void delete this.textPath}if(m(a,"string")){var g=n(this),h=l(g.parentNode).path(a);g.appendChild(h.node),d=h.id,h.attr({id:d})}else a=l(a),a instanceof c&&(d=a.attr("id"),d||(d=a.id,a.attr({id:d})));if(d)if(e=this.textPath,f=this.node,e)e.attr({"xlink:href":"#"+d});else{for(e=p("textPath",{"xlink:href":"#"+d});f.firstChild;)e.appendChild(f.firstChild);f.appendChild(e),this.textPath=l(e)}}})(-1),b.on("snap.util.attr.text",function(a){if("text"==this.type){for(var c=this.node,d=function(a){var b=p("tspan");if(m(a,"array"))for(var c=0;c<a.length;c++)b.appendChild(d(a[c]));else b.appendChild(e.doc.createTextNode(a));return b.normalize&&b.normalize(),b};c.firstChild;)c.removeChild(c.firstChild);for(var f=d(a);f.firstChild;)c.appendChild(f.firstChild)}b.stop()})(-1),b.on("snap.util.attr.fontSize",h)(-1),b.on("snap.util.attr.font-size",h)(-1),b.on("snap.util.getattr.transform",function(){return b.stop(),this.transform()})(-1),b.on("snap.util.getattr.textpath",function(){return b.stop(),this.textPath})(-1),function(){function c(c){return function(){b.stop();var d=e.doc.defaultView.getComputedStyle(this.node,null).getPropertyValue("marker-"+c);return"none"==d?d:a(e.doc.getElementById(d.match(o)[1]))}}function d(a){return function(c){b.stop();var d="marker"+a.charAt(0).toUpperCase()+a.substring(1);if(""==c||!c)return void(this.node.style[d]="none");if("marker"==c.type){var e=c.node.id;return e||p(c.node,{id:c.id}),void(this.node.style[d]=q(e))}}}b.on("snap.util.getattr.marker-end",c("end"))(-1),b.on("snap.util.getattr.markerEnd",c("end"))(-1),b.on("snap.util.getattr.marker-start",c("start"))(-1),b.on("snap.util.getattr.markerStart",c("start"))(-1),b.on("snap.util.getattr.marker-mid",c("mid"))(-1),b.on("snap.util.getattr.markerMid",c("mid"))(-1),b.on("snap.util.attr.marker-end",d("end"))(-1),b.on("snap.util.attr.markerEnd",d("end"))(-1),b.on("snap.util.attr.marker-start",d("start"))(-1),b.on("snap.util.attr.markerStart",d("start"))(-1),b.on("snap.util.attr.marker-mid",d("mid"))(-1),b.on("snap.util.attr.markerMid",d("mid"))(-1)}(),b.on("snap.util.getattr.r",function(){return"rect"==this.type&&p(this.node,"rx")==p(this.node,"ry")?(b.stop(),p(this.node,"rx")):void 0})(-1),b.on("snap.util.getattr.text",function(){if("text"==this.type||"tspan"==this.type){b.stop();var a=i(this.node);return 1==a.length?a[0]:a}})(-1),b.on("snap.util.getattr.#text",function(){return this.node.textContent})(-1),b.on("snap.util.getattr.viewBox",function(){b.stop();var c=p(this.node,"viewBox");return c?(c=c.split(s),a._.box(+c[0],+c[1],+c[2],+c[3])):void 0})(-1),b.on("snap.util.getattr.points",function(){var a=p(this.node,"points");return b.stop(),a?a.split(s):void 0})(-1),b.on("snap.util.getattr.path",function(){var a=p(this.node,"d");return b.stop(),a})(-1),b.on("snap.util.getattr.class",function(){return this.node.className.baseVal})(-1),b.on("snap.util.getattr.fontSize",j)(-1),b.on("snap.util.getattr.font-size",j)(-1)}),d.plugin(function(a,b){var c=/\S+/g,d=String,e=b.prototype;e.addClass=function(a){var b,e,f,g,h=d(a||"").match(c)||[],i=this.node,j=i.className.baseVal,k=j.match(c)||[];if(h.length){for(b=0;f=h[b++];)e=k.indexOf(f),~e||k.push(f);g=k.join(" "),j!=g&&(i.className.baseVal=g)}return this},e.removeClass=function(a){var b,e,f,g,h=d(a||"").match(c)||[],i=this.node,j=i.className.baseVal,k=j.match(c)||[];if(k.length){for(b=0;f=h[b++];)e=k.indexOf(f),~e&&k.splice(e,1);g=k.join(" "),j!=g&&(i.className.baseVal=g)}return this},e.hasClass=function(a){var b=this.node,d=b.className.baseVal,e=d.match(c)||[];return!!~e.indexOf(a)},e.toggleClass=function(a,b){if(null!=b)return b?this.addClass(a):this.removeClass(a);var d,e,f,g,h=(a||"").match(c)||[],i=this.node,j=i.className.baseVal,k=j.match(c)||[];for(d=0;f=h[d++];)e=k.indexOf(f),~e?k.splice(e,1):k.push(f);return g=k.join(" "),j!=g&&(i.className.baseVal=g),this}}),d.plugin(function(){function a(a){return a}function c(a){return function(b){return+b.toFixed(3)+a}}var d={"+":function(a,b){return a+b},"-":function(a,b){return a-b},"/":function(a,b){return a/b},"*":function(a,b){return a*b}},e=String,f=/[a-z]+$/i,g=/^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;b.on("snap.util.attr",function(a){var c=e(a).match(g);if(c){var h=b.nt(),i=h.substring(h.lastIndexOf(".")+1),j=this.attr(i),k={};b.stop();var l=c[3]||"",m=j.match(f),n=d[c[1]];if(m&&m==l?a=n(parseFloat(j),+c[2]):(j=this.asPX(i),a=n(this.asPX(i),this.asPX(i,c[2]+l))),isNaN(j)||isNaN(a))return;k[i]=a,this.attr(k)}})(-10),b.on("snap.util.equal",function(h,i){var j=e(this.attr(h)||""),k=e(i).match(g);if(k){b.stop();var l=k[3]||"",m=j.match(f),n=d[k[1]];return m&&m==l?{from:parseFloat(j),to:n(parseFloat(j),+k[2]),f:c(m)}:(j=this.asPX(h),{from:j,to:n(j,this.asPX(h,k[2]+l)),f:a})}})(-10)}),d.plugin(function(c,d,e,f){var g=e.prototype,h=c.is;g.rect=function(a,b,c,d,e,f){var g;return null==f&&(f=e),h(a,"object")&&"[object Object]"==a?g=a:null!=a&&(g={x:a,y:b,width:c,height:d},null!=e&&(g.rx=e,g.ry=f)),this.el("rect",g)},g.circle=function(a,b,c){var d;return h(a,"object")&&"[object Object]"==a?d=a:null!=a&&(d={cx:a,cy:b,r:c}),this.el("circle",d)};var i=function(){function a(){this.parentNode.removeChild(this)}return function(b,c){var d=f.doc.createElement("img"),e=f.doc.body;d.style.cssText="position:absolute;left:-9999em;top:-9999em",d.onload=function(){c.call(d),d.onload=d.onerror=null,e.removeChild(d)},d.onerror=a,e.appendChild(d),d.src=b}}();g.image=function(a,b,d,e,f){var g=this.el("image");if(h(a,"object")&&"src"in a)g.attr(a);else if(null!=a){var j={"xlink:href":a,preserveAspectRatio:"none"};null!=b&&null!=d&&(j.x=b,j.y=d),null!=e&&null!=f?(j.width=e,j.height=f):i(a,function(){c._.$(g.node,{width:this.offsetWidth,height:this.offsetHeight})}),c._.$(g.node,j)}return g},g.ellipse=function(a,b,c,d){var e;return h(a,"object")&&"[object Object]"==a?e=a:null!=a&&(e={cx:a,cy:b,rx:c,ry:d}),this.el("ellipse",e)},g.path=function(a){var b;return h(a,"object")&&!h(a,"array")?b=a:a&&(b={d:a}),this.el("path",b)},g.group=g.g=function(a){var b=this.el("g");return 1==arguments.length&&a&&!a.type?b.attr(a):arguments.length&&b.add(Array.prototype.slice.call(arguments,0)),b},g.svg=function(a,b,c,d,e,f,g,i){var j={};return h(a,"object")&&null==b?j=a:(null!=a&&(j.x=a),null!=b&&(j.y=b),null!=c&&(j.width=c),null!=d&&(j.height=d),null!=e&&null!=f&&null!=g&&null!=i&&(j.viewBox=[e,f,g,i])),this.el("svg",j)},g.mask=function(a){var b=this.el("mask");return 1==arguments.length&&a&&!a.type?b.attr(a):arguments.length&&b.add(Array.prototype.slice.call(arguments,0)),b},g.ptrn=function(a,b,c,d,e,f,g,i){if(h(a,"object"))var j=a;else j={patternUnits:"userSpaceOnUse"},a&&(j.x=a),b&&(j.y=b),null!=c&&(j.width=c),null!=d&&(j.height=d),j.viewBox=null!=e&&null!=f&&null!=g&&null!=i?[e,f,g,i]:[a||0,b||0,c||0,d||0];return this.el("pattern",j)},g.use=function(a){return null!=a?(a instanceof d&&(a.attr("id")||a.attr({id:c._.id(a)}),a=a.attr("id")),"#"==String(a).charAt()&&(a=a.substring(1)),this.el("use",{"xlink:href":"#"+a})):d.prototype.use.call(this)},g.symbol=function(a,b,c,d){var e={};return null!=a&&null!=b&&null!=c&&null!=d&&(e.viewBox=[a,b,c,d]),this.el("symbol",e)},g.text=function(a,b,c){var d={};return h(a,"object")?d=a:null!=a&&(d={x:a,y:b,text:c||""}),this.el("text",d)},g.line=function(a,b,c,d){var e={};return h(a,"object")?e=a:null!=a&&(e={x1:a,x2:c,y1:b,y2:d}),this.el("line",e)},g.polyline=function(a){arguments.length>1&&(a=Array.prototype.slice.call(arguments,0));var b={};return h(a,"object")&&!h(a,"array")?b=a:null!=a&&(b={points:a}),this.el("polyline",b)},g.polygon=function(a){arguments.length>1&&(a=Array.prototype.slice.call(arguments,0));var b={};return h(a,"object")&&!h(a,"array")?b=a:null!=a&&(b={points:a}),this.el("polygon",b)},function(){function d(){return this.selectAll("stop")}function e(a,b){var d=k("stop"),e={offset:+b+"%"};return a=c.color(a),e["stop-color"]=a.hex,a.opacity<1&&(e["stop-opacity"]=a.opacity),k(d,e),this.node.appendChild(d),this}function f(){if("linearGradient"==this.type){var a=k(this.node,"x1")||0,b=k(this.node,"x2")||1,d=k(this.node,"y1")||0,e=k(this.node,"y2")||0;return c._.box(a,d,math.abs(b-a),math.abs(e-d))}var f=this.node.cx||.5,g=this.node.cy||.5,h=this.node.r||0;return c._.box(f-h,g-h,2*h,2*h)}function h(a,c){function d(a,b){for(var c=(b-l)/(a-m),d=m;a>d;d++)g[d].offset=+(+l+c*(d-m)).toFixed(2);m=a,l=b}var e,f=b("snap.util.grad.parse",null,c).firstDefined();if(!f)return null;f.params.unshift(a),e="l"==f.type.toLowerCase()?i.apply(0,f.params):j.apply(0,f.params),f.type!=f.type.toLowerCase()&&k(e.node,{gradientUnits:"userSpaceOnUse"});var g=f.stops,h=g.length,l=0,m=0;h--;for(var n=0;h>n;n++)"offset"in g[n]&&d(n,g[n].offset);for(g[h].offset=g[h].offset||100,d(h,g[h].offset),n=0;h>=n;n++){var o=g[n];e.addStop(o.color,o.offset)}return e}function i(a,b,g,h,i){var j=c._.make("linearGradient",a);return j.stops=d,j.addStop=e,j.getBBox=f,null!=b&&k(j.node,{x1:b,y1:g,x2:h,y2:i}),j}function j(a,b,g,h,i,j){var l=c._.make("radialGradient",a);return l.stops=d,l.addStop=e,l.getBBox=f,null!=b&&k(l.node,{cx:b,cy:g,r:h}),null!=i&&null!=j&&k(l.node,{fx:i,fy:j}),l}var k=c._.$;g.gradient=function(a){return h(this.defs,a)},g.gradientLinear=function(a,b,c,d){return i(this.defs,a,b,c,d)},g.gradientRadial=function(a,b,c,d,e){return j(this.defs,a,b,c,d,e)},g.toString=function(){var a,b=this.node.ownerDocument,d=b.createDocumentFragment(),e=b.createElement("div"),f=this.node.cloneNode(!0);return d.appendChild(e),e.appendChild(f),c._.$(f,{xmlns:"http://www.w3.org/2000/svg"}),a=e.innerHTML,d.removeChild(d.firstChild),a},g.toDataURL=function(){return a&&a.btoa?"data:image/svg+xml;base64,"+btoa(unescape(encodeURIComponent(this))):void 0},g.clear=function(){for(var a,b=this.node.firstChild;b;)a=b.nextSibling,"defs"!=b.tagName?b.parentNode.removeChild(b):g.clear.call({node:b}),b=a}}()}),d.plugin(function(a,b){function c(a){var b=c.ps=c.ps||{};return b[a]?b[a].sleep=100:b[a]={sleep:100},setTimeout(function(){for(var c in b)b[K](c)&&c!=a&&(b[c].sleep--,!b[c].sleep&&delete b[c])}),b[a]}function d(a,b,c,d){return null==a&&(a=b=c=d=0),null==b&&(b=a.y,c=a.width,d=a.height,a=a.x),{x:a,y:b,width:c,w:c,height:d,h:d,x2:a+c,y2:b+d,cx:a+c/2,cy:b+d/2,r1:N.min(c,d)/2,r2:N.max(c,d)/2,r0:N.sqrt(c*c+d*d)/2,path:w(a,b,c,d),vb:[a,b,c,d].join(" ")}}function e(){return this.join(",").replace(L,"$1")}function f(a){var b=J(a);return b.toString=e,b}function g(a,b,c,d,e,f,g,h,j){return null==j?n(a,b,c,d,e,f,g,h):i(a,b,c,d,e,f,g,h,o(a,b,c,d,e,f,g,h,j))}function h(c,d){function e(a){return+(+a).toFixed(3)}return a._.cacher(function(a,f,h){a instanceof b&&(a=a.attr("d")),a=E(a);for(var j,k,l,m,n,o="",p={},q=0,r=0,s=a.length;s>r;r++){if(l=a[r],"M"==l[0])j=+l[1],k=+l[2];else{if(m=g(j,k,l[1],l[2],l[3],l[4],l[5],l[6]),q+m>f){if(d&&!p.start){if(n=g(j,k,l[1],l[2],l[3],l[4],l[5],l[6],f-q),o+=["C"+e(n.start.x),e(n.start.y),e(n.m.x),e(n.m.y),e(n.x),e(n.y)],h)return o;p.start=o,o=["M"+e(n.x),e(n.y)+"C"+e(n.n.x),e(n.n.y),e(n.end.x),e(n.end.y),e(l[5]),e(l[6])].join(),q+=m,j=+l[5],k=+l[6];continue}if(!c&&!d)return n=g(j,k,l[1],l[2],l[3],l[4],l[5],l[6],f-q)}q+=m,j=+l[5],k=+l[6]}o+=l.shift()+l}return p.end=o,n=c?q:d?p:i(j,k,l[0],l[1],l[2],l[3],l[4],l[5],1)},null,a._.clone)}function i(a,b,c,d,e,f,g,h,i){var j=1-i,k=R(j,3),l=R(j,2),m=i*i,n=m*i,o=k*a+3*l*i*c+3*j*i*i*e+n*g,p=k*b+3*l*i*d+3*j*i*i*f+n*h,q=a+2*i*(c-a)+m*(e-2*c+a),r=b+2*i*(d-b)+m*(f-2*d+b),s=c+2*i*(e-c)+m*(g-2*e+c),t=d+2*i*(f-d)+m*(h-2*f+d),u=j*a+i*c,v=j*b+i*d,w=j*e+i*g,x=j*f+i*h,y=90-180*N.atan2(q-s,r-t)/O;return{x:o,y:p,m:{x:q,y:r},n:{x:s,y:t},start:{x:u,y:v},end:{x:w,y:x},alpha:y}}function j(b,c,e,f,g,h,i,j){a.is(b,"array")||(b=[b,c,e,f,g,h,i,j]);var k=D.apply(null,b);return d(k.min.x,k.min.y,k.max.x-k.min.x,k.max.y-k.min.y)}function k(a,b,c){return b>=a.x&&b<=a.x+a.width&&c>=a.y&&c<=a.y+a.height}function l(a,b){return a=d(a),b=d(b),k(b,a.x,a.y)||k(b,a.x2,a.y)||k(b,a.x,a.y2)||k(b,a.x2,a.y2)||k(a,b.x,b.y)||k(a,b.x2,b.y)||k(a,b.x,b.y2)||k(a,b.x2,b.y2)||(a.x<b.x2&&a.x>b.x||b.x<a.x2&&b.x>a.x)&&(a.y<b.y2&&a.y>b.y||b.y<a.y2&&b.y>a.y)}function m(a,b,c,d,e){var f=-3*b+9*c-9*d+3*e,g=a*f+6*b-12*c+6*d;return a*g-3*b+3*c}function n(a,b,c,d,e,f,g,h,i){null==i&&(i=1),i=i>1?1:0>i?0:i;for(var j=i/2,k=12,l=[-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],n=[.2491,.2491,.2335,.2335,.2032,.2032,.1601,.1601,.1069,.1069,.0472,.0472],o=0,p=0;k>p;p++){var q=j*l[p]+j,r=m(q,a,c,e,g),s=m(q,b,d,f,h),t=r*r+s*s;o+=n[p]*N.sqrt(t)}return j*o}function o(a,b,c,d,e,f,g,h,i){if(!(0>i||n(a,b,c,d,e,f,g,h)<i)){var j,k=1,l=k/2,m=k-l,o=.01;for(j=n(a,b,c,d,e,f,g,h,m);S(j-i)>o;)l/=2,m+=(i>j?1:-1)*l,j=n(a,b,c,d,e,f,g,h,m);return m}}function p(a,b,c,d,e,f,g,h){if(!(Q(a,c)<P(e,g)||P(a,c)>Q(e,g)||Q(b,d)<P(f,h)||P(b,d)>Q(f,h))){var i=(a*d-b*c)*(e-g)-(a-c)*(e*h-f*g),j=(a*d-b*c)*(f-h)-(b-d)*(e*h-f*g),k=(a-c)*(f-h)-(b-d)*(e-g);if(k){var l=i/k,m=j/k,n=+l.toFixed(2),o=+m.toFixed(2);if(!(n<+P(a,c).toFixed(2)||n>+Q(a,c).toFixed(2)||n<+P(e,g).toFixed(2)||n>+Q(e,g).toFixed(2)||o<+P(b,d).toFixed(2)||o>+Q(b,d).toFixed(2)||o<+P(f,h).toFixed(2)||o>+Q(f,h).toFixed(2)))return{x:l,y:m}}}}function q(a,b,c){var d=j(a),e=j(b);if(!l(d,e))return c?0:[];for(var f=n.apply(0,a),g=n.apply(0,b),h=~~(f/8),k=~~(g/8),m=[],o=[],q={},r=c?0:[],s=0;h+1>s;s++){var t=i.apply(0,a.concat(s/h));m.push({x:t.x,y:t.y,t:s/h})}for(s=0;k+1>s;s++)t=i.apply(0,b.concat(s/k)),o.push({x:t.x,y:t.y,t:s/k});for(s=0;h>s;s++)for(var u=0;k>u;u++){var v=m[s],w=m[s+1],x=o[u],y=o[u+1],z=S(w.x-v.x)<.001?"y":"x",A=S(y.x-x.x)<.001?"y":"x",B=p(v.x,v.y,w.x,w.y,x.x,x.y,y.x,y.y);if(B){if(q[B.x.toFixed(4)]==B.y.toFixed(4))continue;q[B.x.toFixed(4)]=B.y.toFixed(4);var C=v.t+S((B[z]-v[z])/(w[z]-v[z]))*(w.t-v.t),D=x.t+S((B[A]-x[A])/(y[A]-x[A]))*(y.t-x.t);C>=0&&1>=C&&D>=0&&1>=D&&(c?r++:r.push({x:B.x,y:B.y,t1:C,t2:D}))}}return r}function r(a,b){return t(a,b)}function s(a,b){return t(a,b,1)}function t(a,b,c){a=E(a),b=E(b);for(var d,e,f,g,h,i,j,k,l,m,n=c?0:[],o=0,p=a.length;p>o;o++){var r=a[o];if("M"==r[0])d=h=r[1],e=i=r[2];else{"C"==r[0]?(l=[d,e].concat(r.slice(1)),d=l[6],e=l[7]):(l=[d,e,d,e,h,i,h,i],d=h,e=i);for(var s=0,t=b.length;t>s;s++){var u=b[s];if("M"==u[0])f=j=u[1],g=k=u[2];else{"C"==u[0]?(m=[f,g].concat(u.slice(1)),f=m[6],g=m[7]):(m=[f,g,f,g,j,k,j,k],f=j,g=k);var v=q(l,m,c);if(c)n+=v;else{for(var w=0,x=v.length;x>w;w++)v[w].segment1=o,v[w].segment2=s,v[w].bez1=l,v[w].bez2=m;n=n.concat(v)}}}}}return n}function u(a,b,c){var d=v(a);return k(d,b,c)&&t(a,[["M",b,c],["H",d.x2+10]],1)%2==1}function v(a){var b=c(a);if(b.bbox)return J(b.bbox);if(!a)return d();a=E(a);for(var e,f=0,g=0,h=[],i=[],j=0,k=a.length;k>j;j++)if(e=a[j],"M"==e[0])f=e[1],g=e[2],h.push(f),i.push(g);else{var l=D(f,g,e[1],e[2],e[3],e[4],e[5],e[6]);h=h.concat(l.min.x,l.max.x),i=i.concat(l.min.y,l.max.y),f=e[5],g=e[6]}var m=P.apply(0,h),n=P.apply(0,i),o=Q.apply(0,h),p=Q.apply(0,i),q=d(m,n,o-m,p-n);return b.bbox=J(q),q}function w(a,b,c,d,f){if(f)return[["M",+a+ +f,b],["l",c-2*f,0],["a",f,f,0,0,1,f,f],["l",0,d-2*f],["a",f,f,0,0,1,-f,f],["l",2*f-c,0],["a",f,f,0,0,1,-f,-f],["l",0,2*f-d],["a",f,f,0,0,1,f,-f],["z"]];var g=[["M",a,b],["l",c,0],["l",0,d],["l",-c,0],["z"]];return g.toString=e,g}function x(a,b,c,d,f){if(null==f&&null==d&&(d=c),a=+a,b=+b,c=+c,d=+d,null!=f)var g=Math.PI/180,h=a+c*Math.cos(-d*g),i=a+c*Math.cos(-f*g),j=b+c*Math.sin(-d*g),k=b+c*Math.sin(-f*g),l=[["M",h,j],["A",c,c,0,+(f-d>180),0,i,k]];else l=[["M",a,b],["m",0,-d],["a",c,d,0,1,1,0,2*d],["a",c,d,0,1,1,0,-2*d],["z"]];return l.toString=e,l}function y(b){var d=c(b),g=String.prototype.toLowerCase;if(d.rel)return f(d.rel);a.is(b,"array")&&a.is(b&&b[0],"array")||(b=a.parsePathString(b));var h=[],i=0,j=0,k=0,l=0,m=0;"M"==b[0][0]&&(i=b[0][1],j=b[0][2],k=i,l=j,m++,h.push(["M",i,j]));for(var n=m,o=b.length;o>n;n++){var p=h[n]=[],q=b[n];if(q[0]!=g.call(q[0]))switch(p[0]=g.call(q[0]),p[0]){case"a":p[1]=q[1],p[2]=q[2],p[3]=q[3],p[4]=q[4],p[5]=q[5],p[6]=+(q[6]-i).toFixed(3),p[7]=+(q[7]-j).toFixed(3);break;case"v":p[1]=+(q[1]-j).toFixed(3);break;case"m":k=q[1],l=q[2];default:for(var r=1,s=q.length;s>r;r++)p[r]=+(q[r]-(r%2?i:j)).toFixed(3)}else{p=h[n]=[],"m"==q[0]&&(k=q[1]+i,l=q[2]+j);for(var t=0,u=q.length;u>t;t++)h[n][t]=q[t]}var v=h[n].length;switch(h[n][0]){case"z":i=k,j=l;break;case"h":i+=+h[n][v-1];break;case"v":j+=+h[n][v-1];break;default:i+=+h[n][v-2],j+=+h[n][v-1]}}return h.toString=e,d.rel=f(h),h}function z(b){var d=c(b);if(d.abs)return f(d.abs);if(I(b,"array")&&I(b&&b[0],"array")||(b=a.parsePathString(b)),!b||!b.length)return[["M",0,0]];var g,h=[],i=0,j=0,k=0,l=0,m=0;"M"==b[0][0]&&(i=+b[0][1],j=+b[0][2],k=i,l=j,m++,h[0]=["M",i,j]);for(var n,o,p=3==b.length&&"M"==b[0][0]&&"R"==b[1][0].toUpperCase()&&"Z"==b[2][0].toUpperCase(),q=m,r=b.length;r>q;q++){if(h.push(n=[]),o=b[q],g=o[0],g!=g.toUpperCase())switch(n[0]=g.toUpperCase(),n[0]){case"A":n[1]=o[1],n[2]=o[2],n[3]=o[3],n[4]=o[4],n[5]=o[5],n[6]=+o[6]+i,n[7]=+o[7]+j;break;case"V":n[1]=+o[1]+j;break;case"H":n[1]=+o[1]+i;break;case"R":for(var s=[i,j].concat(o.slice(1)),t=2,u=s.length;u>t;t++)s[t]=+s[t]+i,s[++t]=+s[t]+j;h.pop(),h=h.concat(G(s,p));break;case"O":h.pop(),s=x(i,j,o[1],o[2]),s.push(s[0]),h=h.concat(s);break;case"U":h.pop(),h=h.concat(x(i,j,o[1],o[2],o[3])),n=["U"].concat(h[h.length-1].slice(-2));break;case"M":k=+o[1]+i,l=+o[2]+j;default:for(t=1,u=o.length;u>t;t++)n[t]=+o[t]+(t%2?i:j)}else if("R"==g)s=[i,j].concat(o.slice(1)),h.pop(),h=h.concat(G(s,p)),n=["R"].concat(o.slice(-2));else if("O"==g)h.pop(),s=x(i,j,o[1],o[2]),s.push(s[0]),h=h.concat(s);else if("U"==g)h.pop(),h=h.concat(x(i,j,o[1],o[2],o[3])),n=["U"].concat(h[h.length-1].slice(-2));else for(var v=0,w=o.length;w>v;v++)n[v]=o[v];if(g=g.toUpperCase(),"O"!=g)switch(n[0]){case"Z":i=+k,j=+l;break;case"H":i=n[1];break;case"V":j=n[1];break;case"M":k=n[n.length-2],l=n[n.length-1];default:i=n[n.length-2],j=n[n.length-1]}}return h.toString=e,d.abs=f(h),h}function A(a,b,c,d){return[a,b,c,d,c,d]}function B(a,b,c,d,e,f){var g=1/3,h=2/3;return[g*a+h*c,g*b+h*d,g*e+h*c,g*f+h*d,e,f]}function C(b,c,d,e,f,g,h,i,j,k){var l,m=120*O/180,n=O/180*(+f||0),o=[],p=a._.cacher(function(a,b,c){var d=a*N.cos(c)-b*N.sin(c),e=a*N.sin(c)+b*N.cos(c);return{x:d,y:e}});if(k)y=k[0],z=k[1],w=k[2],x=k[3];else{l=p(b,c,-n),b=l.x,c=l.y,l=p(i,j,-n),i=l.x,j=l.y;var q=(N.cos(O/180*f),N.sin(O/180*f),(b-i)/2),r=(c-j)/2,s=q*q/(d*d)+r*r/(e*e);s>1&&(s=N.sqrt(s),d=s*d,e=s*e);var t=d*d,u=e*e,v=(g==h?-1:1)*N.sqrt(S((t*u-t*r*r-u*q*q)/(t*r*r+u*q*q))),w=v*d*r/e+(b+i)/2,x=v*-e*q/d+(c+j)/2,y=N.asin(((c-x)/e).toFixed(9)),z=N.asin(((j-x)/e).toFixed(9));y=w>b?O-y:y,z=w>i?O-z:z,0>y&&(y=2*O+y),0>z&&(z=2*O+z),h&&y>z&&(y-=2*O),!h&&z>y&&(z-=2*O)}var A=z-y;if(S(A)>m){var B=z,D=i,E=j;z=y+m*(h&&z>y?1:-1),i=w+d*N.cos(z),j=x+e*N.sin(z),o=C(i,j,d,e,f,0,h,D,E,[z,B,w,x])}A=z-y;var F=N.cos(y),G=N.sin(y),H=N.cos(z),I=N.sin(z),J=N.tan(A/4),K=4/3*d*J,L=4/3*e*J,M=[b,c],P=[b+K*G,c-L*F],Q=[i+K*I,j-L*H],R=[i,j];if(P[0]=2*M[0]-P[0],P[1]=2*M[1]-P[1],k)return[P,Q,R].concat(o);o=[P,Q,R].concat(o).join().split(",");for(var T=[],U=0,V=o.length;V>U;U++)T[U]=U%2?p(o[U-1],o[U],n).y:p(o[U],o[U+1],n).x;return T}function D(a,b,c,d,e,f,g,h){for(var i,j,k,l,m,n,o,p,q=[],r=[[],[]],s=0;2>s;++s)if(0==s?(j=6*a-12*c+6*e,i=-3*a+9*c-9*e+3*g,k=3*c-3*a):(j=6*b-12*d+6*f,i=-3*b+9*d-9*f+3*h,k=3*d-3*b),S(i)<1e-12){if(S(j)<1e-12)continue;l=-k/j,l>0&&1>l&&q.push(l)}else o=j*j-4*k*i,p=N.sqrt(o),0>o||(m=(-j+p)/(2*i),m>0&&1>m&&q.push(m),n=(-j-p)/(2*i),n>0&&1>n&&q.push(n));for(var t,u=q.length,v=u;u--;)l=q[u],t=1-l,r[0][u]=t*t*t*a+3*t*t*l*c+3*t*l*l*e+l*l*l*g,r[1][u]=t*t*t*b+3*t*t*l*d+3*t*l*l*f+l*l*l*h;return r[0][v]=a,r[1][v]=b,r[0][v+1]=g,r[1][v+1]=h,r[0].length=r[1].length=v+2,{min:{x:P.apply(0,r[0]),y:P.apply(0,r[1])},max:{x:Q.apply(0,r[0]),y:Q.apply(0,r[1])}}}function E(a,b){var d=!b&&c(a);if(!b&&d.curve)return f(d.curve);for(var e=z(a),g=b&&z(b),h={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},i={x:0,y:0,bx:0,by:0,X:0,Y:0,qx:null,qy:null},j=(function(a,b,c){var d,e;if(!a)return["C",b.x,b.y,b.x,b.y,b.x,b.y];switch(!(a[0]in{T:1,Q:1})&&(b.qx=b.qy=null),a[0]){case"M":b.X=a[1],b.Y=a[2];break;case"A":a=["C"].concat(C.apply(0,[b.x,b.y].concat(a.slice(1))));break;case"S":"C"==c||"S"==c?(d=2*b.x-b.bx,e=2*b.y-b.by):(d=b.x,e=b.y),a=["C",d,e].concat(a.slice(1));break;case"T":"Q"==c||"T"==c?(b.qx=2*b.x-b.qx,b.qy=2*b.y-b.qy):(b.qx=b.x,b.qy=b.y),a=["C"].concat(B(b.x,b.y,b.qx,b.qy,a[1],a[2]));break;case"Q":b.qx=a[1],b.qy=a[2],a=["C"].concat(B(b.x,b.y,a[1],a[2],a[3],a[4]));break;case"L":a=["C"].concat(A(b.x,b.y,a[1],a[2]));break;case"H":a=["C"].concat(A(b.x,b.y,a[1],b.y));break;case"V":a=["C"].concat(A(b.x,b.y,b.x,a[1]));break;case"Z":a=["C"].concat(A(b.x,b.y,b.X,b.Y))}return a}),k=function(a,b){if(a[b].length>7){a[b].shift();for(var c=a[b];c.length;)m[b]="A",g&&(n[b]="A"),a.splice(b++,0,["C"].concat(c.splice(0,6)));a.splice(b,1),r=Q(e.length,g&&g.length||0)}},l=function(a,b,c,d,f){a&&b&&"M"==a[f][0]&&"M"!=b[f][0]&&(b.splice(f,0,["M",d.x,d.y]),c.bx=0,c.by=0,c.x=a[f][1],c.y=a[f][2],r=Q(e.length,g&&g.length||0))},m=[],n=[],o="",p="",q=0,r=Q(e.length,g&&g.length||0);r>q;q++){e[q]&&(o=e[q][0]),"C"!=o&&(m[q]=o,q&&(p=m[q-1])),e[q]=j(e[q],h,p),"A"!=m[q]&&"C"==o&&(m[q]="C"),k(e,q),g&&(g[q]&&(o=g[q][0]),"C"!=o&&(n[q]=o,q&&(p=n[q-1])),g[q]=j(g[q],i,p),"A"!=n[q]&&"C"==o&&(n[q]="C"),k(g,q)),l(e,g,h,i,q),l(g,e,i,h,q);var s=e[q],t=g&&g[q],u=s.length,v=g&&t.length;h.x=s[u-2],h.y=s[u-1],h.bx=M(s[u-4])||h.x,h.by=M(s[u-3])||h.y,i.bx=g&&(M(t[v-4])||i.x),i.by=g&&(M(t[v-3])||i.y),i.x=g&&t[v-2],i.y=g&&t[v-1]}return g||(d.curve=f(e)),g?[e,g]:e}function F(a,b){if(!b)return a;var c,d,e,f,g,h,i;for(a=E(a),e=0,g=a.length;g>e;e++)for(i=a[e],f=1,h=i.length;h>f;f+=2)c=b.x(i[f],i[f+1]),d=b.y(i[f],i[f+1]),i[f]=c,i[f+1]=d;return a}function G(a,b){for(var c=[],d=0,e=a.length;e-2*!b>d;d+=2){var f=[{x:+a[d-2],y:+a[d-1]},{x:+a[d],y:+a[d+1]},{x:+a[d+2],y:+a[d+3]},{x:+a[d+4],y:+a[d+5]}];b?d?e-4==d?f[3]={x:+a[0],y:+a[1]}:e-2==d&&(f[2]={x:+a[0],y:+a[1]},f[3]={x:+a[2],y:+a[3]}):f[0]={x:+a[e-2],y:+a[e-1]}:e-4==d?f[3]=f[2]:d||(f[0]={x:+a[d],y:+a[d+1]}),c.push(["C",(-f[0].x+6*f[1].x+f[2].x)/6,(-f[0].y+6*f[1].y+f[2].y)/6,(f[1].x+6*f[2].x-f[3].x)/6,(f[1].y+6*f[2].y-f[3].y)/6,f[2].x,f[2].y])}return c}var H=b.prototype,I=a.is,J=a._.clone,K="hasOwnProperty",L=/,?([a-z]),?/gi,M=parseFloat,N=Math,O=N.PI,P=N.min,Q=N.max,R=N.pow,S=N.abs,T=h(1),U=h(),V=h(0,1),W=a._unit2px,X={path:function(a){return a.attr("path")},circle:function(a){var b=W(a);return x(b.cx,b.cy,b.r)},ellipse:function(a){var b=W(a);return x(b.cx||0,b.cy||0,b.rx,b.ry)},rect:function(a){var b=W(a);return w(b.x||0,b.y||0,b.width,b.height,b.rx,b.ry)},image:function(a){var b=W(a);return w(b.x||0,b.y||0,b.width,b.height)},line:function(a){return"M"+[a.attr("x1")||0,a.attr("y1")||0,a.attr("x2"),a.attr("y2")]},polyline:function(a){return"M"+a.attr("points")},polygon:function(a){return"M"+a.attr("points")+"z"},deflt:function(a){var b=a.node.getBBox();return w(b.x,b.y,b.width,b.height)}};a.path=c,a.path.getTotalLength=T,a.path.getPointAtLength=U,a.path.getSubpath=function(a,b,c){if(this.getTotalLength(a)-c<1e-6)return V(a,b).end;var d=V(a,c,1);return b?V(d,b).end:d},H.getTotalLength=function(){return this.node.getTotalLength?this.node.getTotalLength():void 0},H.getPointAtLength=function(a){return U(this.attr("d"),a)},H.getSubpath=function(b,c){return a.path.getSubpath(this.attr("d"),b,c)},a._.box=d,a.path.findDotsAtSegment=i,a.path.bezierBBox=j,a.path.isPointInsideBBox=k,a.closest=function(b,c,e,f){for(var g=100,h=d(b-g/2,c-g/2,g,g),i=[],j=e[0].hasOwnProperty("x")?function(a){return{x:e[a].x,y:e[a].y}}:function(a){return{x:e[a],y:f[a]}},l=0;1e6>=g&&!l;){for(var m=0,n=e.length;n>m;m++){var o=j(m);if(k(h,o.x,o.y)){l++,i.push(o);break}}l||(g*=2,h=d(b-g/2,c-g/2,g,g))}if(1e6!=g){var p,q=1/0;for(m=0,n=i.length;n>m;m++){var r=a.len(b,c,i[m].x,i[m].y);q>r&&(q=r,i[m].len=r,p=i[m])}return p}},a.path.isBBoxIntersect=l,a.path.intersection=r,a.path.intersectionNumber=s,a.path.isPointInside=u,a.path.getBBox=v,a.path.get=X,a.path.toRelative=y,a.path.toAbsolute=z,a.path.toCubic=E,a.path.map=F,a.path.toString=e,a.path.clone=f}),d.plugin(function(a){var d=Math.max,e=Math.min,f=function(a){if(this.items=[],this.bindings={},this.length=0,this.type="set",a)for(var b=0,c=a.length;c>b;b++)a[b]&&(this[this.items.length]=this.items[this.items.length]=a[b],this.length++)},g=f.prototype;g.push=function(){for(var a,b,c=0,d=arguments.length;d>c;c++)a=arguments[c],a&&(b=this.items.length,this[b]=this.items[b]=a,this.length++);return this},g.pop=function(){return this.length&&delete this[this.length--],this.items.pop()},g.forEach=function(a,b){for(var c=0,d=this.items.length;d>c;c++)if(a.call(b,this.items[c],c)===!1)return this;return this},g.animate=function(d,e,f,g){"function"!=typeof f||f.length||(g=f,f=c.linear),d instanceof a._.Animation&&(g=d.callback,f=d.easing,e=f.dur,d=d.attr);var h=arguments;if(a.is(d,"array")&&a.is(h[h.length-1],"array"))var i=!0;var j,k=function(){j?this.b=j:j=this.b},l=0,m=this,n=g&&function(){++l==m.length&&g.call(this)
    };return this.forEach(function(a,c){b.once("snap.animcreated."+a.id,k),i?h[c]&&a.animate.apply(a,h[c]):a.animate(d,e,f,n)})},g.remove=function(){for(;this.length;)this.pop().remove();return this},g.bind=function(a,b,c){var d={};if("function"==typeof b)this.bindings[a]=b;else{var e=c||a;this.bindings[a]=function(a){d[e]=a,b.attr(d)}}return this},g.attr=function(a){var b={};for(var c in a)this.bindings[c]?this.bindings[c](a[c]):b[c]=a[c];for(var d=0,e=this.items.length;e>d;d++)this.items[d].attr(b);return this},g.clear=function(){for(;this.length;)this.pop()},g.splice=function(a,b){a=0>a?d(this.length+a,0):a,b=d(0,e(this.length-a,b));var c,g=[],h=[],i=[];for(c=2;c<arguments.length;c++)i.push(arguments[c]);for(c=0;b>c;c++)h.push(this[a+c]);for(;c<this.length-a;c++)g.push(this[a+c]);var j=i.length;for(c=0;c<j+g.length;c++)this.items[a+c]=this[a+c]=j>c?i[c]:g[c-j];for(c=this.items.length=this.length-=b-j;this[c];)delete this[c++];return new f(h)},g.exclude=function(a){for(var b=0,c=this.length;c>b;b++)if(this[b]==a)return this.splice(b,1),!0;return!1},g.insertAfter=function(a){for(var b=this.items.length;b--;)this.items[b].insertAfter(a);return this},g.getBBox=function(){for(var a=[],b=[],c=[],f=[],g=this.items.length;g--;)if(!this.items[g].removed){var h=this.items[g].getBBox();a.push(h.x),b.push(h.y),c.push(h.x+h.width),f.push(h.y+h.height)}return a=e.apply(0,a),b=e.apply(0,b),c=d.apply(0,c),f=d.apply(0,f),{x:a,y:b,x2:c,y2:f,width:c-a,height:f-b,cx:a+(c-a)/2,cy:b+(f-b)/2}},g.clone=function(a){a=new f;for(var b=0,c=this.items.length;c>b;b++)a.push(this.items[b].clone());return a},g.toString=function(){return"Snap?s set"},g.type="set",a.Set=f,a.set=function(){var a=new f;return arguments.length&&a.push.apply(a,Array.prototype.slice.call(arguments,0)),a}}),d.plugin(function(a,c){function d(a){var b=a[0];switch(b.toLowerCase()){case"t":return[b,0,0];case"m":return[b,1,0,0,1,0,0];case"r":return 4==a.length?[b,0,a[2],a[3]]:[b,0];case"s":return 5==a.length?[b,1,1,a[3],a[4]]:3==a.length?[b,1,1]:[b,1]}}function e(b,c,e){c=p(c).replace(/\.{3}|\u2026/g,b),b=a.parseTransformString(b)||[],c=a.parseTransformString(c)||[];for(var f,g,h,i,l=Math.max(b.length,c.length),m=[],n=[],o=0;l>o;o++){if(h=b[o]||d(c[o]),i=c[o]||d(h),h[0]!=i[0]||"r"==h[0].toLowerCase()&&(h[2]!=i[2]||h[3]!=i[3])||"s"==h[0].toLowerCase()&&(h[3]!=i[3]||h[4]!=i[4])){b=a._.transform2matrix(b,e()),c=a._.transform2matrix(c,e()),m=[["m",b.a,b.b,b.c,b.d,b.e,b.f]],n=[["m",c.a,c.b,c.c,c.d,c.e,c.f]];break}for(m[o]=[],n[o]=[],f=0,g=Math.max(h.length,i.length);g>f;f++)f in h&&(m[o][f]=h[f]),f in i&&(n[o][f]=i[f])}return{from:k(m),to:k(n),f:j(m)}}function f(a){return a}function g(a){return function(b){return+b.toFixed(3)+a}}function h(a){return a.join(" ")}function i(b){return a.rgb(b[0],b[1],b[2])}function j(a){var b,c,d,e,f,g,h=0,i=[];for(b=0,c=a.length;c>b;b++){for(f="[",g=['"'+a[b][0]+'"'],d=1,e=a[b].length;e>d;d++)g[d]="val["+h++ +"]";f+=g+"]",i[b]=f}return Function("val","return Snap.path.toString.call(["+i+"])")}function k(a){for(var b=[],c=0,d=a.length;d>c;c++)for(var e=1,f=a[c].length;f>e;e++)b.push(a[c][e]);return b}function l(a){return isFinite(parseFloat(a))}function m(b,c){return a.is(b,"array")&&a.is(c,"array")?b.toString()==c.toString():!1}var n={},o=/[a-z]+$/i,p=String;n.stroke=n.fill="colour",c.prototype.equal=function(a,c){return b("snap.util.equal",this,a,c).firstDefined()},b.on("snap.util.equal",function(b,c){var d,q,r=p(this.attr(b)||""),s=this;if(l(r)&&l(c))return{from:parseFloat(r),to:parseFloat(c),f:f};if("colour"==n[b])return d=a.color(r),q=a.color(c),{from:[d.r,d.g,d.b,d.opacity],to:[q.r,q.g,q.b,q.opacity],f:i};if("viewBox"==b)return d=this.attr(b).vb.split(" ").map(Number),q=c.split(" ").map(Number),{from:d,to:q,f:h};if("transform"==b||"gradientTransform"==b||"patternTransform"==b)return c instanceof a.Matrix&&(c=c.toTransformString()),a._.rgTransform.test(c)||(c=a._.svgTransform2string(c)),e(r,c,function(){return s.getBBox(1)});if("d"==b||"path"==b)return d=a.path.toCubic(r,c),{from:k(d[0]),to:k(d[1]),f:j(d[0])};if("points"==b)return d=p(r).split(a._.separator),q=p(c).split(a._.separator),{from:d,to:q,f:function(a){return a}};var t=r.match(o),u=p(c).match(o);return t&&m(t,u)?{from:parseFloat(r),to:parseFloat(c),f:g(t)}:{from:this.asPX(b),to:this.asPX(b,c),f:f}})}),d.plugin(function(a,c,d,e){for(var f=c.prototype,g="hasOwnProperty",h=("createTouch"in e.doc),i=["click","dblclick","mousedown","mousemove","mouseout","mouseover","mouseup","touchstart","touchmove","touchend","touchcancel"],j={mousedown:"touchstart",mousemove:"touchmove",mouseup:"touchend"},k=(function(a,b){var c="y"==a?"scrollTop":"scrollLeft",d=b&&b.node?b.node.ownerDocument:e.doc;return d[c in d.documentElement?"documentElement":"body"][c]}),l=function(){return this.originalEvent.preventDefault()},m=function(){return this.originalEvent.stopPropagation()},n=function(a,b,c,d){var e=h&&j[b]?j[b]:b,f=function(e){var f=k("y",d),i=k("x",d);if(h&&j[g](b))for(var n=0,o=e.targetTouches&&e.targetTouches.length;o>n;n++)if(e.targetTouches[n].target==a||a.contains(e.targetTouches[n].target)){var p=e;e=e.targetTouches[n],e.originalEvent=p,e.preventDefault=l,e.stopPropagation=m;break}var q=e.clientX+i,r=e.clientY+f;return c.call(d,e,q,r)};return b!==e&&a.addEventListener(b,f,!1),a.addEventListener(e,f,!1),function(){return b!==e&&a.removeEventListener(b,f,!1),a.removeEventListener(e,f,!1),!0}},o=[],p=function(a){for(var c,d=a.clientX,e=a.clientY,f=k("y"),g=k("x"),i=o.length;i--;){if(c=o[i],h){for(var j,l=a.touches&&a.touches.length;l--;)if(j=a.touches[l],j.identifier==c.el._drag.id||c.el.node.contains(j.target)){d=j.clientX,e=j.clientY,(a.originalEvent?a.originalEvent:a).preventDefault();break}}else a.preventDefault();{var m=c.el.node;m.nextSibling,m.parentNode,m.style.display}d+=g,e+=f,b("snap.drag.move."+c.el.id,c.move_scope||c.el,d-c.el._drag.x,e-c.el._drag.y,d,e,a)}},q=function(c){a.unmousemove(p).unmouseup(q);for(var d,e=o.length;e--;)d=o[e],d.el._drag={},b("snap.drag.end."+d.el.id,d.end_scope||d.start_scope||d.move_scope||d.el,c),b.off("snap.drag.*."+d.el.id);o=[]},r=i.length;r--;)!function(b){a[b]=f[b]=function(c,d){if(a.is(c,"function"))this.events=this.events||[],this.events.push({name:b,f:c,unbind:n(this.node||document,b,c,d||this)});else for(var e=0,f=this.events.length;f>e;e++)if(this.events[e].name==b)try{this.events[e].f.call(this)}catch(g){}return this},a["un"+b]=f["un"+b]=function(a){for(var c=this.events||[],d=c.length;d--;)if(c[d].name==b&&(c[d].f==a||!a))return c[d].unbind(),c.splice(d,1),!c.length&&delete this.events,this;return this}}(i[r]);f.hover=function(a,b,c,d){return this.mouseover(a,c).mouseout(b,d||c)},f.unhover=function(a,b){return this.unmouseover(a).unmouseout(b)};var s=[];f.drag=function(c,d,e,f,g,h){function i(i,j,l){(i.originalEvent||i).preventDefault(),k._drag.x=j,k._drag.y=l,k._drag.id=i.identifier,!o.length&&a.mousemove(p).mouseup(q),o.push({el:k,move_scope:f,start_scope:g,end_scope:h}),d&&b.on("snap.drag.start."+k.id,d),c&&b.on("snap.drag.move."+k.id,c),e&&b.on("snap.drag.end."+k.id,e),b("snap.drag.start."+k.id,g||f||k,j,l,i)}function j(a,c,d){b("snap.draginit."+k.id,k,a,c,d)}var k=this;if(!arguments.length){var l;return k.drag(function(a,b){this.attr({transform:l+(l?"T":"t")+[a,b]})},function(){l=this.transform().local})}return b.on("snap.draginit."+k.id,i),k._drag={},s.push({el:k,start:i,init:j}),k.mousedown(j),k},f.undrag=function(){for(var c=s.length;c--;)s[c].el==this&&(this.unmousedown(s[c].init),s.splice(c,1),b.unbind("snap.drag.*."+this.id),b.unbind("snap.draginit."+this.id));return!s.length&&a.unmousemove(p).unmouseup(q),this}}),d.plugin(function(a,c,d){var e=(c.prototype,d.prototype),f=/^\s*url\((.+)\)/,g=String,h=a._.$;a.filter={},e.filter=function(b){var d=this;"svg"!=d.type&&(d=d.paper);var e=a.parse(g(b)),f=a._.id(),i=(d.node.offsetWidth,d.node.offsetHeight,h("filter"));return h(i,{id:f,filterUnits:"userSpaceOnUse"}),i.appendChild(e.node),d.defs.appendChild(i),new c(i)},b.on("snap.util.getattr.filter",function(){b.stop();var c=h(this.node,"filter");if(c){var d=g(c).match(f);return d&&a.select(d[1])}}),b.on("snap.util.attr.filter",function(d){if(d instanceof c&&"filter"==d.type){b.stop();var e=d.node.id;e||(h(d.node,{id:d.id}),e=d.id),h(this.node,{filter:a.url(e)})}d&&"none"!=d||(b.stop(),this.node.removeAttribute("filter"))}),a.filter.blur=function(b,c){null==b&&(b=2);var d=null==c?b:[b,c];return a.format('<feGaussianBlur stdDeviation="{def}"/>',{def:d})},a.filter.blur.toString=function(){return this()},a.filter.shadow=function(b,c,d,e,f){return"string"==typeof d&&(e=d,f=e,d=4),"string"!=typeof e&&(f=e,e="#000"),e=e||"#000",null==d&&(d=4),null==f&&(f=1),null==b&&(b=0,c=2),null==c&&(c=b),e=a.color(e),a.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>',{color:e,dx:b,dy:c,blur:d,opacity:f})},a.filter.shadow.toString=function(){return this()},a.filter.grayscale=function(b){return null==b&&(b=1),a.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>',{a:.2126+.7874*(1-b),b:.7152-.7152*(1-b),c:.0722-.0722*(1-b),d:.2126-.2126*(1-b),e:.7152+.2848*(1-b),f:.0722-.0722*(1-b),g:.2126-.2126*(1-b),h:.0722+.9278*(1-b)})},a.filter.grayscale.toString=function(){return this()},a.filter.sepia=function(b){return null==b&&(b=1),a.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>',{a:.393+.607*(1-b),b:.769-.769*(1-b),c:.189-.189*(1-b),d:.349-.349*(1-b),e:.686+.314*(1-b),f:.168-.168*(1-b),g:.272-.272*(1-b),h:.534-.534*(1-b),i:.131+.869*(1-b)})},a.filter.sepia.toString=function(){return this()},a.filter.saturate=function(b){return null==b&&(b=1),a.format('<feColorMatrix type="saturate" values="{amount}"/>',{amount:1-b})},a.filter.saturate.toString=function(){return this()},a.filter.hueRotate=function(b){return b=b||0,a.format('<feColorMatrix type="hueRotate" values="{angle}"/>',{angle:b})},a.filter.hueRotate.toString=function(){return this()},a.filter.invert=function(b){return null==b&&(b=1),a.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>',{amount:b,amount2:1-b})},a.filter.invert.toString=function(){return this()},a.filter.brightness=function(b){return null==b&&(b=1),a.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>',{amount:b})},a.filter.brightness.toString=function(){return this()},a.filter.contrast=function(b){return null==b&&(b=1),a.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>',{amount:b,amount2:.5-b/2})},a.filter.contrast.toString=function(){return this()}}),d.plugin(function(a,b){var c=a._.box,d=a.is,e=/^[^a-z]*([tbmlrc])/i,f=function(){return"T"+this.dx+","+this.dy};b.prototype.getAlign=function(a,b){null==b&&d(a,"string")&&(b=a,a=null),a=a||this.paper;var g=a.getBBox?a.getBBox():c(a),h=this.getBBox(),i={};switch(b=b&&b.match(e),b=b?b[1].toLowerCase():"c"){case"t":i.dx=0,i.dy=g.y-h.y;break;case"b":i.dx=0,i.dy=g.y2-h.y2;break;case"m":i.dx=0,i.dy=g.cy-h.cy;break;case"l":i.dx=g.x-h.x,i.dy=0;break;case"r":i.dx=g.x2-h.x2,i.dy=0;break;default:i.dx=g.cx-h.cx,i.dy=0}return i.toString=f,i},b.prototype.align=function(a,b){return this.transform("..."+this.getAlign(a,b))}}),d});
